'use strict';

var jsxRuntime = require('react/jsx-runtime');
var reactNative = require('react-native');
var React = require('react');
var freeBrandsSvgIcons = require('@fortawesome/free-brands-svg-icons');
var freeRegularSvgIcons = require('@fortawesome/free-regular-svg-icons');
var freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var merge = require('lodash.merge');
var importedInstance = require('i18next');
var reactNativeWebHover = require('react-native-web-hover');
var reactCsv = require('react-csv');
var moment = require('moment');
var picker = require('@react-native-picker/picker');
var reactNativeCalendario = require('react-native-calendario');
var reactNativeSvg = require('react-native-svg');
var PropTypes = require('prop-types');
var qrcode_react = require('qrcode.react');
var debounce$1 = require('lodash.debounce');

function _interopNamespaceDefault(e) {
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const colors = {
    primary: { background: '#de7008', text: 'white' },
    secondary: { background: '#eee', text: 'black', border: '#ccc' },
    accent: { background: '#075AE4', text: 'white' },
    light: { background: 'linen', text: '#333' },
    dark: { background: '#fd5800', text: 'white' },
    success: { background: '#59b259', text: 'white' },
    danger: { background: '#d62828', text: 'white' },
    info: { background: 'blue', text: 'white' },
    warning: { background: 'yellow', text: 'black' },
    link: { background: 'transparent', text: '#075AE4' },
};
const fonts = {
    body: { fontSize: 14, fontFamily: 'Segoe UI", Roboto, Helvetica, Arial, sans-serif', lineHeight: 'normal', color: 'black', fontWeight: 'normal' },
    title: { fontSize: 34, fontFamily: 'Segoe UI", Roboto, Helvetica, Arial, sans-serif', lineHeight: 'normal', color: 'black', fontWeight: 'normal' },
};
const jwtRole = "";
const urls = {};

const OWCContext = React__namespace.createContext({
    alerts: {
        items: [],
        create: (_alert) => { },
        createDefaultError: (_error) => { },
        delete: (_id) => { },
    },
    setColors: (_colors) => { },
    colors,
    fonts,
    setFonts: (_fonts) => { },
    navigate: (_route, _params) => { },
    jwtRole: undefined,
    setJwtRole: {},
    urls: undefined,
    setUrls: {}
});

const TextContext = React__namespace.createContext({});

const Text = ({ uppercase = false, bold, italic = false, strikethrough = false, lineHeight, textAlign, color, fontSize, title, children, style = {}, ...props }) => {
    const context = React__namespace.useContext(OWCContext);
    const textContext = React__namespace.useContext(TextContext);
    fontSize = fontSize || textContext?.fontSize || context?.fonts?.body?.fontSize || 12;
    return (jsxRuntime.jsx(reactNative.Text, { ...props, accessibilityLabel: title, style: [
            context.fonts.body,
            // fontWeight,
            !!fontSize && { fontSize },
            !!uppercase && styles$F.uppercase,
            !!italic && styles$F.italic,
            !!bold && styles$F.bold,
            strikethrough && styles$F.strikethrough,
            !!color && { color },
            !!lineHeight && { lineHeight },
            !!textAlign && { textAlign },
            style
        ], children: children }));
};
const styles$F = reactNative.StyleSheet.create({
    uppercase: {
        textTransform: 'uppercase',
    },
    italic: {
        fontStyle: 'italic',
    },
    strikethrough: {
        textDecorationLine: 'line-through',
    },
    bold: {
        fontWeight: 'bold',
    }
});

const COLORS = {
    success: { color: '#155b62', backgroundColor: '#d4edda' },
    error: { color: '#722162', backgroundColor: '#f8d7da' },
    warning: { color: '#a3640a', backgroundColor: '#fff3cd' },
    info: { color: '#004094', backgroundColor: '#cce5ff' },
};
const Alert = ({ type = 'error', text, onClose, containerStyle, textStyle, children }) => {
    const backgroundColor = COLORS[type].backgroundColor;
    const color = COLORS[type].color;
    text = text?.replace(/<br>/g, '\n');
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$E.container, containerStyle, { backgroundColor, borderColor: color, gap: 15 }], children: [!!text && jsxRuntime.jsx(Text, { style: [styles$E.text, textStyle, { color }], children: text }), children, !!onClose && (jsxRuntime.jsx(reactNative.View, { style: styles$E.closeContainer, children: jsxRuntime.jsx(reactNative.TouchableWithoutFeedback, { onPress: onClose, children: jsxRuntime.jsx(Text, { style: [styles$E.closeButton, { color }], children: "\u00D7" }) }) }))] }));
};
const styles$E = reactNative.StyleSheet.create({
    container: {
        width: '100%',
        backgroundColor: 'lightpink',
        borderWidth: 1,
        borderColor: 'crimson',
        padding: 15,
        marginBottom: 15,
    },
    closeContainer: {
        position: 'absolute',
        top: 5,
        right: 10,
    },
    closeButton: {
        color: 'crimson',
        cursor: 'pointer',
        fontSize: 28,
    },
    text: {
        color: 'crimson',
    },
});

/**
 * Alert manager component
 */
const AlertManager = () => {
    const context = React__namespace.useContext(OWCContext);
    /**
     * empty
     */
    if (!context.alerts?.items?.length) {
        return null;
    }
    /**
     * render
     */
    return (jsxRuntime.jsx(reactNative.View, { style: [styles$D.container, { position: reactNative.Platform.OS === 'web' ? 'fixed' : 'absolute' }], children: context.alerts?.items.map((item) => (jsxRuntime.jsx(Alert, { onClose: () => context.alerts?.delete(item.id), text: item.text, type: item.type }, item.id))) }));
};
/**
 * styles
 */
const styles$D = reactNative.StyleSheet.create({
    container: {
        top: 0,
        right: 0,
        // padding: 15,
        marginTop: 15,
        marginRight: 15,
        zIndex: 99999,
        maxWidth: 550,
        width: '100%',
    },
});

const Loader = ({ size = 'large', color, margin = 20 }) => (jsxRuntime.jsx(reactNative.View, { style: { margin: margin }, children: jsxRuntime.jsx(reactNative.ActivityIndicator, { size: size, color: color }) }));

const BackgroundLoader = () => {
    return (jsxRuntime.jsx(reactNative.View, { style: styles$C.container, children: jsxRuntime.jsx(reactNative.View, { style: styles$C.background, children: jsxRuntime.jsx(Loader, {}) }) }));
};
const styles$C = reactNative.StyleSheet.create({
    container: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        paddingTop: 30,
        alignItems: 'center',
        // justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    background: {
        backgroundColor: 'white',
        borderRadius: 5,
        padding: 10,
    },
});

const styles$B = reactNative.StyleSheet.create({
    container: {
        width: 150,
        height: 150,
        margin: 5,
        cursor: "pointer",
    },
    blur: {
        cursor: "default",
        opacity: 0.5,
    },
    image: {
        width: '100%',
        flex: 1,
    },
});

const BigIcon = ({ onPress = () => { }, blur = false, src, containerStyle }) => {
    return (jsxRuntime.jsx(reactNative.TouchableOpacity, { onPress: !blur ? onPress : undefined, style: [styles$B.container, blur && styles$B.blur, containerStyle], children: jsxRuntime.jsx(reactNative.Image, { source: src, style: styles$B.image }) }));
};

var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADukAAA7pAQ4zQhwAAAAHdElNRQfkCxQIMAwxSSmNAAACFElEQVRo3u3VzWoTURyG8effEyxq/UI3LlyaduUNuOncgdcgeBsyCIKIoIiiTibxDtQrkLMRFBSpKFXUnZ1J0k8ltlWbxkWn6cQk853ExXl3OUl4fhzIBMzMzMzMzMwmPLl6Tk5NLt9ZL3GRy5yeUH+NWmnqSecCVzgzkfzzqadqvi0vmGGOo2POr1ITmy2lmd/hJUfGTFihxjXZtFGgsf7wisNjJCxT47q0bEBBQHjNNHPMjCVf5Yb8sGEfABrrN2+YZnbkhCZVbsp3O3ip9s811i/ecmjEhCYut2TD7h6og/c01jYLlJjl2IjyDVxuy7odOlLh9zXWNu9QIyI0cLkja3YnfKh6P6OxtniPolw4oY7LXVntzfcBglv4gBR8C3Uq3JOVf/MDAMEtLCKUOV5Q3sflviz35wcCQGNtsggFEXwqPJDmoPwQQED4WAjBp8JDaQzODwUEhE/s5iT4ODhSH5aPAIDG+snnXASPCo74w/ORgNwEDwc3Oh8DCAhfaGcgeDhUxYvOxwJAY7UyEPbyS3H5BICA8JUdznOi6HwiQJfQTkjweMTjZPmEgFSEvfy3ZPnEgMSEJZw0+RSARAQvbT4VIJaQ8vIzACIJmfKpASFC73Mhw+VnBISeCweEFL/7AgB9T8cc+YyALmGXMq08eZBsXwOwpXOWSwjP4v9yRgIAWzgJbGTPm5mZmZmZmf0H+wu0VPPD3BJg2gAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMC0xMS0yMFQwODo0ODoxMiswMDowMMgdvIcAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjAtMTEtMjBUMDg6NDg6MTIrMDA6MDC5QAQ7AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg==";

const Button = React__namespace.forwardRef(({ type = 'primary', fontWeight = 400, disabled = false, containerStyle = {}, fontSize, backgroundColor, marginBottom = 15, marginRight = 0, borderRadius = 5, color, shadow = false, loading = false, text = '', children = null, onPress = () => { }, iconDown = false, justifyContent = 'center', textTransform = 'none', active = false, colorActive, loadingColor, fullSize, flexDirection = 'row', borderColor }, ref) => {
    const context = React__namespace.useContext(OWCContext);
    const [processing, setProcessing] = React__namespace.useState(false);
    const [colorBox, setColorBox] = React__namespace.useState(backgroundColor || context?.colors[type]?.background);
    const [colorText, setColorText] = React__namespace.useState(color || context?.colors[type]?.text);
    const [colorBorder, setColorBorder] = React__namespace.useState(borderColor || context?.colors[type]?.border || colorBox);
    loadingColor = loadingColor || colorText;
    React__namespace.useImperativeHandle(ref, () => ({
        setColorBox,
        setColorText,
        setColorBorder,
        setLoading: setProcessing,
    }));
    React__namespace.useEffect(() => {
        setColorBox(backgroundColor || context?.colors[type]?.background);
        setColorText(color || context?.colors[type]?.text);
        setColorBorder(borderColor || context?.colors[type]?.border || colorBox);
    }, [backgroundColor, color, borderColor, type]);
    /**
     * handle press
     */
    const handlePress = React__namespace.useCallback(async () => {
        // start processing
        setProcessing(true);
        // resolve
        await Promise.resolve(onPress());
        // stop processing
        setProcessing(false);
    }, [onPress]);
    /**
     * render
     */
    return (jsxRuntime.jsx(reactNative.TouchableOpacity, { onPress: !disabled && !(loading || processing) ? handlePress : undefined, style: [
            styles$A.container,
            shadow && styles$A.shadow,
            type === 'link' && fullSize !== undefined && styles$A.containerLink,
            type !== 'link' && { minHeight: 30, minWidth: 150 },
            { backgroundColor: colorBox, borderWidth: 1, borderColor: colorBorder, borderRadius, marginBottom, marginRight },
            containerStyle,
            fullSize && { width: '100%' },
            disabled && styles$A.disabled
        ], children: loading || processing ? (jsxRuntime.jsx(reactNative.ActivityIndicator, { size: 'small', color: loadingColor })) : (jsxRuntime.jsxs(reactNative.View, { style: [styles$A.boxText, { justifyContent }], children: [jsxRuntime.jsxs(reactNative.View, { style: { flexDirection: flexDirection, maxWidth: "100%" }, children: [jsxRuntime.jsx(Text, { fontSize: fontSize, color: disabled ? '#ccc' : active ? colorActive : colorText, style: [styles$A.text, { textTransform, fontWeight: fontWeight }], children: text }), children] }), !!iconDown && (jsxRuntime.jsx(reactNative.View, { style: { margin: 4 }, children: jsxRuntime.jsx(reactNative.Image, { source: img$1, style: { width: 10, height: 10 } }) }))] })) }));
});
const styles$A = reactNative.StyleSheet.create({
    container: {
        width: 'max-content',
        maxWidth: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        // flex: 1,
        // borderRadius: 5,
        padding: 10,
    },
    containerLink: {
        width: undefined,
        flex: undefined,
        padding: 0,
    },
    boxText: {
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
    },
    shadow: {
        elevation: 5,
        shadowColor: '#000',
        shadowOffset: { width: 0.5, height: 0.5 },
        shadowOpacity: 0.5,
        shadowRadius: 3,
    },
    text: {
        // fontSize: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%',
    },
    disabled: {
        backgroundColor: '#eee',
        cursor: 'not-allowed',
    },
});

const ButtonTab = ({ text, onPress, active = false, containerStyle }) => {
    return (jsxRuntime.jsx(Button, { text: text, onPress: onPress, containerStyle: { flex: 1, borderColor: '#eee', ...containerStyle, borderWidth: active ? 1 : 0, borderBottomWidth: active ? 0 : 1 }, color: !active ? '#ccc' : undefined, type: 'link' }));
};

const Card = ({ children = null, padding, backgroundColor, borderColor, containerStyle, borderLeftWidth = 1 }) => {
    const context = React__namespace.useContext(OWCContext);
    const bgc = backgroundColor || context.colors.light.background || 'white';
    const bc = borderColor || context.colors.primary.background || '#eee';
    return (jsxRuntime.jsx(reactNative.View, { style: [styles$z.container, { padding, borderLeftWidth, backgroundColor: bgc, borderColor: bc }, containerStyle], children: children }));
};
const styles$z = reactNative.StyleSheet.create({
    container: {
        borderWidth: 1,
        marginBottom: 15,
        flexDirection: 'column',
        justifyContent: 'center',
    },
});

let styles$y = reactNative.StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
    },
    checkbox: {
        borderWidth: 1,
        borderColor: '#ccc',
        marginRight: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    label: {
        display: 'flex',
        // alignItems: 'center',
        // justifyContent: 'center',
        // textAlign: 'center',
        // textTransform: 'capitalize'
    },
    shadow: {
        shadowColor: "#000",
        shadowOffset: { width: 0.5, height: 0.5 },
        shadowOpacity: 0.5,
        elevation: 5,
        shadowRadius: 3,
    },
    textError: {
        //  fontSize: 12,
        paddingLeft: 10,
        color: 'crimson',
    },
    labelError: {
        color: 'crimson',
    },
});

const Checkbox = ({ borderRadius = 5, colorIcon, typeIcon = "✓", marginLeft = 0, marginBottom = 20, label = "", textTransform, defaultValue = false, onChange = () => { }, size = 18, shadow = true, disabled = false, value, containerStyle, labelStyle, error, children }) => {
    const context = React__namespace.useContext(OWCContext);
    const [currentValue, setCurrentValue] = React__namespace.useState(value !== undefined && value || defaultValue);
    const iconColor = colorIcon || context.colors.primary.background;
    /**
     * on prop value change
     */
    React__namespace.useEffect(() => {
        if (value !== undefined) {
            setCurrentValue(value);
        }
    }, [value]);
    /**
     * handle change
     */
    const handleChange = React__namespace.useCallback(() => {
        if (disabled) {
            return;
        }
        setCurrentValue(!currentValue);
        onChange(!currentValue);
    }, [disabled, currentValue, onChange, value]);
    /**
     *
     */
    return (jsxRuntime.jsxs(reactNative.View, { style: [{ marginBottom: marginBottom }, containerStyle], children: [jsxRuntime.jsxs(reactNative.View, { style: [styles$y.container, { marginLeft }], children: [jsxRuntime.jsx(reactNative.TouchableWithoutFeedback, { onPress: handleChange, style: shadow && styles$y.shadow, children: jsxRuntime.jsx(reactNative.View, { style: [styles$y.checkbox, { width: size, height: size, borderRadius }, { cursor: disabled ? 'default' : "pointer" }, { backgroundColor: disabled ? '#f2f2f2' : 'white' }], children: jsxRuntime.jsx(reactNative.View, { style: { flex: 1, alignItems: 'center', justifyContent: 'center' }, children: jsxRuntime.jsx(Text, { color: iconColor, fontSize: size, children: (value !== undefined && value || currentValue) && typeIcon }) }) }) }), children ?? (jsxRuntime.jsx(Text, { style: [
                            styles$y.label,
                            { textTransform, fontSize: size - 6 },
                            labelStyle,
                            error ? styles$y.labelError : undefined
                        ], children: label }))] }), jsxRuntime.jsx(Text, { style: [styles$y.textError], children: error })] }));
};

const CircleImage = ({ width = 140, height = 140, type = 'primary', borderColor, resizeMode = 'contain', backgroundColor = 'white', style, onPress, src = '', alt, borderRadius, borderWidth = 1 }) => {
    const context = React__namespace.useContext(OWCContext);
    borderColor = borderColor || context.colors[type].background;
    const fontSize = width / 100 * 35;
    /**
     * render image
     */
    const renderImage = React__namespace.useCallback(() => {
        // render alt
        if (!src?.length && !!alt) {
            return (jsxRuntime.jsx(reactNative.View, { style: [styles$x.container, { height, borderWidth, width, borderRadius: borderRadius ? borderRadius : width / 2, borderColor: context.colors[type].background, backgroundColor: context.colors[type].background }, style], children: jsxRuntime.jsx(reactNative.View, { style: { alignSelf: 'center', justifyContent: 'center', flex: 1 }, children: jsxRuntime.jsx(Text, { color: context.colors[type].text, marginBottom: 3, fontSize: fontSize, children: alt?.substring(0, 1) }) }) }));
        }
        // render image
        return (jsxRuntime.jsx(reactNative.View, { style: [styles$x.container, { width, height, borderRadius: borderRadius ? borderRadius : width / 2, borderColor, borderWidth }, style], children: jsxRuntime.jsx(reactNative.Image, { source: { uri: src }, style: [{ backgroundColor, resizeMode }, styles$x.image] }) }));
    }, [height, borderWidth, width, borderRadius, borderColor, backgroundColor, resizeMode, src, alt]);
    /**
     * render with touchable condition
     */
    const render = React__namespace.useCallback(() => {
        // without touchable
        if (!onPress) {
            return renderImage();
        }
        // with touchable
        return (jsxRuntime.jsx(reactNative.TouchableOpacity, { onPress: onPress, children: renderImage() }));
    }, [onPress, renderImage]);
    /**
     * render
     */
    return (render());
};
const styles$x = reactNative.StyleSheet.create({
    container: {
        overflow: 'hidden',
    },
    image: {
        width: '100%',
        height: '100%',
        alignItems: 'center',
        // resizeMode: 'contain'
    }
});

const Image = ({ url = "", containerStyle, height, width }) => {
    const [size, setSize] = React__namespace.useState({});
    React__namespace.useEffect(() => {
        if (!height || !width) { // auto size
            reactNative.Image.getSize(url, (width, height) => {
                setSize({ width: width, height: height });
            });
        }
        else {
            setSize({ width: width, height: height });
        }
    }, []);
    return (jsxRuntime.jsx(reactNative.View, { style: containerStyle, children: jsxRuntime.jsx(reactNative.Image, { source: { uri: url }, style: { width: size.width, height: size.height } }) }));
};

var img = "data:image/png;base64,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";

const resources = {
    'file-plus': freeSolidSvgIcons.faFileCirclePlus,
    coins: freeSolidSvgIcons.faCoins,
    medal: freeSolidSvgIcons.faMedal,
    graduation: freeSolidSvgIcons.faGraduationCap,
    setting: freeSolidSvgIcons.faCog,
    previewtime: freeSolidSvgIcons.faRedo,
    backtime: freeSolidSvgIcons.faUndo,
    ok: freeSolidSvgIcons.faCheckCircle,
    ko: freeSolidSvgIcons.faTimesCircle,
    add: freeSolidSvgIcons.faPlusCircle,
    edit: freeSolidSvgIcons.faPen,
    remove: freeSolidSvgIcons.faTrash,
    more: freeSolidSvgIcons.faChevronDown,
    less: freeSolidSvgIcons.faChevronUp,
    check: freeSolidSvgIcons.faCheck,
    times: freeSolidSvgIcons.faTimes,
    close: freeSolidSvgIcons.faTimes,
    exclamation: freeSolidSvgIcons.faExclamation,
    'exclamation-circle': freeSolidSvgIcons.faExclamationCircle,
    plus: freeSolidSvgIcons.faPlus,
    minus: freeSolidSvgIcons.faMinus,
    'arrow-up': freeSolidSvgIcons.faChevronUp,
    'arrow-down': freeSolidSvgIcons.faChevronDown,
    upload: freeSolidSvgIcons.faUpload,
    download: freeSolidSvgIcons.faDownload,
    list: freeSolidSvgIcons.faList,
    burger: freeSolidSvgIcons.faBars,
    user: freeSolidSvgIcons.faUser,
    at: freeSolidSvgIcons.faAt,
    question: freeSolidSvgIcons.faQuestion,
    'play-circle': freeSolidSvgIcons.faPlayCircle,
    eye: freeSolidSvgIcons.faEye,
    'eye-slash': freeSolidSvgIcons.faEyeSlash,
    'paper-plane': freeSolidSvgIcons.faPaperPlane,
    'info-circle': freeSolidSvgIcons.faInfoCircle,
    trash: freeSolidSvgIcons.faTrash,
    'trash-restore': freeSolidSvgIcons.faTrashRestore,
    map: freeSolidSvgIcons.faMapLocationDot,
    ball: freeSolidSvgIcons.faBasketballBall,
    search: freeSolidSvgIcons.faSearch,
    arrowleft: freeSolidSvgIcons.faChevronLeft,
    arrowright: freeSolidSvgIcons.faChevronRight,
    clock: freeSolidSvgIcons.faClock,
    stats: freeSolidSvgIcons.faSignal,
    cart: freeSolidSvgIcons.faShoppingCart,
    bold: freeSolidSvgIcons.faBold,
    italic: freeSolidSvgIcons.faItalic,
    underline: freeSolidSvgIcons.faUnderline,
    image: freeRegularSvgIcons.faImage,
    ol: freeSolidSvgIcons.faListOl,
    ul: freeSolidSvgIcons.faListUl,
    alignLeft: freeSolidSvgIcons.faAlignLeft,
    alignCenter: freeSolidSvgIcons.faAlignCenter,
    alignRight: freeSolidSvgIcons.faAlignRight,
    alignJustify: freeSolidSvgIcons.faAlignJustify,
    rotateLeft: freeSolidSvgIcons.faRotateLeft,
    rotateRight: freeSolidSvgIcons.faRotateRight,
    clipboard: freeSolidSvgIcons.faClipboard,
    card: freeSolidSvgIcons.faAddressCard,
    phone: freeSolidSvgIcons.faPhoneFlip,
    email: freeSolidSvgIcons.faEnvelope,
    calendar: freeSolidSvgIcons.faCalendar,
    help: freeSolidSvgIcons.faCircleQuestion,
    warning: freeSolidSvgIcons.faTriangleExclamation,
    creditCard: freeSolidSvgIcons.faCreditCard,
    fileDownload: freeSolidSvgIcons.faFileArrowDown,
    ban: freeSolidSvgIcons.faBan,
    clone: freeSolidSvgIcons.faClone,
    link: freeSolidSvgIcons.faLink,
    file: freeSolidSvgIcons.faFile,
    circle: freeSolidSvgIcons.faCircle,
    language: freeSolidSvgIcons.faLanguage,
    'user-shield': freeSolidSvgIcons.faUserShield,
    'people-group': freeSolidSvgIcons.faPeopleGroup,
    bed: freeSolidSvgIcons.faBed,
    shirt: freeSolidSvgIcons.faShirt,
    'arrow-turn-right': freeSolidSvgIcons.faArrowsTurnRight,
    'arrow-turn-up': freeSolidSvgIcons.faArrowTurnUp,
    send: freeSolidSvgIcons.faPaperPlane,
    'right-left': freeSolidSvgIcons.faRightLeft,
    'arrow-up-2': freeSolidSvgIcons.faArrowUp,
    'arrow-down-2': freeSolidSvgIcons.faArrowDown,
    'arrow-up-down': freeSolidSvgIcons.faArrowsUpDown,
    'caret-up': freeSolidSvgIcons.faCaretUp,
    'caret-down': freeSolidSvgIcons.faCaretDown,
    filter: freeSolidSvgIcons.faFilter,
    wand: freeSolidSvgIcons.faMagicWandSparkles,
    excel: freeRegularSvgIcons.faFileExcel,
    'ranking-star': freeSolidSvgIcons.faRankingStar,
    pdf: freeRegularSvgIcons.faFilePdf,
    print: freeSolidSvgIcons.faPrint,
    flag: freeSolidSvgIcons.faFlag,
    'list-check': freeSolidSvgIcons.faListCheck,
    gear: freeSolidSvgIcons.faGear,
    key: freeSolidSvgIcons.faKey,
    envelope: freeSolidSvgIcons.faEnvelope,
    house: freeSolidSvgIcons.faHouse,
    aibasketvideo: freeSolidSvgIcons.faPlayCircle,
    aibasketcrashvideo: freeSolidSvgIcons.faVideoSlash,
    aibasketadvancevideo: freeSolidSvgIcons.faAnglesRight,
    aibasketabackvideo: freeSolidSvgIcons.faAnglesLeft,
    aibasketplayvideo: freeSolidSvgIcons.faPlay,
    aibasketpausevideo: freeSolidSvgIcons.faPause,
    aibasketvolumehighvideo: freeSolidSvgIcons.faVolumeHigh,
    aibasketvolumemutevideo: freeSolidSvgIcons.faVolumeMute,
    aibaskettvvideo: freeSolidSvgIcons.faTv,
    aibasketopenFullScreen: freeSolidSvgIcons.faUpRightAndDownLeftFromCenter,
    aibasketcloseFullScreen: freeSolidSvgIcons.faDownLeftAndUpRightToCenter,
    twitter: freeBrandsSvgIcons.faXTwitter,
    facebook: freeBrandsSvgIcons.faFacebookF,
    whatsapp: freeBrandsSvgIcons.faWhatsapp,
    cup: freeSolidSvgIcons.faTrophy,
    users: freeSolidSvgIcons.faUsers,
    asterisk: freeSolidSvgIcons.faAsterisk,
    puzzle: freeSolidSvgIcons.faPuzzlePiece,
    draganddrop: freeSolidSvgIcons.faGripVertical,
    sort: freeSolidSvgIcons.faSort,
};
const Icon = ({ text, fontSize = 16, padding = 5, marginRight = 5, marginBottom = 0, type, title, onPress, color = '#333', borderWidth = 0, containerStyle = {}, style = {}, textStyle: textStyle, backgroundColor, rotate, loading = false }) => {
    const [loadingState, setLoadingState] = React.useState(false);
    const handlePress = React.useCallback(async () => {
        if (!onPress)
            return;
        try {
            setLoadingState(true);
            await Promise.resolve(onPress());
        }
        finally {
            setLoadingState(false);
        }
    }, [onPress]);
    const containerStyles = {
        marginRight,
        marginBottom,
        borderWidth,
        borderColor: color,
        cursor: onPress ? 'pointer' : '',
        ...containerStyle,
        backgroundColor,
    };
    const contentStyle = {
        padding: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transform: rotate ? `rotate(${rotate}deg)` : undefined,
    };
    const styles = {
        fontSize,
        width: fontSize,
        height: fontSize,
        color,
        ...style,
    };
    if (type === 'aibasketvideo') {
        return (jsxRuntime.jsx(reactNative.View, { style: containerStyles, accessibilityLabel: title, pointerEvents: !!onPress ? 'auto' : 'none', children: jsxRuntime.jsx(reactNative.TouchableWithoutFeedback, { onPress: !!onPress ? onPress : undefined, children: jsxRuntime.jsx(reactNative.View, { style: [contentStyle, { padding }], accessible: false, focusable: false, tabIndex: -1, children: jsxRuntime.jsx(Image, { width: fontSize, height: fontSize, url: img, containerStyle: styles }) }) }) }));
    }
    return (jsxRuntime.jsx(reactNative.View, { style: containerStyles, accessibilityLabel: title, pointerEvents: !!onPress ? 'auto' : 'none', children: loading || loadingState ? (jsxRuntime.jsx(Loader, { size: "small", color: color, margin: 3 })) : (jsxRuntime.jsx(reactNative.TouchableWithoutFeedback, { onPress: handlePress, children: jsxRuntime.jsxs(reactNative.View, { style: [contentStyle, { padding }], accessible: false, focusable: false, tabIndex: -1, children: [type !== 'text' && jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, { title: title, icon: resources[type], style: styles }), type === 'text' && jsxRuntime.jsx(reactNative.Text, { style: { ...styles, width: 'auto', fontWeight: 'bold', ...textStyle }, children: text })] }) })) }));
};

const SM = 576;
const MD = 768;
const LG = 992;
const XL = 1280;

const useResponsiveStyles = ({ xs = {}, sm = {}, md = {}, lg = {}, xl = {} }) => {
    const { width } = reactNative.useWindowDimensions();
    if (width > XL) {
        return merge({}, xs, sm, md, lg, xl);
    }
    if (width > LG) {
        return merge({}, xs, sm, md, lg);
    }
    if (width > MD) {
        return merge({}, xs, sm, md);
    }
    if (width > SM) {
        return merge({}, xs, sm);
    }
    return xs;
};

const Title = ({ text, subtext, size = 'medium', fontSize, fontWeight, uppercase = false, justifyContent = 'flex-start', color, borderColor, containerStyle, italic, button, borderBottomWidth = 0, marginBottom, subtextColor }) => {
    const context = React__namespace.useContext(OWCContext);
    const _color = color || context?.fonts.title.color;
    const _fontWeight = fontWeight || context?.fonts.title.fontWeight;
    const styles = useResponsiveStyles({ xs: xs$4, md: md$3 });
    return (jsxRuntime.jsxs(reactNative.View, { style: [!borderBottomWidth && { paddingBottom: 0 }, styles.container, containerStyle, { borderColor: borderColor || _color, borderBottomWidth }, marginBottom !== undefined && { marginBottom }], children: [jsxRuntime.jsxs(reactNative.View, { style: [styles.contentContainer, { justifyContent }], children: [jsxRuntime.jsx(Text, { uppercase: uppercase, italic: italic, style: [
                            context.fonts.title,
                            styles.text,
                            styles[size],
                            { fontWeight: _fontWeight },
                            { color: _color },
                            !!fontSize && { fontSize, lineHeight: fontSize },
                            justifyContent === 'center' && { textAlign: 'center' }
                        ], children: text }), !!subtext && (jsxRuntime.jsx(Text, { style: [
                            styles.subtext,
                            { color: subtextColor || _color },
                        ], children: subtext }))] }), !!button && (jsxRuntime.jsx(Button, { marginBottom: 0, ...button }))] }));
};
const xs$4 = reactNative.StyleSheet.create({
    container: {
        width: '100%',
        alignItems: 'center',
        flexDirection: 'row',
        marginBottom: 10,
        justifyContent: 'space-between',
    },
    text: {
    // textAlign: 'center',
    },
    uppercase: {
        textTransform: 'uppercase',
    },
    italic: {
        fontStyle: 'italic',
    },
    xsmall: {
        fontSize: 12,
        lineHeight: 12,
    },
    small: {
        fontSize: 18,
        lineHeight: 18,
    },
    medium: {
        fontSize: 22,
        lineHeight: 22,
    },
    large: {
        fontSize: 26,
        lineHeight: 26,
    },
    xlarge: {
        fontSize: 28,
        lineHeight: 28,
    },
    default: {},
    contentContainer: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        gap: 10,
        flex: 1,
    }
});
const md$3 = reactNative.StyleSheet.create({
    container: {
        width: '100%',
        flexDirection: 'row',
        marginBottom: 20,
        alignItems: 'flex-end',
        //borderBottomWidth: 1,
        paddingBottom: 5,
    },
    text: {
    // textAlign: 'center',
    },
    subtext: {
        fontWeight: 'normal',
    },
    uppercase: {
        textTransform: 'uppercase',
    },
    italic: {
        fontStyle: 'italic',
    },
    xsmall: {
        fontSize: 16,
        lineHeight: 16,
    },
    small: {
        fontSize: 22,
        lineHeight: 22,
    },
    medium: {
        fontSize: 28,
        lineHeight: 28,
    },
    large: {
        fontSize: 34,
        lineHeight: 34,
    },
    xlarge: {
        fontSize: 40,
        lineHeight: 40,
    },
    default: {}
});

/**
 * Collapsible component
 */
const Collapsible = ({ headerStyle, borderWidthIcon = 1, containerIcon, iconClose = "minus", iconOpen = "plus", title, titleSize = 'small', type = 'primary', headerBottom, headerLeft, headerRight, children, borderColor, headerBackgroundColor, headerColor, contentBackgroundColor, containerStyle, contentStyle, defaultOpen = false, trigger, onToggle, disableToggle = false }) => {
    const context = React__namespace.useContext(OWCContext);
    const [open, setOpen] = React__namespace.useState(defaultOpen);
    // context
    const bc = borderColor || context.colors.primary.background;
    const hbgc = headerBackgroundColor || context.colors[type].background;
    const hc = headerColor || (type === 'primary' ? 'white' : context.colors.light.text);
    const cbgc = contentBackgroundColor || (type === 'primary' ? context.colors.light.background : 'white');
    /**
     * trigger action
     */
    React__namespace.useEffect(() => {
        if (!trigger?.value?.length) {
            return;
        }
        if (trigger.value === 'open') {
            setOpen(true);
        }
        else if (trigger.value === 'close') {
            setOpen(false);
        }
    }, [trigger]);
    /**
     * toggle
     */
    const toggle = () => {
        if (!disableToggle) { // Solo permitir el toggle si disableToggle es false
            onToggle?.(!open ? 'open' : 'close');
            setOpen(!open);
        }
    };
    /**
     * render
     */
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$w.container, { borderColor: bc }, containerStyle], children: [jsxRuntime.jsx(reactNative.TouchableWithoutFeedback, { onPress: toggle, children: jsxRuntime.jsxs(reactNative.View, { style: [styles$w.header, { backgroundColor: hbgc }, headerStyle], children: [jsxRuntime.jsxs(reactNative.View, { style: { flex: 1 }, children: [jsxRuntime.jsxs(reactNative.View, { style: { flexDirection: 'row', alignItems: "center" }, children: [headerLeft, jsxRuntime.jsx(Title, { text: title, color: hc, size: titleSize, containerStyle: styles$w.title }), headerRight] }), headerBottom] }), !!children && (jsxRuntime.jsx(reactNative.View, { style: containerIcon, children: jsxRuntime.jsx(Icon, { marginRight: 0, type: open ? iconClose : iconOpen, color: hc, onPress: toggle, borderWidth: borderWidthIcon }) }))] }) }), open && !!children && (jsxRuntime.jsx(reactNative.View, { style: [styles$w.content, { backgroundColor: cbgc, borderColor: bc }, contentStyle], children: children }))] }));
};
/**
 * styles
 */
const styles$w = reactNative.StyleSheet.create({
    container: {
        width: '100%',
        borderWidth: 1,
        marginBottom: 15,
    },
    header: {
        padding: 15,
        cursor: 'pointer',
        flexDirection: 'row',
        alignItems: 'center',
    },
    title: {
        flex: 1,
        margin: 0,
        marginBottom: 0,
        paddingBottom: 0,
    },
    content: {
        padding: 15,
        borderTopWidth: 1,
    },
});

const styles$v = reactNative.StyleSheet.create({
    progressContent: {
        justifyContent: 'flex-start',
        borderRadius: 100,
        alignItems: 'flex-start',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    progressBar: {
        borderRadius: 100,
        height: 30,
    },
    progressText: {
        position: 'absolute',
        zIndex: 99,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%'
    }
});

const toFixed = (value, amount = 2) => {
    return parseFloat((value + '').replace(',', '.')).toFixed(amount);
};
const addZero = (val) => {
    if (val < 10) {
        return `0${val}`;
    }
    else {
        return val;
    }
};
const percentage = (amount, total, decimals = 2) => {
    if (!total) {
        return '-';
    }
    return (amount / total * 100).toFixed(decimals) + '%';
};
const round = (value, amount = 2) => {
    return Math.round(value * Math.pow(10, amount)) / Math.pow(10, amount);
};

var NumberUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addZero: addZero,
  percentage: percentage,
  round: round,
  toFixed: toFixed
});

const CompletedBar = ({ toComplete, completed }) => {
    const context = React__namespace.useContext(OWCContext);
    const barPercent = completed != 0 ? (completed / toComplete) * 100 : 0;
    const colorprogressText = context.colors.primary.text;
    const bgProgressBar = context.colors.primary.background;
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$v.progressContent, { backgroundColor: '#ccc' }], children: [jsxRuntime.jsx(reactNative.View, { style: [styles$v.progressText], children: jsxRuntime.jsxs(Text, { bold: true, color: colorprogressText, children: [toFixed(barPercent), "%"] }) }), jsxRuntime.jsx(reactNative.View, { style: [styles$v.progressBar, { width: `${barPercent}%`, backgroundColor: bgProgressBar }] })] }));
};

const useAlert = () => {
    const context = React__namespace.useContext(OWCContext);
    return {
        create: context.alerts.create,
        createDefaultError: context.alerts.createDefaultError,
        delete: context.alerts.delete,
    };
};

const useComponentDidMount = (callback, unmount) => {
    React__namespace.useEffect(() => {
        Promise.resolve(callback());
        return unmount;
    }, []);
};

const defaultInstance = require('i18next').default;
const instance = defaultInstance || importedInstance;
/**
 *
 */
const init = (defaultLanguage, translations) => {
    return instance.init({
        lng: defaultLanguage,
        resources: translations,
        keySeparator: '.',
        interpolation: { escapeValue: false },
    });
};
/**
 *
 * @param language
 */
const changeLanguage = (language) => {
    if (getLanguage() === language) {
        return;
    }
    instance.changeLanguage(language);
};
/**
 *
 */
const getLanguage = () => {
    return instance.language;
};
/**
 *
 */
const t = (key, params = {}) => {
    return instance.getFixedT(getLanguage())(key, params);
};
const i18n = { instance, init, changeLanguage, getLanguage };

const Separator = ({ width = '100%', height = 1, marginTop = 0, marginBottom = 0, backgroundColor = 'transparent', style }) => {
    return (jsxRuntime.jsx(reactNative.View, { style: [{ width, height, marginTop, marginBottom, backgroundColor }, style] }));
};

const styles$u = reactNative.StyleSheet.create({
    container: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        paddingVertical: 'calc(0.025 * 100vh)',
        paddingHorizontal: 10,
    },
    backdrop: {
        backgroundColor: 'black',
        opacity: 0.5,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    },
    content: {
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        width: '100%',
        maxHeight: '90%',
    },
    header: {
        flexDirection: 'row',
        width: '100%',
        padding: 15,
        alignItems: 'center',
    },
    footer: {
        width: '100%',
    },
    titleContainer: {
        flex: 1,
    },
    headerClose: {
        marginLeft: 15,
        flexGrow: 0,
    },
});

const Modal = ({ close, minHeight = 'auto', children, title = t('common:modal.alert'), subtitle, visible = true, animationType = 'none', width, minWidth = 100, maxWidth = 800, justifyContent = 'flex-start', backgroundColor = 'white', fullscreen = false, header = true, footer, contentContainerStyle }) => {
    const dimensions = reactNative.useWindowDimensions();
    fullscreen = dimensions.width <= SM || fullscreen;
    if (!visible) {
        return null;
    }
    // problem with scrollView
    return (jsxRuntime.jsx(reactNative.Modal, { animationType: animationType, transparent: true, visible: visible, children: jsxRuntime.jsxs(reactNative.View, { style: [styles$u.container, { justifyContent: fullscreen ? "center" : justifyContent }, fullscreen && { padding: 0 }], children: [jsxRuntime.jsx(reactNative.TouchableWithoutFeedback, { onPress: close, children: jsxRuntime.jsx(reactNative.View, { style: styles$u.backdrop }) }), jsxRuntime.jsxs(reactNative.View, { style: [
                        styles$u.content,
                        {
                            minWidth: typeof minWidth === 'string' ? minWidth : Math.min(minWidth, dimensions.width),
                            maxWidth: typeof maxWidth === 'string' ? maxWidth : Math.min(maxWidth, dimensions.width),
                            minHeight: typeof minHeight === 'string' ? minHeight : Math.min(minHeight, dimensions.height),
                            backgroundColor: backgroundColor,
                        },
                        width && { width },
                        fullscreen && { minWidth: '98%', minHeight: '98%' }
                    ], children: [header && (jsxRuntime.jsxs(reactNative.View, { style: { width: "100%" }, children: [jsxRuntime.jsxs(reactNative.View, { style: styles$u.header, children: [jsxRuntime.jsxs(reactNative.View, { style: styles$u.titleContainer, children: [jsxRuntime.jsx(Text, { fontSize: 20, uppercase: true, children: title }), !!subtitle && jsxRuntime.jsx(Text, { uppercase: true, children: subtitle })] }), close && (jsxRuntime.jsx(reactNative.TouchableOpacity, { style: styles$u.headerClose, onPress: close, children: jsxRuntime.jsx(Text, { style: { fontSize: 24 }, children: "\u00D7" }) }))] }), jsxRuntime.jsx(Separator, { backgroundColor: '#eee' })] })), jsxRuntime.jsx(reactNative.ScrollView, { contentContainerStyle: [{ flexGrow: 1, padding: 15 }, contentContainerStyle], style: { width: '100%' }, children: children }), !!footer && (jsxRuntime.jsxs(React.Fragment, { children: [jsxRuntime.jsx(Separator, { backgroundColor: '#eee' }), jsxRuntime.jsx(reactNative.View, { style: styles$u.footer, children: footer })] }))] })] }) }));
};

const ComponentLoader = ({ load = () => { }, onError = () => { }, loadOnStart = true, title, refreshing = false, children }) => {
    const [loading, setLoading] = React__namespace.useState(loadOnStart);
    const alerts = useAlert();
    useComponentDidMount(async () => {
        try {
            await Promise.resolve(load());
        }
        catch (error) {
            onError(error);
            alerts.createDefaultError(error);
        }
        setLoading(false);
    });
    if (loading) {
        return jsxRuntime.jsx(Loader, {});
    }
    return (jsxRuntime.jsxs(reactNative.View, { children: [!!title && jsxRuntime.jsx(Title, { text: title }), children, jsxRuntime.jsx(Modal, { visible: refreshing, maxWidth: 150, children: jsxRuntime.jsx(Loader, {}) })] }));
};

const Container = ({ loading, error, children, flexDirection = 'column', maxWidth, padding = 0, style }) => (jsxRuntime.jsx(reactNative.View, { style: [styles$t.container, { flexDirection, maxWidth, padding }, style], children: error ? (jsxRuntime.jsx(Alert, { text: error, type: "error", containerStyle: { marginBottom: 0 } })) : loading ? (jsxRuntime.jsx(Loader, {})) : (children) }));
const styles$t = reactNative.StyleSheet.create({
    container: {
        marginHorizontal: 'auto',
        width: '100%',
    },
});

const Cookies = ({ buttonRadius, visible = true, children, accept, close, justifyContent, backgroundColor, color, acceptText, closeText }) => {
    const dimensions = reactNative.useWindowDimensions();
    return (jsxRuntime.jsxs(Modal, { header: false, visible: visible, maxWidth: '100%', color: color, backgroundColor: backgroundColor, justifyContent: justifyContent, children: [jsxRuntime.jsx(reactNative.View, { style: { marginBottom: 20 }, children: children }), jsxRuntime.jsxs(reactNative.View, { style: { flexDirection: 'row', width: dimensions.width >= 750 ? '50%' : "100%", margin: 'auto' }, children: [jsxRuntime.jsx(Button, { borderRadius: buttonRadius, text: acceptText ? acceptText : t('common:cookies.accept'), onPress: accept, containerStyle: { flex: 1, marginBottom: 0, marginRight: 5 } }), jsxRuntime.jsx(Button, { borderRadius: buttonRadius, text: closeText ? closeText : t('common:cookies.close'), onPress: close, type: 'secondary', containerStyle: { flex: 1, marginBottom: 0 } })] })] }));
};

const CustomPicker = ({ multiple, items = [], label, onChange, defaultOptionLabel = t('common:global.selectAnOption'), error, defaultValue, stylesContainer, disabled, renderItem, renderLabel }) => {
    const defaultItem = items?.find((item) => item.value === defaultValue);
    const [isListOpen, setIsListOpen] = React__namespace.useState(false);
    const [selectedItem, setSelectedItem] = React__namespace.useState(defaultItem);
    const [multipleItems, setMultipleItems] = React__namespace.useState(defaultItem ? [defaultItem] : []);
    React__namespace.useEffect(() => {
        setSelectedItem(defaultItem);
        if (defaultValue instanceof Array) {
            setMultipleItems([...items.filter(i => {
                    //@ts-ignore
                    return defaultValue.includes(i.value);
                })]);
        }
    }, [multiple]);
    const handleChange = (item) => {
        if (disabled)
            return;
        setSelectedItem(item);
        onChange?.(item);
        setIsListOpen(false);
    };
    const handleMultipleChange = (item) => {
        if (disabled)
            return;
        const itemsIds = multipleItems.map((a) => a.value);
        if (itemsIds.includes(item.value)) {
            setMultipleItems([...multipleItems.filter(i => i.value !== item.value)]);
        }
        else {
            setMultipleItems([...multipleItems, item]);
        }
        onChange?.(item);
    };
    const renderSelected = (item) => {
        const itemsIds = multipleItems.map((a) => a.value);
        if (itemsIds.includes(item.value)) {
            return jsxRuntime.jsx(Icon, { fontSize: 9, type: 'check' });
        }
    };
    return (jsxRuntime.jsxs(reactNative.View, { style: [stylesContainer, { flex: 1, zIndex: 1, position: 'relative', marginBottom: 10 }], children: [jsxRuntime.jsx(Text, { style: [error && styles$s.error], children: label }), jsxRuntime.jsx(Button, { containerStyle: [styles$s.border, error && styles$s.error, { overflow: 'hidden' }], backgroundColor: 'white', marginBottom: 0, onPress: () => setIsListOpen(!isListOpen), fullSize: true, iconDown: true, justifyContent: 'space-between', children: jsxRuntime.jsx(reactNative.View, { style: { width: '100%', }, children: jsxRuntime.jsx(Text, { children: multiple
                            ? jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [" ", multipleItems.length > 0 ? multipleItems.map((item) => renderLabel?.(item)) : defaultOptionLabel] })
                            : selectedItem ? renderLabel?.(selectedItem) : defaultOptionLabel }) }) }), isListOpen && (jsxRuntime.jsx(reactNative.View, { style: { position: 'absolute', top: '100%', zIndex: 1, width: '100%', backgroundColor: 'white', borderWidth: 1, borderStyle: 'solid', borderColor: '#cccccc' }, children: items?.map((item) => (jsxRuntime.jsx(reactNativeWebHover.Hoverable, { style: { zIndex: 1 }, children: ({ hovered }) => (jsxRuntime.jsx(reactNative.TouchableOpacity, { onPress: () => { multiple ? handleMultipleChange(item) : handleChange(item); }, style: { backgroundColor: hovered ? '#f2f2f2' : 'white', padding: 6 }, children: jsxRuntime.jsxs(reactNative.View, { style: { display: "flex", flexDirection: "row", justifyContent: "space-between" }, children: [renderItem?.(item), multiple ? renderSelected(item) : jsxRuntime.jsx(jsxRuntime.Fragment, {})] }) })) }))) })), error === '' || error === ' ' ? null : jsxRuntime.jsx(Text, { style: [styles$s.error, { paddingLeft: 10 }], children: error || '' })] }));
};
const styles$s = reactNative.StyleSheet.create({
    border: {
        marginTop: 6,
        borderWidth: 1,
        borderColor: '#cccccc',
        borderStyle: 'solid'
    },
    error: {
        color: 'red',
        borderColor: 'red'
    }
});

// import axios, { AxiosResponse } from 'axios';
const axios = require('axios').default;
const setDefaultHeader = (key, value) => {
    axios.defaults.headers.common[key] = value;
};
const deleteDefaultHeader = (key) => {
    delete axios.defaults.headers.common[key];
};
const request = (params) => {
    return axios.request(params);
};
const get$1 = (url, params) => {
    return axios.get(url, params);
};
const post = (url, data, params) => {
    return axios.post(url, data, params);
};
const put = (url, data, params) => {
    return axios.put(url, data, params);
};
const patch = (url, data, params) => {
    return axios.patch(url, data, params);
};
const _delete = (url, params) => {
    return axios.delete(url, params);
};
/**
 *
 */
const requestPdf = (url, target = '_self', filename = 'file.pdf', method = 'GET', data = undefined) => {
    return requestFile(url, 'application/pdf', target, filename, method, data);
};
/**
 *
 * @param url
 * @param type
 * @param target
 * @param filename
 * @param method
 * @param data
 */
const requestFile = async (url, type, target = '_self', filename = 'file.pdf', method = 'GET', data = undefined) => {
    const response = await axios.request({
        url,
        method: method.toUpperCase(),
        data,
        responseType: 'blob',
        headers: { 'Access-Control-Allow-Origin': '*' },
    });
    const link = document.createElement('a');
    if (type == 'unknown' || '' == type?.trim()) {
        type = response.headers?.['content-type']; // si no tenemos header cogemos el que nos envía el back
        type = type === 'application/download' ? 'application/pdf' : type; // si el back no nos envía el formato..., entendemos que es pdf
    }
    link.href = window.URL.createObjectURL(new Blob([response.data], { type: type || '' })) + '#filename=' + filename;
    link.target = target;
    if (isDownload(type || '')) {
        link.download = filename;
    }
    link.click();
    return { type };
};
/**
 *
 * @param type
 * @returns
 */
const isDownload = (type) => {
    // image
    if (['jpg', 'jpeg', 'png', 'gif'].some((ext) => type?.toLowerCase().includes(ext))) {
        return false;
    }
    // pdf in browser
    if (type?.includes('pdf') && isFirefox()) {
        return false;
    }
    // default
    return true;
};
const isFirefox = () => {
    return /Firefox/i.test(navigator.userAgent);
};
/*const isChrome = () => {
  return /chrome/i.test(navigator.userAgent);
}

const isSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

const isAndroid = () => {
  return navigator.userAgent.toLowerCase().indexOf("android") > -1;
}*/
const getBlobUrl = async (url, type, method = 'GET', data = undefined) => {
    const response = await axios.request({
        url,
        method: method?.toUpperCase(),
        data,
        responseType: 'blob',
        headers: { 'Access-Control-Allow-Origin': '*' },
    });
    if (type == 'unknown' || '' == type.trim()) {
        type = response.headers?.['content-type'] || ''; // si no tenemos header cogemos el que nos envía el back
        type = type === 'application/download' ? 'application/pdf' : type; // si el back no nos envía el formato..., entendemos que es pdf
    }
    return window.URL.createObjectURL(new Blob([response.data], { type: type }));
};
/**
 *
 * @param url
 * @returns
 */
const getEsb = async (url) => {
    const response = await request(url);
    if (response.data?.result === 'OK') {
        return { data: response.data.messageData };
    }
    else if (response.data.result === 'ERROR') {
        const error = new Error(response.data?.message);
        error.messageData = response.data?.messageData;
        error.errorCode = response.data?.errorCode;
        throw error;
    }
    throw new Error();
};
/**
 *
 * @param url
 * @returns
 */
const getEsbEncoded = async (url) => {
    const response = await request(url);
    const resp = JSON.parse(decodeURIComponent(escape(atob(response.data))));
    if (resp?.result === 'OK') {
        return { data: resp.messageData };
    }
    else if (resp.result === 'ERROR') {
        const error = new Error(resp?.message);
        error.messageData = resp?.messageData;
        error.errorCode = resp?.errorCode;
        throw error;
    }
    throw new Error();
};
/**
 *
 * @param key
 * @param value
 */
const getDefaultHeader = (key) => {
    return axios.defaults.headers.common[key];
};
/**
 *
 * @returns
 */
const getDefaultHeaders = () => {
    return { ...axios.defaults.headers.common };
};
var RestService = { getDefaultHeaders, getDefaultHeader, setDefaultHeader, getEsb, getEsbEncoded, deleteDefaultHeader, request, get: get$1, post, put, patch, delete: _delete, requestPdf, requestFile, getBlobUrl, isDownload };

const format = (date, format) => {
    if (!date) {
        return '';
    }
    return moment(date).format(format);
};
const formatDate = (date) => {
    return format(date, 'DD/MM/YYYY');
};
const formatDateTime = (date) => {
    return format(date, 'DD/MM/YYYY HH:mm');
};
const formatSqlDateTime = (date) => {
    return format(date, 'YYYY-MM-DD HH:mm:ss');
};
const formatSqlDate = (date) => {
    return format(date, 'YYYY-MM-DD');
};
const parse = (date, format = 'DD/MM/YYYY HH:mm:ss') => {
    if (date === undefined) {
        return date;
    }
    return moment(date, format);
};
const parseDate = (date, format = 'DD/MM/YYYY HH:mm:ss') => {
    return parse(date, format)?.toDate();
};
const sub = (date, amount, units = 'hours') => {
    return moment(date).subtract(amount, units);
};
const add = (date, amount, units = 'hours') => {
    return moment(date).add(amount, units);
};
const isBefore = (date1, date2, equals = false) => {
    if (equals) {
        return moment(date1).isSameOrBefore(moment(date2));
    }
    return moment(date1).isBefore(moment(date2));
};
const isAfter = (date1, date2, equals = false) => {
    if (equals) {
        return moment(date1).isSameOrAfter(moment(date2));
    }
    return moment(date1).isAfter(moment(date2));
};
const toStandardFormat = (date, currentFormat) => {
    return moment(date, currentFormat).format();
};
const testFormat = (date, format) => {
    return moment(date, format, true).isValid();
};
const getDay = (date) => {
    const DAYS = [
        t('common:date.sunday'),
        t('common:date.monday'),
        t('common:date.tuesday'),
        t('common:date.wednesday'),
        t('common:date.thursday'),
        t('common:date.friday'),
        t('common:date.saturday'),
    ];
    const day = moment(date).isoWeekday();
    return DAYS[day % 7];
};
const getDayShort = (date) => {
    const DAYSSHORT = [
        t('common:dateShort.sunday'),
        t('common:dateShort.monday'),
        t('common:dateShort.tuesday'),
        t('common:dateShort.wednesday'),
        t('common:dateShort.thursday'),
        t('common:dateShort.friday'),
        t('common:dateShort.saturday'),
    ];
    const day = moment(date).isoWeekday();
    return DAYSSHORT[day % 7];
};
const getMonth = (date) => {
    const MONTH = [
        t('common:month.january'),
        t('common:month.february'),
        t('common:month.march'),
        t('common:month.april'),
        t('common:month.may'),
        t('common:month.june'),
        t('common:month.july'),
        t('common:month.august'),
        t('common:month.september'),
        t('common:month.october'),
        t('common:month.november'),
        t('common:month.december'),
    ];
    const month = moment(date).month();
    return MONTH[month % 12];
};
const getDateTime = (date, time) => {
    const formatted = format(date, 'YYYY-MM-DD');
    return new Date(formatted + ' ' + time);
};
const getTimezone = (timezone) => {
    if (timezone === 'M') {
        return t('common:timezone.morning');
    }
    return t('common:timezone.afternoon');
};
const startOfMonth = (formatDate = 'YYYY-MM-DD') => {
    return format(moment().startOf('month'), formatDate);
};
const endOfMonth = (formatDate = 'YYYY-MM-DD') => {
    return format(moment().endOf('month'), formatDate);
};
const getDaysMonth = (year = 2020, month = 1) => {
    const monthIndex = month - 1;
    let date = new Date(year, monthIndex, 1);
    let result = [];
    while (date.getMonth() == monthIndex) {
        result.push({ date: formatDate(date), day: date.getDate(), month: date.getMonth() + 1, label: getDay(date.toDateString()), weekIndex: date.getDay() + 1, labelShort: getDayShort(date.toDateString()) });
        date.setDate(date.getDate() + 1);
    }
    return result;
};
const getDaysOfTheWeek = () => {
    return [
        t('common:date.monday'),
        t('common:date.tuesday'),
        t('common:date.wednesday'),
        t('common:date.thursday'),
        t('common:date.friday'),
        t('common:date.saturday'),
        t('common:date.sunday'),
    ];
};
const incrementMonth = (date, quantity = 1) => {
    return moment(date.add(quantity, 'months'));
};
const decrementMonth = (date, quantity = 1) => {
    return (moment(date.subtract(quantity, 'months')));
};
const segmentIntoWeeks = dayMoments => {
    const weeks = [];
    let currentWeek = [];
    for (let day of dayMoments) {
        //@ts-ignore
        currentWeek.push(day.clone());
        // 0 is sunday in moment js day format
        if (day.format('d') == 0) {
            //@ts-ignore
            weeks.push(currentWeek);
            currentWeek = [];
        }
    }
    if (currentWeek.length > 0) {
        //@ts-ignore
        weeks.push(currentWeek);
    }
    return weeks;
};
const getDaysInMonth = monthMoment => {
    const monthCopy = monthMoment.clone();
    monthCopy.startOf('month');
    let days = [];
    while (monthCopy.month() === monthMoment.month()) {
        //@ts-ignore
        days.push(monthCopy.clone());
        monthCopy.add(1, 'days');
    }
    return days;
};
const padWeekFront = (week, padWith = null) => {
    return [...Array(7 - week.length).fill(padWith), ...week];
};
const padWeekBack = (week, padWith = null) => {
    return [...week, ...Array(7 - week.length).fill(padWith)];
};
const compareDays = (firstDate, secondDate) => {
    const a = moment(firstDate);
    const b = moment(secondDate);
    return (a.format('D') === b.format('D') &&
        a.format('M') === b.format('M') &&
        a.format('Y') === b.format('Y'));
};
var DateUtils = { format, parse, parseDate, startOfMonth, getDaysMonth, formatDate, endOfMonth, formatDateTime, formatSqlDateTime, formatSqlDate, getDay, getMonth, getTimezone, toStandardFormat, add, sub, getDaysOfTheWeek, incrementMonth, decrementMonth, segmentIntoWeeks, getDaysInMonth, padWeekFront, padWeekBack, compareDays };

var DateUtils$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  add: add,
  compareDays: compareDays,
  decrementMonth: decrementMonth,
  default: DateUtils,
  endOfMonth: endOfMonth,
  format: format,
  formatDate: formatDate,
  formatDateTime: formatDateTime,
  formatSqlDate: formatSqlDate,
  formatSqlDateTime: formatSqlDateTime,
  getDateTime: getDateTime,
  getDay: getDay,
  getDayShort: getDayShort,
  getDaysInMonth: getDaysInMonth,
  getDaysMonth: getDaysMonth,
  getDaysOfTheWeek: getDaysOfTheWeek,
  getMonth: getMonth,
  getTimezone: getTimezone,
  incrementMonth: incrementMonth,
  isAfter: isAfter,
  isBefore: isBefore,
  padWeekBack: padWeekBack,
  padWeekFront: padWeekFront,
  parse: parse,
  parseDate: parseDate,
  segmentIntoWeeks: segmentIntoWeeks,
  startOfMonth: startOfMonth,
  sub: sub,
  testFormat: testFormat,
  toStandardFormat: toStandardFormat
});

/**
 * Devuelve si true si un elemento es de tipo texto o número
 */
const isText = (text) => {
    return ['string', 'number'].includes(typeof text);
};
/**
 * Añade tantos símbolos como sean necesarios para que el valor tenga la longitud especificada
 */
const pad = (value, length = 2, symbol = '0') => {
    const text = value + '';
    if (text.length >= length) {
        return value;
    }
    const padding = symbol.repeat(length);
    const index = padding.length - text.length;
    return padding.substr(0, index) + text;
};
/**
 * Recupera los valores de tipo string de un elemento, de manera recursiva
 */
const getTextNodes = (tree) => {
    if (tree === undefined || tree === null) {
        return '';
    }
    if (isText(tree)) {
        return tree + '';
    }
    let children;
    if (React__namespace.isValidElement(tree)) {
        const props = tree.props;
        children = props?.children || props?.text || props?.label || []; // needs to be split in two lines...?
    }
    else {
        children = tree.children || [];
    }
    // if (isText(children)) {
    //   return children + '';
    // }
    children = Array.isArray(children) ? children : [children];
    return children?.map((child) => {
        return getTextNodes(child);
    }).join(' ') || ' ';
};

var TextUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getTextNodes: getTextNodes,
  isText: isText,
  pad: pad
});

const generate = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

const styles$r = reactNative.StyleSheet.create({
    labelbox: {
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: 5,
    },
    container: {
        marginBottom: 15,
    },
    label: {
        //  paddingLeft: 10,
        marginBottom: 5,
        color: '#333',
    },
    labelError: {
        color: 'crimson',
    },
    inputContainer: {
        //  padding: 5,
        width: '100%',
    },
    inputContainerError: {
        borderColor: 'crimson',
        shadowColor: 'crimson',
    },
    input: {
        width: '100%',
        flex: 1,
        backgroundColor: 'white',
        borderRadius: 0,
        //  fontSize: 15,
        paddingLeft: 10,
        color: '#333',
        borderWidth: 1,
        borderColor: '#ccc',
        height: 40,
        minHeight: 40,
        boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075)',
    },
    text: {
        width: '90%',
        textAlign: 'left',
        fontWeight: 'bold',
        //  fontSize: 18,
    },
    textError: {
        //  fontSize: 12,
        paddingLeft: 10,
        color: 'crimson',
    },
});

// import { OWCContext } from 'src/context/OWCContext';
const Input = React__namespace.forwardRef(({ disabled = false, numberOfLines = 1, label, placeholder, placeholderColor = '#757575', onChange = () => { }, onKeyPress = () => { }, onBlur, onSubmitEditing, numeric = false, secureTextEntry = false, error, defaultValue = '', autoCapitalize = 'none', keyboardType, value, containerStyle, autoFocus, style, required = false, borderRadius = 5, borderWidth = 1, color, backgroundColor, horizontal = false, labelHorizontalWidth = 200, labelHorizontalJustifyContent = 'flex-end', loading = false, }, ref) => {
    const [currentValue, setCurrentValue] = React__namespace.useState(value !== undefined && value !== null ? value + '' : defaultValue != undefined && defaultValue != null ? defaultValue + '' : '');
    const [currentError, setCurrentError] = React__namespace.useState(error);
    const [currentColor, setCurrentColor] = React__namespace.useState(color);
    const [currentBackgroundColor, setCurrentBackgroundColor] = React__namespace.useState(backgroundColor);
    const [currentLoading, setCurrentLoading] = React__namespace.useState(loading);
    const [dirty, setDirty] = React__namespace.useState(false);
    React__namespace.useImperativeHandle(ref, () => ({
        setValue: setCurrentValue,
        getValue: () => currentValue,
        setError: setCurrentError,
        setColor: setCurrentColor,
        setBackgroundColor: setCurrentBackgroundColor,
        isDisabled: () => disabled,
        setLoading: setCurrentLoading,
    }));
    /**
     * update current error
     */
    React__namespace.useEffect(() => {
        setCurrentError(error);
    }, [error]);
    /**
     * update current border color
     */
    React__namespace.useEffect(() => {
        setCurrentColor(color);
    }, [color]);
    /**
     * update current background color
     */
    React__namespace.useEffect(() => {
        setCurrentBackgroundColor(backgroundColor);
    }, [backgroundColor]);
    /**
     * update loading
     */
    React__namespace.useEffect(() => {
        setCurrentLoading(loading);
    }, [loading]);
    /**
     * handle key press
     */
    const handleKeyPress = ({ nativeEvent: { key } }) => {
        onKeyPress?.(key);
    };
    /**
     * handle change
     */
    const handleChangeText = (text) => {
        if (numeric && /^-?[\d,]*\.?[\d]*$/.exec(text) === null) {
            return;
        }
        onChange(text);
        setCurrentValue(text);
        setDirty(true);
    };
    /**
     * handle blur
     */
    const handleBlur = (event) => {
        if (!dirty) {
            return;
        }
        onBlur?.(event);
        setDirty(false);
    };
    /**
     * render
     */
    if (!Array.isArray(containerStyle)) {
        containerStyle = [containerStyle];
    }
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$r.container, ...containerStyle], children: [jsxRuntime.jsxs(reactNative.View, { style: horizontal && { flexDirection: 'row' }, children: [!!label && (jsxRuntime.jsx(reactNative.View, { style: [styles$r.labelbox, horizontal && { width: labelHorizontalWidth, paddingRight: 5, justifyContent: labelHorizontalJustifyContent }], children: jsxRuntime.jsx(Text, { style: [styles$r.label, currentError ? styles$r.labelError : undefined, horizontal && { marginBottom: 0 }], children: required ? `${label} *` : label }) })), jsxRuntime.jsxs(reactNative.View, { style: [styles$r.inputContainer, horizontal && { flex: 1, width: 'auto', minWidth: 0 }, currentError ? styles$r.inputContainerError : undefined], children: [jsxRuntime.jsx(reactNative.TextInput, { editable: !disabled, multiline: numberOfLines > 1, numberOfLines: numberOfLines, style: [
                                    styles$r.input,
                                    style,
                                    disabled && { backgroundColor: '#f2f2f2' },
                                    !!currentColor && { color: currentColor, borderColor: currentColor },
                                    !!currentError && { borderColor: 'crimson' },
                                    !!currentBackgroundColor && { backgroundColor: currentBackgroundColor },
                                    { borderRadius, borderWidth },
                                ], placeholder: placeholder, onChangeText: handleChangeText, onBlur: handleBlur, onSubmitEditing: onSubmitEditing, onKeyPress: handleKeyPress, secureTextEntry: secureTextEntry, keyboardType: keyboardType, autoCapitalize: autoCapitalize, value: value !== undefined && value !== null ? value + '' : currentValue != undefined && currentValue != null ? currentValue + '' : '', autoFocus: autoFocus, placeholderTextColor: placeholderColor }), currentLoading && (jsxRuntime.jsx(reactNative.View, { style: { position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, alignItems: 'center', justifyContent: 'center' }, children: jsxRuntime.jsx(reactNative.ActivityIndicator, { size: 'small', style: { flex: 1 } }) }))] })] }), jsxRuntime.jsx(Text, { style: [styles$r.textError], children: currentError })] }));
});

const styles$q = reactNative.StyleSheet.create({
    container: {
        marginBottom: 15,
        // width: '100%',
    },
    labelContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: 5,
    },
    label: {
        color: '#333',
        marginBottom: 5,
    },
    labelError: {
        color: 'crimson',
    },
    pickerContainer: {
        width: '100%',
        backgroundColor: 'white',
        borderWidth: 1,
        borderColor: '#ccc',
        height: 40,
        minHeight: 40,
    },
    pickerNative: {
        backgroundColor: 'transparent',
        // fontSize: 15,
        textTransform: 'none',
        margin: 0,
        paddingLeft: 10,
        paddingRight: 20,
        // paddingTop: 10,
        // marginRight: 10,
        width: '100%',
        flex: 1,
        fontWeight: '400',
        color: '#333',
        borderRadius: 0,
        appearance: 'none',
        zIndex: 10,
        border: 0,
    },
    pickerNativeDisabled: {
        backgroundColor: '#f2f2f2',
        borderColor: '#e6e6e6'
    },
    pickerError: {
        borderColor: 'crimson',
        shadowColor: 'crimson',
    },
    pickerDisabled: {
        borderColor: '#e6e6e6'
    },
    icon: {
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        alignItems: 'center',
        justifyContent: 'center',
    },
    helpError: {
        // fontSize: 12,
        paddingLeft: 10,
        color: 'crimson',
    },
});

// import { OWCContext } from "src/context/OWCContext";
const Picker = ({ defaultOptionLabel, items = [], label, onChange = () => { }, defaultValue, selected, error, stylesContainer, marginBottom = 15, borderRadius = 5, editable = true, clearable = true, disabled = false, containerStyle, required = false, horizontal = false, labelHorizontalWidth = 200 }) => {
    // const context = React.useContext(OWCContext);
    const [currentValue, setCurrentValue] = React__namespace.useState(selected ?? defaultValue ?? '');
    const handleChange = (value, position) => {
        onChange(value, position);
        setCurrentValue(value);
    };
    const enabled = editable && !disabled;
    // default option
    if (defaultOptionLabel === undefined) {
        defaultOptionLabel = t('common:global.selectAnOption');
    }
    // render
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$q.container, { marginBottom }, containerStyle], children: [jsxRuntime.jsxs(reactNative.View, { style: horizontal && { flexDirection: 'row' }, children: [!!label && (jsxRuntime.jsx(reactNative.View, { style: [styles$q.labelContainer, horizontal && { width: labelHorizontalWidth, justifyContent: 'flex-end', marginLeft: 0, paddingRight: 5 }], children: jsxRuntime.jsx(Text, { style: [styles$q.label, error && styles$q.labelError, horizontal && { marginBottom: 0 }], children: required ? `${label} *` : label }) })), jsxRuntime.jsxs(reactNative.View, { style: [
                            styles$q.pickerContainer,
                            horizontal && { flex: 1, width: 'auto', minWidth: 0 },
                            { /*borderColor: '#ccc' context.colors.primary.background, */ borderRadius },
                            stylesContainer,
                            !!error && styles$q.pickerError, !!disabled && styles$q.pickerDisabled
                        ], children: [jsxRuntime.jsxs(picker.Picker, { enabled: enabled, mode: "dropdown", onValueChange: handleChange, style: [styles$q.pickerNative, !enabled && styles$q.pickerNativeDisabled, (!!defaultOptionLabel && clearable) && { paddingRight: 55 }], selectedValue: selected !== undefined && selected !== null ? selected : currentValue, children: [defaultOptionLabel && (jsxRuntime.jsx(picker.Picker.Item, { label: defaultOptionLabel, value: "", color: "#333" })), items.map((item) => (jsxRuntime.jsx(picker.Picker.Item, { label: item.label + '', value: item.value, color: '#333' }, item.value ?? "undefined")))] }), (!!defaultOptionLabel && clearable) && jsxRuntime.jsx(Icon, { type: 'times', marginRight: 0, color: '#333', fontSize: 10, containerStyle: { ...styles$q.icon, right: 25, zIndex: 9999 }, onPress: () => handleChange('', 0) }), jsxRuntime.jsx(Icon, { type: 'arrow-down', marginRight: 0, color: '#333', fontSize: 10, containerStyle: { ...styles$q.icon, pointerEvents: 'none' } })] })] }), error === '' || error === ' ' ? null : jsxRuntime.jsx(Text, { style: [styles$q.helpError], children: error || '' })] }));
};

const DATATABLE_LOADING = 'DATATABLE_LOADING'; // before fetching data from url
const DATATABLE_METADATA = 'DATATABLE_METADATA'; // on metadata change
const DATATABLE_FILTER = 'DATATABLE_FILTER'; // on filter change
const DATATABLE_VISIBILITY = 'DATATABLE_HEADERS'; // set shown values
const DATATABLE_VALUES = 'DATATABLE_VALUES'; // set shown values
const datatableReducer = (state, action) => {
    switch (action.type) {
        case DATATABLE_LOADING:
            return { ...state, loading: true };
        case DATATABLE_METADATA:
            const metadata = { ...state.metadata, ...action.payload };
            if (!!state.id) {
                localStorage.setItem('datatable-' + state.id, JSON.stringify({ ...metadata, _updated: new Date() }));
            }
            return { ...state, metadata };
        case DATATABLE_FILTER:
            return { ...state, filter: action.payload, loading: false };
        case DATATABLE_VISIBILITY:
            const visibility = { ...state.visibility, ...action.payload };
            if (!!state.id) {
                localStorage.setItem('datatable-vis-' + state.id, JSON.stringify(visibility));
            }
            return { ...state, visibility };
        case DATATABLE_VALUES:
            return { ...state, ...action.payload, key: Math.floor(Math.random() * 1000), loaded: true, loading: false };
        default:
            return state;
    }
};

const getFilterValues = (filters, header, values = []) => {
    // get all values
    let filterValues = [...values];
    // apply other filters
    Object.keys(filters).forEach((name) => {
        if (name === header.name) {
            return;
        }
        const filter = filters[name];
        filterValues = filterValues.filter((value) => filter.mode === 'include' && value[name] || filter.mode === 'exclude' && !filter.exclude.includes(value[name]));
    });
    // get checkable values for this header and remove duplicates
    return [...new Set(filterValues.map((value) => value[header.name]))];
};
const getVisibility = (id, defaultValue) => {
    const localStorageVisibility = localStorage.getItem('datatable-vis-' + id);
    return !!localStorageVisibility ? JSON.parse(localStorageVisibility) : defaultValue;
};
const getMetadata = (id, hours, defaultValue) => {
    const localStorageMetadata = localStorage.getItem('datatable-' + id);
    let metadata = !!localStorageMetadata ? JSON.parse(localStorageMetadata) : defaultValue;
    if (!!hours && !!metadata && (!metadata._updated || isBefore(new Date(metadata._updated), sub(new Date(), hours, 'hours')))) {
        metadata = defaultValue;
    }
    metadata.page = 0;
    metadata.search = '';
    return metadata;
};
const PAGE_OFFSET = 3; // amount of pages to show on each side of the current page
const Datatable = ({ id, duration = 0, headers, values, source, onChange, onPressRow, onHoverRow, getRowStyles, pagination = true, defaultSort = {}, additionalButtons = [], defaultSize = 10 }) => {
    // const loadRef = useRef<any>();
    const context = React.useContext(OWCContext);
    const colors = {
        active: context.colors.primary.background,
        inactive: '#ddd'
    };
    const filterSearch = React.useRef({
        type: 'contains',
        value: '',
    });
    const [data, dispatch] = React.useReducer(datatableReducer, {
        id,
        loaded: false,
        loading: true,
        key: 0,
        // headers, // headers
        // filters: false, // toggle filter visibility
        filter: undefined,
        values: [],
        total: 0,
        pages: 0,
        visibility: getVisibility(id, {
            open: false,
            hidden: headers?.filter((object) => object.defaultHidden).map((header) => header.name) ?? [], // hidden headers
        }),
        metadata: getMetadata(id, duration, {
            size: defaultSize,
            page: 0,
            search: '',
            sort: defaultSort,
            filters: {}, // filter values
        }),
    });
    /**
     * request
     */
    const request = React.useCallback((params = {}, filter = undefined) => {
        if (!source) {
            return null;
        }
        const filters = { ...data.metadata.filters };
        if (!!filter) {
            filters[filter?.name] = filter;
        }
        const payload = {
            ...data.metadata,
            ...params,
            params: source.params,
            filters: Object.keys(filters).map((key) => ({
                ...filters[key],
                name: key,
            })),
            sort: Object.keys(data.metadata.sort).filter((key) => !!data.metadata.sort[key]).map((key) => ({ name: key, direction: data.metadata.sort[key] === 1 ? 'asc' : 'desc' })),
        };
        // request
        dispatch({ type: DATATABLE_LOADING });
        return RestService.post(source.url, payload);
    }, [source, data.metadata]);
    /**
     * load
     */
    const load = React.useCallback(async () => {
        try {
            const payload = { ...data };
            // ajax
            if (!!source) {
                const response = await request();
                if (response?.data) {
                    // shown values
                    payload.values = response.data.values; // .slice(0, data.metadata.size);
                    // filtered amount
                    payload.filtered = response.data.filtered;
                    // total amount
                    payload.total = response.data.total || 0;
                    // page amount
                    payload.pages = !data.metadata.size ? 0 : Math.max(0, Math.ceil((payload.filtered ?? payload.total) / data.metadata.size) - 1);
                }
            }
            // static data
            else if (!!values) {
                let filtered = [...values];
                // search
                if (!!data.metadata.search) {
                    filtered = filtered.filter((object) => headers.some((header, index) => ((header.value?.(object, index) || object?.[header.name]))?.toString().toLowerCase().includes(data.metadata.search.toLowerCase())));
                }
                // filters
                Object.keys(data.metadata.filters).forEach((name) => {
                    const filter = data.metadata.filters[name];
                    filtered = filtered.filter((value) => filter.mode === 'include' && filter.include.includes(value[name]) || filter.mode === 'exclude' && !filter.exclude.includes(value[name]));
                });
                // sort
                filtered = filtered.sort((a, b) => sortDT(headers, data.metadata.sort, a, b, 0));
                // shown values
                payload.values = !data.metadata.size ? filtered : filtered.slice(data.metadata.page * data.metadata.size, data.metadata.page * data.metadata.size + data.metadata.size) || [];
                // filtered amount
                payload.filtered = filtered.length;
                // total amount
                payload.total = values.length;
                // page amount
                payload.pages = !data.metadata.size ? 0 : Math.max(0, Math.ceil(filtered.length / data.metadata.size) - 1);
            }
            delete payload.metadata;
            dispatch({ type: DATATABLE_VALUES, payload });
            // notify
            onChange?.(payload);
        }
        catch (error) {
            // dispatch({ type: DATATABLE_VALUES, payload: { total: 0, filtered: 0, pages: 0, values: [] } });
            console.error(error);
        }
    }, [source, onChange, request, data.metadata, values]);
    /**
     * load
     */
    React.useEffect(() => {
        load();
    }, [data.metadata, values]);
    /**
     * on change source
     */
    React.useEffect(() => {
        if (!data.loaded) {
            return;
        }
        load();
    }, [source, source?.params]);
    /**
     * clear filters
     */
    const clear = React.useCallback(() => {
        dispatch({ type: DATATABLE_METADATA, payload: { page: 0, size: data.metadata.size, search: '', sort: {}, filters: {} } });
    }, [data]);
    /**
     * select page
     */
    const select = React.useCallback((page) => {
        page = Math.max(Math.min(page, data.pages), 0);
        if (page !== data.metadata.page) {
            // data.metadata.page = page;
            dispatch({ type: DATATABLE_METADATA, payload: { page } });
        }
    }, [data.pages, data.metadata.page]);
    /**
     * last page
     */
    const first = React.useCallback(() => {
        select(0);
    }, [select]);
    /**
     * previous page
     */
    const prev = React.useCallback(() => {
        select(data.metadata.page - 1);
    }, [select, data.metadata.page]);
    /**
     * next page
     */
    const next = React.useCallback(() => {
        select(data.metadata.page + 1);
    }, [select, data.metadata.page]);
    /**
     * last page
     */
    const last = React.useCallback(() => {
        select(data.pages);
    }, [data.pages, select]);
    /**
     * resize pagination
     */
    const resize = React.useCallback((size) => {
        // data.metadata = { ...data.metadata, size, page: 0 };
        dispatch({ type: DATATABLE_METADATA, payload: { size: parseInt(size), page: 0 } });
    }, []);
    /**
     * search
     */
    const search = React.useCallback(debounce((search) => {
        // data.metadata = { ...data.metadata, search, page: 0 };
        dispatch({ type: DATATABLE_METADATA, payload: { search, page: 0 } });
    }), []);
    /**
     * sort
     */
    const sort = React.useCallback((header) => {
        if (!(header.sortable ?? true)) {
            return;
        }
        const column = header.name;
        const sort = { ...data.metadata.sort };
        if (!sort[column]) {
            sort[column] = 1;
        }
        else if (sort[column] === 1) {
            sort[column] = -1;
        }
        else {
            delete sort[column];
        }
        data.metadata = { ...data.metadata, sort };
        dispatch({ type: DATATABLE_METADATA, payload: { sort } });
    }, [data.metadata.sort]);
    /**
     * download excel from source
     */
    const excel = React.useCallback(async () => {
        if (!source) {
            return;
        }
        try {
            const { filters } = data.metadata;
            await RestService.requestFile(source.url, 'application/xlsx', '_blank', 'data.xlsx', 'POST', {
                excel: true,
                // ...data.metadata,
                headers,
                params: source?.params || {},
                filters: Object.keys(filters).map((key) => ({
                    ...filters[key],
                    name: key,
                })),
                sort: Object.keys(data.metadata.sort).filter((key) => !!data.metadata.sort[key]).map((key) => ({ name: key, direction: data.metadata.sort[key] === 1 ? 'asc' : 'desc' })),
            });
        }
        catch (error) {
            console.error(error);
        }
    }, [data, source]);
    /**
     * download excel from values
     */
    const getExcelValues = React.useCallback(() => {
        const data = [headers.map((header) => header.label)];
        values?.forEach((object) => {
            data.push(headers.map((header, index) => {
                return getTextNodes(header.render?.(object, index) ?? header.value?.(object, index) ?? object[header.name]);
            }));
        });
        return data;
    }, [headers, values]);
    /**
     * toggle column visibility modal
     */
    const toggleColumnVisibility = React.useCallback(() => {
        dispatch({ type: DATATABLE_VISIBILITY, payload: { open: !data.visibility.open } });
    }, [data.visibility]);
    /**
     * toggle filter visibility modal
     */
    const toggleFilterVisibility = React.useCallback(async (header) => {
        if (!header || !!data.filter || !(header.filterable ?? true)) {
            dispatch({ type: DATATABLE_FILTER, payload: undefined });
            return;
        }
        dispatch({ type: DATATABLE_LOADING });
        // request
        let response;
        // ajax
        if (!!source) {
            // get checkable values for this header
            response = await request({ column: header.name });
        }
        // static data
        else {
            // get checkable values for this header and remove duplicates
            response = {
                data: {
                    values: getFilterValues(data.metadata.filters, header, values),
                }
            };
        }
        // dispatch
        const filter = data.metadata.filters?.[header.name] || {
            name: header.name,
            label: header.label || '',
            type: 'contains',
            value: '',
            mode: 'exclude',
            include: [],
            exclude: [],
        };
        // set filter search type and value
        filterSearch.current = {
            type: filter.type,
            value: filter.value,
        };
        // dispatch DATATABLE_FILTER to show the items
        const payload = {
            ...filter,
            loading: false,
            items: response.data.values.map((item, index) => ({
                label: header.value?.({ [header.name]: item }, index) || item,
                value: item,
            })),
        };
        dispatch({ type: DATATABLE_FILTER, payload });
    }, [source, values, data.values, data.filter, request]);
    /**
     * confirm filter search
     */
    const confirmFilterSearch = React.useCallback(async () => {
        if (!data.filter) {
            return;
        }
        // dispatch({ type: DATATABLE_FILTER, payload: { ...data.filter } });
        const header = headers.find((header) => header.name === data.filter.name);
        let response;
        // ajax
        if (!!source) {
            response = await request({ column: data.filter.name }, { name: data.filter.name, ...filterSearch.current });
        }
        // static data
        else {
            response = {
                data: {
                    values: getFilterValues(data.metadata.filters, header, values).filter((value, index) => {
                        const label = (header.value?.({ [header.name]: value }, index) || value);
                        // contains
                        if (filterSearch.current.type === 'contains') {
                            return label?.toLowerCase().includes(filterSearch.current.value.toLowerCase());
                        }
                        // exact
                        return label === filterSearch.current.value;
                    }),
                }
            };
        }
        const payload = {
            ...data.filter,
            ...filterSearch.current,
            items: response.data.values.map((value, index) => ({
                label: header?.value?.({ [header.name]: value }, index) || value,
                value,
            })),
        };
        dispatch({ type: DATATABLE_FILTER, payload });
    }, [data.filter, request, values]);
    /**
     * toggle filter mode
     */
    const toggleFilterMode = React.useCallback((mode) => {
        dispatch({ type: DATATABLE_FILTER, payload: { ...data.filter, include: [], exclude: [], mode } });
    }, [data.filter]);
    /**
     * toggle filter whitelist selection
     */
    const toggleFilterWhitelist = React.useCallback((value) => {
        if (!data.filter) {
            return;
        }
        const values = data.filter[data.filter.mode].filter((item) => item !== value);
        if (values?.length === data.filter?.[data.filter.mode].length) {
            values?.push(value);
        }
        dispatch({ type: DATATABLE_FILTER, payload: { ...data.filter, include: [], exclude: [], [data.filter.mode]: values } });
    }, [data.filter]);
    /**
     * confirm filter
     */
    const confirmFilter = React.useCallback(() => {
        if (!data.filter) {
            return;
        }
        const filters = { ...data.metadata.filters };
        if (!data.filter.value && !data.filter.exclude.length && !data.filter.include.length) {
            delete filters[data.filter.name];
        }
        else {
            const filter = {
                ...data.filter,
                items: undefined,
                loading: undefined,
            };
            filters[data.filter.name] = filter;
        }
        dispatch({ type: DATATABLE_FILTER, payload: undefined });
        dispatch({ type: DATATABLE_METADATA, payload: { filters, page: 0 } });
    }, [data.filter, data.metadata.filters]);
    /**
     * block selected filter
     */
    // const blockFilter = useCallback(() => {
    //   const filters = { ...data.metadata.filters };
    //   filters[data.filter.name] = {
    //     type: data.filter.type,
    //     // value: data.filter.value,
    //     mode: 'include',
    //     exclude: [],
    //     include: data.filter.items,
    //   };
    //   dispatch({ type: DATATABLE_FILTER, payload: undefined });
    //   dispatch({ type: DATATABLE_METADATA, payload: { filters, page: 0 } });
    // }, [data.filter, data.metadata.filters]);
    /**
     * clear filter
     */
    const clearFilter = React.useCallback(() => {
        const filters = { ...data.metadata.filters };
        if (!!data.filter) {
            delete filters[data.filter.name];
        }
        dispatch({ type: DATATABLE_FILTER, payload: undefined });
        dispatch({ type: DATATABLE_METADATA, payload: { filters } });
    }, [data.filter, data.metadata.filters]);
    /**
     * loading
     */
    if (!data.loaded) {
        return jsxRuntime.jsx(Loader, {});
    }
    /**
     * render
     */
    const { pages, total, filtered } = data;
    const { page, size } = data.metadata;
    const pinfo = {
        start: !data.metadata.size ? Math.min(data.values.length, 1) : data.values.length ? page * size + 1 : 0,
        end: !data.metadata.size ? data.values.length : Math.min(page * size + size, filtered ?? total),
        entries: filtered ?? total,
        total,
        pages: {
            start: Math.max(Math.min(page - PAGE_OFFSET, pages - PAGE_OFFSET * 2), 0),
            end: Math.min(page + PAGE_OFFSET, pages),
        }
    };
    const sizes = [
        { label: '10', value: 10 },
        { label: '25', value: 25 },
        { label: '50', value: 50 },
        { label: t('common:datatable.all'), value: 0 },
    ];
    return (jsxRuntime.jsxs(reactNative.View, { style: styles$p.container, children: [pagination && (jsxRuntime.jsxs(reactNative.View, { style: styles$p.filter, children: [jsxRuntime.jsx(Picker, { selected: data.metadata.size ?? sizes[0].value, items: sizes, onChange: resize, defaultOptionLabel: null, containerStyle: { flex: 0, minWidth: 60, marginBottom: 0 } }), jsxRuntime.jsx(reactNative.View, { style: { flex: 1, marginLeft: 10, marginRight: 5 }, children: !source && jsxRuntime.jsx(Input, { placeholder: t('common:datatable.search'), defaultValue: data.metadata.search, onChange: search, containerStyle: { marginBottom: 0 } }) }), !source && (jsxRuntime.jsx(reactCsv.CSVLink, { data: getExcelValues(), filename: `${generate()}.csv`, style: { textDecoration: 'none' }, separator: ';', children: jsxRuntime.jsx(Icon, { type: 'text', text: 'excel', marginRight: 0 }) })), !!source && jsxRuntime.jsx(Icon, { type: 'text', text: 'excel', marginRight: 0, onPress: excel }), jsxRuntime.jsx(Icon, { type: 'text', text: t('common:datatable.visibility').toLowerCase(), marginRight: 0, onPress: toggleColumnVisibility }), jsxRuntime.jsx(Icon, { type: 'text', text: t('common:global.clear').toLowerCase(), marginRight: 0, onPress: clear }), additionalButtons.map((button, idx) => (jsxRuntime.jsx(Icon, { type: button.type, text: button.text?.toLowerCase(), marginRight: 0, onPress: button.onPress }, idx)))] })), jsxRuntime.jsxs(reactNative.View, { style: [styles$p.table, !pagination && { marginVertical: 0 }], children: [jsxRuntime.jsx(reactNative.View, { style: styles$p.thead, children: jsxRuntime.jsx(reactNative.View, { style: [styles$p.tr, { minHeight: 42, borderBottomWidth: 0 }], children: headers.map((header) => {
                                if (data.visibility.hidden?.includes(header.name)) {
                                    return null;
                                }
                                const filterable = header.filterable ?? true;
                                const sortable = header.sortable ?? true;
                                return (jsxRuntime.jsx(reactNative.TouchableWithoutFeedback, { onPress: () => sort(header), children: jsxRuntime.jsx(reactNative.View, { style: [styles$p.th, parseStyle(header.style)], children: jsxRuntime.jsxs(reactNative.View, { style: { flex: 1, flexDirection: 'row', alignItems: 'center' }, children: [jsxRuntime.jsx(reactNative.View, { style: styles$p.thText, children: jsxRuntime.jsx(Text, { bold: true, children: header.label ?? header.name }) }), jsxRuntime.jsxs(reactNative.View, { style: { position: 'relative', width: 16, justifyContent: 'center', alignItems: 'center' }, children: [jsxRuntime.jsx(Icon, { type: 'caret-up', color: !sortable ? 'transparent' : data.metadata.sort?.[header.name] === -1 ? colors.active : colors.inactive, marginRight: 0, containerStyle: { width: 12, height: 16, marginBottom: -4 }, padding: 0 }), jsxRuntime.jsx(Icon, { type: 'filter', color: !filterable ? 'transparent' : !!data.metadata?.filters?.[header.name] ? colors.active : colors.inactive, fontSize: 12, marginRight: 0, marginBottom: 0, padding: 0, onPress: () => toggleFilterVisibility(header), containerStyle: { width: 10, height: 16, alignItems: 'center', justifyContent: 'center' } }), jsxRuntime.jsx(Icon, { type: 'caret-down', color: !sortable ? 'transparent' : data.metadata.sort?.[header.name] === 1 ? colors.active : colors.inactive, marginRight: 0, containerStyle: { width: 12, height: 16, marginTop: -6 }, padding: 0 })] })] }) }) }, header.name));
                            }) }) }), jsxRuntime.jsx(reactNative.View, { style: styles$p.tbody, children: !data.values.length ? (jsxRuntime.jsx(reactNative.View, { style: { padding: 15, alignItems: 'center', justifyContent: 'center', borderWidth: 1 }, children: jsxRuntime.jsx(Text, { children: t('common:datatable.empty') }) })) : (data.values.map((object, idx) => {
                            return (jsxRuntime.jsx(reactNative.TouchableWithoutFeedback, { onPress: () => onPressRow?.(object), children: jsxRuntime.jsx(reactNative.View, { style: [styles$p.tr, { backgroundColor: idx % 2 === 0 ? context.colors.light.background : '#fff' }, getRowStyles?.(object), !!onPressRow && { cursor: 'pointer' }], onPointerEnter: () => onHoverRow?.(object), children: headers.map((header) => {
                                        if (data.visibility.hidden.includes(header.name)) {
                                            return null;
                                        }
                                        const value = header.render?.(object, idx) ?? jsxRuntime.jsx(Text, { children: header.value?.(object, idx) ?? object[header.name] });
                                        return (jsxRuntime.jsx(reactNative.View, { style: [styles$p.td, parseStyle(header.style, object, data.values)], children: value }, header.name));
                                    }) }) }, `${data.key}-${data.metadata.page}-${idx}`));
                        })) }), data.loading && (jsxRuntime.jsx(reactNative.View, { style: styles$p.loader, children: jsxRuntime.jsx(Loader, {}) }))] }), pagination && (jsxRuntime.jsxs(reactNative.View, { style: styles$p.information, children: [jsxRuntime.jsxs(reactNative.View, { style: styles$p.entries, children: [jsxRuntime.jsxs(Text, { children: ["showing ", pinfo.start, " to ", pinfo.end, " of ", pinfo.entries, " entries"] }), !!filtered && jsxRuntime.jsxs(Text, { children: [" (", pinfo.total, " total)"] })] }), jsxRuntime.jsxs(reactNative.View, { style: styles$p.pagination, children: [jsxRuntime.jsx(Icon, { type: "rotateLeft", onPress: first, textStyle: { fontWeight: 'normal' } }), jsxRuntime.jsx(Icon, { type: "arrowleft", onPress: prev, textStyle: { fontWeight: 'normal' } }), Array(Math.max(pinfo.pages.end - pinfo.pages.start + 1, 1)).fill(0).map((_value, key) => {
                                const index = key + pinfo.pages.start;
                                const selected = page === index;
                                return (jsxRuntime.jsx(Icon, { type: "text", color: selected ? '#eee' : '#333', containerStyle: { minWidth: 26, textAlign: 'center', justifyContent: 'center', alignItems: 'center', borderRadius: 3, backgroundColor: selected ? '#333' : 'transparent' }, textStyle: { fontWeight: 'normal' }, text: (index + 1) + '', fontSize: 14, onPress: () => select(index) }, index));
                            }), jsxRuntime.jsx(Icon, { type: "arrowright", onPress: next, textStyle: { fontWeight: 'normal' } }), jsxRuntime.jsx(Icon, { type: "rotateRight", onPress: last, textStyle: { fontWeight: 'normal' } })] })] })), jsxRuntime.jsx(Modal, { visible: data.visibility.open, title: t('common:datatable.visibility'), close: toggleColumnVisibility, maxWidth: 300, children: headers.map((header) => {
                    const idx = data.visibility.hidden.indexOf(header.name);
                    const isHidden = idx >= 0;
                    const toggle = () => {
                        const visibility = { ...data.visibility };
                        if (!isHidden) {
                            visibility.hidden.push(header.name);
                        }
                        else {
                            visibility.hidden = visibility.hidden.filter((name) => name !== header.name);
                        }
                        dispatch({ type: DATATABLE_VISIBILITY, payload: visibility });
                        // on visibility change callback
                        setTimeout(() => header.onVisibilityChange?.(isHidden, data.values), 4);
                    };
                    return (jsxRuntime.jsxs(reactNative.TouchableOpacity, { onPress: toggle, style: { flexDirection: 'row', alignItems: 'center', marginVertical: 5 }, children: [jsxRuntime.jsx(Icon, { type: isHidden ? 'times' : 'check', marginBottom: 0 }), jsxRuntime.jsx(Text, { strikethrough: isHidden, children: header.label })] }, header.name));
                }) }), !!data.filter && (jsxRuntime.jsxs(Modal, { visible: true, title: `${t('common:datatable.filter.title')}: ${data.filter.label}`, close: toggleFilterVisibility, maxWidth: 600, children: [jsxRuntime.jsx(Picker, { defaultOptionLabel: null, items: [{ label: t('common:datatable.filter.contains'), value: 'contains' }, { label: t('common:datatable.filter.exact'), value: 'exact' }], onChange: (value) => filterSearch.current.type = value, defaultValue: data.filter.type }), jsxRuntime.jsx(Input, { placeholder: t('common:datatable.filter.value'), onChange: (value) => filterSearch.current.value = value, defaultValue: data.filter.value, onSubmitEditing: confirmFilterSearch }), jsxRuntime.jsx(Button, { text: t('common:datatable.search'), onPress: confirmFilterSearch, containerStyle: { width: '100%' }, loading: !!data.filter.loading }), jsxRuntime.jsx(Separator, { marginBottom: 15, height: 1, backgroundColor: '#eee' }), jsxRuntime.jsxs(reactNative.View, { style: { flexDirection: 'row' }, children: [jsxRuntime.jsx(Button, { type: 'secondary', text: t('common:datatable.filter.select'), onPress: () => toggleFilterMode('exclude'), containerStyle: { flex: 1, minWidth: 0 } }), jsxRuntime.jsx(Button, { type: 'secondary', text: t('common:datatable.filter.deselect'), onPress: () => toggleFilterMode('include'), containerStyle: { flex: 1, minWidth: 0, marginLeft: 5, } })] }), jsxRuntime.jsx(reactNative.ScrollView, { style: { maxHeight: 300 }, children: data.filter.items.map((item) => {
                            const isInArray = data.filter[data.filter.mode].includes(item.value);
                            const selected = data.filter.mode === 'exclude' && !isInArray || data.filter.mode === 'include' && isInArray;
                            return (jsxRuntime.jsx(Checkbox, { label: item.label, value: selected, onChange: () => toggleFilterWhitelist(item.value), marginLeft: 2 }, item.value));
                        }) }), jsxRuntime.jsxs(reactNative.View, { style: { flexDirection: 'row' }, children: [jsxRuntime.jsx(Button, { text: t('common:global.accept'), onPress: confirmFilter, marginBottom: 0, containerStyle: { flex: 1, minWidth: 0 } }), jsxRuntime.jsx(Button, { type: 'secondary', text: t('common:global.clear'), onPress: clearFilter, marginBottom: 0, containerStyle: { flex: 1, minWidth: 0, marginLeft: 5 } })] })] }))] }));
};
/**
 * debounce
 * @param func
 * @param ms
 * @returns
 */
const debounce = (func, ms = 300) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, ms);
    };
};
/**
 * sort datatable
 * @param criteria
 * @param a
 * @param b
 * @param index
 * @returns
 */
const sortDT = ((headers, criteria, a, b, index) => {
    const key = Object.keys(criteria)[index];
    if (!key) {
        return 0;
    }
    const header = headers.find((header) => header.name === key);
    const dir = criteria[key];
    let v1 = '';
    let v2 = '';
    // if(!header.hidden) {
    v1 = header?.sort?.(a) ?? header?.value?.(a, index) ?? a?.[key];
    v2 = header?.sort?.(b) ?? header?.value?.(b, index) ?? b?.[key];
    if (v1 !== undefined && v2 === undefined) {
        return 1 * dir;
    }
    if (v1 === undefined && v2 !== undefined) {
        return -1 * dir;
    }
    v1 += '';
    v2 += '';
    if (/^-?[0-9]*.?[0-9]*?$/.test(v1) && /^-?[0-9]*.?[0-9]*?$/.test(v2) && v1 !== v2) {
        return (parseInt(v1) - parseInt(v2)) * dir;
    }
    // }
    return (v1.localeCompare(v2) * dir) || sortDT(headers, criteria, a, b, index + 1);
});
/**
 * parse header style
 * @param style
 * @returns
 */
const parseStyle = (style = {}, object = {}, objects = []) => {
    if (typeof style === 'function') {
        style = style(object, objects);
    }
    return {
        ...style,
        width: style.width,
        maxWidth: style.width,
        minWidth: style.width,
        flex: !!style.width ? 0 : style.flex,
    };
};
// const normalize = (value: string) => value.normalize('NFD').replace(/\p{Diacritic}/gu, '');
const styles$p = reactNative.StyleSheet.create({
    container: {},
    filter: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    table: {
        marginVertical: 10,
    },
    thead: {
        backgroundColor: '#FFF',
        borderTopWidth: 1,
        borderBottomWidth: 1,
        position: "sticky",
        top: 0,
        zIndex: 1
    },
    tbody: {},
    tr: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        minHeight: 36,
        // height: '100%',
        // alignItems: 'center',
    },
    th: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'white',
        padding: 5,
        paddingVertical: 10,
        borderRightWidth: 1,
        borderColor: '#333',
        // height: '100%',
        cursor: 'pointer',
        justifyContent: 'center',
    },
    thText: {
        flex: 1,
    },
    td: {
        flex: 1,
        paddingHorizontal: 5,
        paddingVertical: 10,
        borderRightWidth: 1,
        borderColor: '#333',
        justifyContent: 'center',
    },
    loader: {
        position: 'absolute',
        backgroundColor: '#fffffff0',
        borderRadius: 10,
        top: 15,
        alignSelf: 'center',
    },
    information: {
        flexDirection: 'row',
    },
    entries: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    pagination: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
    },
});

const START_DATE_ENTRY_TYPE = 1;
const END_DATE_ENTRY_TYPE = 2;
const DateTimePicker = ({ error, minDate = undefined, label, flexDirection = 'column', startDateValue = undefined, endDateValue = undefined, disabled = false, range = false, format = "DD-MM-YYYY", onChange = () => { }, showLabels = true, containerStyle, showDate = true, showTime = true, flex = -1, gap = (flexDirection == 'column' ? 0 : 5) }) => {
    // Guarda la fecha seleccionada en el componente de calendario
    const [pickerDate, setPickerDate] = React__namespace.useState(null);
    // Guarda la fecha seleccionada al abrir un modal de seleccion de fecha/hora
    const [selectedDate, setSelectedDate] = React__namespace.useState(null);
    // Guarda la hora seleccionada en el selector de horas del modal
    const [selectedHour, setSelectedHour] = React__namespace.useState(null);
    // Guarda el minuto seleccionado en el selector de minutos del modal
    const [selectedMin, setSelectedMin] = React__namespace.useState(null);
    // Guarda la última seleccion que se haya hecho de la fecha inicial
    const [selectedStartDate, setSelectedStartDate] = React__namespace.useState(null);
    // Guarda la ultima seleccion que se haya hecho de la fecha final
    const [selectedEndDate, setSelectedEndDate] = React__namespace.useState(null);
    const [entryType, setEntryType] = React__namespace.useState(0);
    const [open, setOpen] = React__namespace.useState(false);
    const [showStartDateValue, setShowStartDateValue] = React__namespace.useState(true);
    const [showEndDateValue, setShowEndDateValue] = React__namespace.useState(true);
    // Contador para forzar el refresco del calendario al modificar los selectores de mes/año del modal
    const [monthChange, setMonthChange] = React__namespace.useState(0);
    const context = React__namespace.useContext(OWCContext);
    let itemsMin = [];
    let itemsHours = [];
    let itemsYears = [];
    let itemsMonth = [];
    let weekDays = [t('common:dateShort.monday'),
        t('common:dateShort.tuesday'),
        t('common:dateShort.wednesday'),
        t('common:dateShort.thursday'),
        t('common:dateShort.friday'),
        t('common:dateShort.saturday'),
        t('common:dateShort.sunday')];
    /** En caso de modificar las prop de entrada, inicializar los valores seleccionados*/
    React__namespace.useEffect(() => {
        setShowStartDateValue(true);
        setShowEndDateValue(true);
        setSelectedStartDate(null);
        setSelectedEndDate(null);
    }, [startDateValue, endDateValue]);
    const changePickerDateMonth = (direction) => {
        const newDate = (direction === '+1' ? pickerDate.add(1, 'months') : pickerDate.subtract(1, 'months'));
        updateCalendarComponent(newDate);
    };
    const updateCalendarComponent = (newDate) => {
        setPickerDate(newDate.date(1)); // Poner seleccionado el dia 1
        setSelectedDate(newDate.date(1));
        setMonthChange(monthChange + 1);
    };
    const onChangeYear = (value) => {
        updateCalendarComponent(pickerDate.year(value));
    };
    const onChangeMonth = (value) => {
        updateCalendarComponent(pickerDate.month(value));
    };
    /**
       *
       Abre el modal para seleccion de fecha y hora.
       Inicializa con la fecha que corresponda segun si se abre para la fecha inicial o la final
       */
    const openModal = (entryType) => {
        const m = (entryType === START_DATE_ENTRY_TYPE ? getDateForModal(selectedStartDate, startDateValue) : getDateForModal(selectedEndDate, endDateValue));
        setEntryType(entryType);
        // Es fan els moment per crear instàncies diferents del moment a aplicar, perque si no al canviar un canvien tots...
        setPickerDate(!!m ? moment(m) : moment());
        setSelectedDate(!!m ? moment(m) : moment());
        setSelectedHour(!!m ? moment(m).hour() : undefined);
        setSelectedMin(!!m ? moment(m).minute() : undefined);
        setOpen(true);
    };
    /**
     *
     * Devuelve la fecha seleccionada en función de si ha habido ya una seleccion de fecha o si
     * no la hay
     */
    const getDateForModal = (selectedDate, initialDateValue) => {
        if (!!selectedDate) {
            return selectedDate;
        }
        if (!!initialDateValue) {
            return moment(initialDateValue);
        }
        return undefined;
    };
    /**
     *
     Seleccion de fecha en el selector de fecha. Se informa la fecha elegida y si
     solo se muestra la fecha se envia evento directamente
     */
    const onChangeDate = (val) => {
        setSelectedDate(moment(val));
        setPickerDate(moment(val));
        if (!showTime) {
            endDateSelection(moment(val));
        }
    };
    /**
     *
     * finaliza la entrada de fecha. Puede recibir la fecha seleccionada del metodo onChangeDate o sin parametro
     * des de el boton de aceptar del modal.
     */
    const endDateSelection = (_selectedDate) => {
        const newDate = (!!_selectedDate ? _selectedDate : selectedDate);
        if (entryType === START_DATE_ENTRY_TYPE) {
            newDate.set({ hour: selectedHour || 0, minute: selectedMin || 0 });
            setSelectedStartDate(newDate);
            setShowStartDateValue(false);
            onChange({ startDate: newDate.format(format), startDateSQL: newDate.format('YYYY-MM-DD'), endDate: getEndDateForEvent() });
        }
        else {
            newDate.set({ hour: selectedHour || 23, minute: selectedMin || 59 });
            setSelectedEndDate(newDate);
            setShowEndDateValue(false);
            onChange({ startDate: getStartDateForEvent(), endDate: newDate.format(format) });
        }
        setOpen(false);
    };
    const getStartDateForEvent = () => {
        if (!selectedStartDate && !startDateValue) {
            return undefined;
        }
        return !!selectedStartDate ? selectedStartDate.format(format) : moment(startDateValue).format(format);
    };
    /**
     *
     * @returns Devuelve la fecha de final en caso de lanzar evento por un cierre del modal de seleccion de la inicial
     * Si no hay final seleccionada ni valor de inicializacion --> undefined.
     * En caso contrario, devuelve la seleccionada o la inicial
     */
    const getEndDateForEvent = () => {
        if (!selectedEndDate && !endDateValue) {
            return undefined;
        }
        return !!selectedEndDate ? selectedEndDate.format(format) : moment(endDateValue).format(format);
    };
    /**
     *
     Monta el string para visualizar la fecha seleccionada
     * @returns
     */
    const getLabelDate = (entryType) => {
        if (entryType === START_DATE_ENTRY_TYPE) {
            if (showStartDateValue) {
                return formatDateLabel(!!startDateValue ? moment(startDateValue) : undefined);
            }
            else {
                return formatDateLabel(selectedStartDate);
            }
        }
        else {
            if (showEndDateValue) {
                return formatDateLabel(!!endDateValue ? moment(endDateValue) : undefined);
            }
            else {
                return formatDateLabel(selectedEndDate);
            }
        }
    };
    const formatDateLabel = (labelDate) => {
        if (!!labelDate) {
            const dateFmt = showDate ? labelDate.format("DD/MM/YYYY") + ' ' : '';
            const hourFmt = showTime ? labelDate.format("HH:mm") : '';
            return dateFmt + hourFmt;
        }
        else {
            const litDate = showDate ? t('common:dateTimePicker.dateLabel') + ' ' : '';
            const litTime = showTime ? t('common:dateTimePicker.timeLabel') : '';
            return litDate + litTime;
        }
    };
    // geenramos minutos
    for (var u = 0; u <= 59; u++) {
        itemsMin.push({ label: pad(u), value: u });
    }
    // geenramos horas
    for (var c = 0; c <= 23; c++) {
        itemsHours.push({ label: pad(c), value: c });
    }
    // geenramos años
    for (var m = new Date().getFullYear() - 90; m < new Date().getFullYear(); m++) {
        itemsYears.push({ label: pad(m), value: m });
    }
    for (var k = new Date().getFullYear(); k <= new Date().getFullYear() + 30; k++) {
        itemsYears.push({ label: pad(k), value: k });
    }
    const year = new Date().getFullYear();
    // geenramos meses
    for (var y = 1; y <= 12; y++) {
        const dateForMonth = moment([year, y - 1, 1]).format('YYYY-MM-DD');
        itemsMonth.push({ label: getMonth(dateForMonth), value: y - 1 });
    }
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$o.container, containerStyle], children: [jsxRuntime.jsxs(reactNative.View, { style: { width: '100%', flexDirection: flexDirection, gap: gap }, children: [jsxRuntime.jsxs(reactNative.View, { style: { flex: flex }, children: [showLabels && jsxRuntime.jsx(reactNative.View, { style: [styles$o.labelbox, { marginTop: 0 }], children: jsxRuntime.jsx(Text, { style: [styles$o.label, error ? styles$o.labelError : undefined], children: label ?? t('common:dateTimePicker.initialdate') }) }), jsxRuntime.jsx(reactNative.View, { style: { display: 'flex', flexDirection: 'row' }, children: jsxRuntime.jsx(reactNative.View, { style: { flex: 1 }, children: jsxRuntime.jsx(reactNative.TouchableOpacity, { disabled: disabled, onPress: () => openModal(START_DATE_ENTRY_TYPE), children: jsxRuntime.jsx(Input, { disabled: disabled, containerStyle: { marginBottom: 0 }, value: getLabelDate(START_DATE_ENTRY_TYPE) }) }) }) })] }), range ?
                        jsxRuntime.jsxs(reactNative.View, { style: { flex: flex }, children: [showLabels && jsxRuntime.jsx(reactNative.View, { style: [styles$o.labelbox], children: jsxRuntime.jsx(Text, { style: [styles$o.label, error ? styles$o.labelError : undefined], children: t('common:dateTimePicker.finaldate') }) }), jsxRuntime.jsx(reactNative.View, { style: { display: 'flex', flexDirection: 'row' }, children: jsxRuntime.jsx(reactNative.View, { style: { flex: 1 }, children: jsxRuntime.jsx(reactNative.TouchableOpacity, { disabled: disabled, onPress: () => openModal(END_DATE_ENTRY_TYPE), children: jsxRuntime.jsx(Input, { disabled: disabled, containerStyle: { marginBottom: 0 }, value: getLabelDate(END_DATE_ENTRY_TYPE) }) }) }) })] })
                        : null] }), jsxRuntime.jsx(Text, { style: [styles$o.textError], children: error }), jsxRuntime.jsx(Modal, { maxWidth: 300, header: false, visible: !!open, children: jsxRuntime.jsxs(reactNative.View, { style: { width: "100%" }, children: [showDate && (jsxRuntime.jsxs(reactNative.View, { children: [jsxRuntime.jsxs(reactNative.View, { style: { flexDirection: 'row', marginBottom: 15 }, children: [jsxRuntime.jsx(reactNative.View, { style: { flex: 1, justifyContent: 'center' }, children: jsxRuntime.jsx(Button, { text: "\u00AB", onPress: () => changePickerDateMonth('-1'), marginBottom: 0, containerStyle: { minWidth: 0 } }) }), jsxRuntime.jsx(reactNative.View, { style: { flex: 3, marginRight: 1 }, children: jsxRuntime.jsx(Picker, { marginBottom: 0, selected: !!pickerDate ? pickerDate.month() : moment().month(), onChange: (val) => onChangeMonth(val), items: itemsMonth, clearable: false }) }), jsxRuntime.jsx(reactNative.View, { style: { flex: 2 }, children: jsxRuntime.jsx(Picker, { marginBottom: 0, selected: !!pickerDate ? pickerDate.year() : moment().year(), onChange: (val) => onChangeYear(val), items: itemsYears, clearable: false }) }), jsxRuntime.jsx(reactNative.View, { style: { flex: 1, justifyContent: 'center', alignItems: 'flex-end' }, children: jsxRuntime.jsx(Button, { text: "\u00BB", onPress: () => changePickerDateMonth('+1'), marginBottom: 0, containerStyle: { minWidth: 0 } }) })] }), jsxRuntime.jsx(reactNative.View, { children: jsxRuntime.jsx(reactNative.View, { style: styles$o.calendarContent, children: jsxRuntime.jsx(reactNative.View, { children: jsxRuntime.jsx(reactNativeCalendario.Calendar, { disableRange: true, onPress: (range) => onChangeDate(range), minDate: minDate, startDate: !!pickerDate ? pickerDate.toDate() : new Date(), startingMonth: (!!pickerDate ? moment(pickerDate) : moment()).format("YYYY-MM-DD"), numberOfMonths: 1, showMonthTitle: false, dayNames: weekDays, showWeekdays: true, firstDayMonday: true, monthHeight: 330, theme: {
                                                    monthTitleTextStyle: {
                                                        fontWeight: "bold",
                                                        fontSize: 16,
                                                    },
                                                    emptyMonthContainerStyle: {
                                                        display: 'none'
                                                    },
                                                    weekColumnsContainerStyle: {},
                                                    dayTextStyle: {
                                                        color: "#2d4150",
                                                        fontWeight: "200",
                                                        fontSize: 15,
                                                    },
                                                    todayTextStyle: {
                                                        color: "#000000",
                                                        fontWeight: "600"
                                                    },
                                                    activeDayContainerStyle: {
                                                        backgroundColor: context.colors.primary.background, // context
                                                    },
                                                    activeDayTextStyle: {
                                                        color: context.colors.primary.text, // context
                                                    },
                                                } }) }) }) })] })), showTime && (jsxRuntime.jsxs(reactNative.View, { style: { flexDirection: 'row', marginTop: 5 }, children: [jsxRuntime.jsx(reactNative.View, { style: { flex: 1 }, children: jsxRuntime.jsx(Picker, { marginBottom: 0, label: t('common:dateTimePicker.hour'), disabled: disabled, defaultValue: selectedHour, defaultOptionLabel: '--', onChange: (val) => setSelectedHour(val), items: itemsHours }) }), jsxRuntime.jsx(reactNative.View, { style: { flex: 1, marginLeft: 5 }, children: jsxRuntime.jsx(Picker, { marginBottom: 0, label: t('common:dateTimePicker.min'), disabled: disabled, defaultValue: selectedMin, defaultOptionLabel: '--', onChange: (val) => setSelectedMin(val), items: itemsMin }) })] })), jsxRuntime.jsxs(reactNative.View, { style: styles$o.modalButtons, children: [jsxRuntime.jsx(Button, { marginBottom: 0, type: 'secondary', text: t('global.cancel'), onPress: () => setOpen(false), containerStyle: { flex: 1, minWidth: 0 } }), showTime && (jsxRuntime.jsx(Button, { marginBottom: 0, type: 'primary', text: t('common:dateTimePicker.apply'), onPress: () => endDateSelection(selectedDate), containerStyle: { flex: 1, marginLeft: 5, minWidth: 0 } }))] })] }) })] }));
};
const styles$o = reactNative.StyleSheet.create({
    container: {
        marginBottom: 15,
    },
    calendarContent: {
        minHeight: 250,
        overflow: "hidden"
    },
    month: {
        textAlign: 'center',
        padding: 8,
        fontWeight: 700,
        textTransform: 'uppercase'
    },
    labelbox: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    label: {
        paddingLeft: 10,
        marginBottom: 5,
        color: '#333',
    },
    labelError: {
        color: 'crimson',
    },
    textError: {
        //  fontSize: 12,
        paddingLeft: 10,
        color: 'crimson',
    },
    legendDay: {
        flex: 1,
        textAlign: "center"
    },
    contentLegendDays: {
        flexDirection: 'row',
    },
    modalButtons: {
        flexDirection: 'row',
        marginTop: 15,
        justifyContent: 'center',
        flex: 1
    }
});

const Doughnut = ({ title, size = 200, amount, total, containerStyle, colors: propColors, representative = true }) => {
    const context = React__namespace.useContext(OWCContext);
    const fontSize = size / 100 * 13.7;
    const percentage = Math.floor(total === 0 ? 0 : amount / total * 100);
    const innerSize = size * 0.8;
    const colors = propColors || { primary: context.colors.primary.background, secondary: '#B0B0B0' };
    /**
     *
     */
    const slice = (radius, value) => {
        const x = radius - Math.cos((2 * Math.PI) / (100 / value)) * radius;
        const y = radius + Math.sin((2 * Math.PI) / (100 / value)) * radius;
        const long = (value <= 50) ? 0 : 1;
        return `M${radius},${radius} L${radius},${0} A${radius},${radius} 0 ${long},1 ${y},${x} Z`;
    };
    /**
     *
     */
    if (representative === false) {
        return (jsxRuntime.jsx(reactNative.View, { style: [styles$n.container, containerStyle, { width: size, height: size }], children: jsxRuntime.jsxs(reactNative.View, { style: [styles$n.textContainer, { width: size, height: size }], children: [title && jsxRuntime.jsx(Text, { bold: true, fontSize: fontSize, children: title }), jsxRuntime.jsx(Text, { fontSize: title ? fontSize : fontSize + 3, children: total })] }) }));
    }
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$n.container, containerStyle, { width: size, height: size }], children: [jsxRuntime.jsxs(reactNativeSvg.Svg, { width: size + 1, height: size + 1, children: [jsxRuntime.jsx(reactNativeSvg.Circle, { cx: size / 2, cy: size / 2, r: size / 2, fill: total === 0 ? '#eee' : percentage !== 100 ? colors.secondary : colors.primary }), jsxRuntime.jsx(reactNativeSvg.Path, { d: slice(size / 2, percentage), fill: colors.primary }), jsxRuntime.jsx(reactNativeSvg.Circle, { cx: size / 2, cy: size / 2, r: innerSize / 2, fill: 'white' })] }), jsxRuntime.jsxs(reactNative.View, { style: [styles$n.textContainer, { width: size, height: size }], children: [title && jsxRuntime.jsx(Text, { bold: true, fontSize: fontSize, children: title }), jsxRuntime.jsx(Text, { bold: true, fontSize: title ? fontSize + 3 : fontSize + 6, children: !!total ? `${percentage}%` : '-' }), jsxRuntime.jsxs(Text, { fontSize: title ? fontSize : fontSize + 3, children: [amount, "/", total] })] })] }));
};
const styles$n = reactNative.StyleSheet.create({
    container: {
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
    },
    textContainer: {
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

const DraggableListItem = props => {
    const itemRef = React.useRef(null);
    const currentXYfirefox = React.useRef({ x: 0, y: 0 });
    useComponentDidMount(() => {
        // @ts-ignore
        // workaround for ondrag bug in firefox https://bugzilla.mozilla.org/show_bug.cgi?id=505521
        const isFirefox = typeof InstallTrigger !== 'undefined';
        isFirefox && document.addEventListener("dragover", (e) => {
            currentXYfirefox.current = {
                x: e.clientX || e.pageX,
                y: e.clientY || e.pageY
            };
        });
    });
    const onDragStart = (e) => {
        // remove default drag ghost
        e.dataTransfer.effectedAllowed = 'move';
        e.dataTransfer.setDragImage(e.target, 50000, 50000);
        // custom drag ghost
        let ghostNode = e.target.cloneNode(true);
        ghostNode.style.position = "absolute";
        // show ghost add mouse pointer position
        ghostNode.style.top = (e.pageY - e.target.offsetHeight / 2) + 'px';
        ghostNode.style.left = (e.pageX - e.target.offsetWidth / 2) + 'px';
        // add width height to ghost node
        ghostNode.style.height = e.target.offsetHeight + 'px';
        ghostNode.style.width = e.target.offsetWidth + 'px';
        // add some style
        ghostNode.style.opacity = '0.8';
        ghostNode.style.pointerEvents = 'none';
        // add id
        ghostNode.id = 'ghostNode';
        document.body.prepend(ghostNode);
        // identify selected item
        itemRef.current.classList.add('dragstart');
        if (props.onDragStart) {
            props.onDragStart(props.index);
        }
    };
    // event when dragging
    const onDrag = (e) => {
        // move ghost node with mouse
        let ghostNode = document.querySelector('#ghostNode');
        // @ts-ignore
        ghostNode.style.top = ((e.pageY || currentXYfirefox.current.y) - e.target.offsetHeight / 2) + 'px';
        // @ts-ignore
        ghostNode.style.left = ((e.pageX || currentXYfirefox.current.x) - e.target.offsetWidth / 2) + 'px';
    };
    // event when drag end
    const onDragEnd = () => {
        // remove ghost node
        document.querySelector('#ghostNode')?.remove();
        // remove selected item style
        itemRef.current.classList.remove('dragstart');
    };
    // event when drag over item
    const onDragEnter = () => itemRef?.current.classList.add('dragover');
    // event when drag leave item
    const onDragLeave = () => itemRef.current.classList.remove('dragover');
    // add event for item can drop
    const onDragOver = (e) => e.preventDefault();
    // event when drop
    const onDrop = () => {
        itemRef.current.classList.remove('dragover');
        props.onDrop(props.index);
    };
    return (jsxRuntime.jsx("li", { ref: itemRef, style: { cursor: 'all-scroll' }, className: "draggable-list__item", draggable: props.draggable !== undefined ? props.draggable : true, onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd, onDragEnter: onDragEnter, onDragLeave: onDragLeave, onDragOver: onDragOver, onDrop: onDrop, children: props.children }));
};
DraggableListItem.propTypes = {
    draggable: PropTypes.bool,
    index: PropTypes.number,
    onDragStart: PropTypes.func,
    onDrop: PropTypes.func,
    children: PropTypes.any
};

const DraggableList = ({ internalState = true, ...props }) => {
    const [data, setdata] = React.useState(props.data);
    const [dragStartIndex, setdragStartIndex] = React.useState(0);
    const dataToUse = internalState ? data : props.data;
    // get index of draged item
    const onDragStart = (index) => setdragStartIndex(index);
    // update list when item dropped
    const onDrop = (dropIndex) => {
        // get draged item
        const dragItem = dataToUse[dragStartIndex];
        // delete draged item in list
        let list = [...dataToUse];
        list.splice(dragStartIndex, 1);
        // update list
        let dataSetter = [];
        if (dragStartIndex < dropIndex && internalState) {
            dataSetter = [
                ...list.slice(0, dropIndex - 1),
                dragItem,
                ...list.slice(dropIndex - 1, list.length)
            ];
        }
        else {
            dataSetter = [
                ...list.slice(0, dropIndex),
                dragItem,
                ...list.slice(dropIndex, list.length)
            ];
        }
        setdata(dataSetter);
        props.handleDrop(dataSetter, dragItem, dragStartIndex, dropIndex);
    };
    return (jsxRuntime.jsxs("ul", { className: "draggable-list", children: [dataToUse.map((item, index) => (jsxRuntime.jsx(DraggableListItem, { index: index, onDragStart: (index) => onDragStart(index), onDrop: (index) => onDrop(index), children: props.renderItemContent(item) }, index))), jsxRuntime.jsx(DraggableListItem, { index: dataToUse.length, draggable: false, onDrop: (index) => onDrop(index) }, dataToUse.length)] }));
};
DraggableList.propTypes = {
    data: PropTypes.array,
    renderItemContent: PropTypes.func,
    handleDrop: PropTypes.func,
    internalState: PropTypes.bool
};

const styles$m = reactNative.StyleSheet.create({
    container: {
        marginBottom: 15,
    },
    containerLabel: {
        paddingHorizontal: 10,
        marginTop: 10,
        marginBottom: 10
    },
    boxContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: "row",
    },
    buttonBox: {
        width: 100,
        justifyContent: "center",
        alignItems: "center",
        marginHorizontal: 15,
    },
    buttonLine: {
        flexDirection: 'row'
    },
    labelbox: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 5,
    },
    labelboxText: {
        fontSize: 14,
    },
    listContainer: {
        /*flexDirection: "column",*/
        /*justifyContent: "flex-start",*/
        /*backgroundColor: "lightgrey",*/
        height: 400,
        width: '100%',
        // paddingHorizontal: 3,
        borderWidth: 1,
        borderColor: '#ccc',
        backgroundColor: 'white'
    },
    element: {
        // marginVertical: 2,
        borderBottomWidth: 1,
        borderColor: '#eee',
        width: '100',
        minHeight: 34,
        padding: 5,
        justifyContent: 'center',
    },
    buttons: {
        flexDirection: 'row',
    },
    button: {
        flex: 1,
    },
    buttonFirst: {
        marginRight: 5,
    },
});

const ListBox = ({ data = [], label = '', clicked = () => { }, buttons = [] }) => {
    const context = React__namespace.useContext(OWCContext);
    const [filtered, setFiltered] = React__namespace.useState(data);
    const search = React__namespace.useRef('');
    /**
     * on change data
     */
    React__namespace.useEffect(() => {
        filter(search.current);
    }, [data]);
    /**
     * filter
     */
    const filter = React__namespace.useCallback((value) => {
        search.current = value;
        if (!value) {
            setFiltered(data);
        }
        else {
            setFiltered(data.filter((object) => object.label?.toLowerCase().includes(value?.toLowerCase())));
        }
    }, [data]);
    /**
     * render
     */
    return (jsxRuntime.jsxs(reactNative.SafeAreaView, { children: [!!label && (jsxRuntime.jsx(reactNative.View, { style: styles$m.labelbox, children: jsxRuntime.jsx(Text, { style: styles$m.labelboxText, children: label }) })), jsxRuntime.jsx(Input, { placeholder: t('common:dualList.search'), defaultValue: search.current, onChange: filter }), jsxRuntime.jsx(reactNative.View, { style: styles$m.buttons, children: buttons.map((button, idx) => jsxRuntime.jsx(Button, { text: button.label, onPress: button.onPress, disabled: button.disabled, containerStyle: [styles$m.button, idx == 0 && styles$m.buttonFirst], marginBottom: 5 }, idx)) }), jsxRuntime.jsx(reactNative.ScrollView, { style: styles$m.listContainer, children: filtered.map((elem) => (jsxRuntime.jsx(reactNative.TouchableOpacity, { style: [styles$m.element, { backgroundColor: elem.selected && context?.colors['primary']?.background || 'white' }], onPress: () => clicked(elem.value), children: jsxRuntime.jsx(Text, { children: elem.label }) }, elem.value))) })] }));
};

const DualListBox = ({ list = [], selected = [], onChange = (_allSelected, _justMoved, _actionType) => { }, containerStyle = {}, containerLabel = '', label = t('common:dualList.elements'), selectedLabel = t('common:dualList.selected'), disabled = false }) => {
    const [leftList, setLeftList] = React__namespace.useState([]);
    const [rightList, setRightList] = React__namespace.useState([]);
    /**
     * on change element list or selected list
     */
    React__namespace.useEffect(() => {
        setRightList(selected);
        setLeftList(list.filter((e) => !selected.some((n) => n.value === e.value)));
    }, [list, selected]);
    /**
     * on highlight left element
     */
    const onHighlightLeft = React__namespace.useCallback((value) => {
        let aux = [...leftList];
        const element = aux.find((elem) => elem.value === value);
        if (!!element) {
            element.selected = !element.selected;
        }
        setLeftList(aux);
    }, [leftList]);
    /**
     * on highlight right element
     */
    const onHighlightRight = React__namespace.useCallback((value) => {
        let aux = [...rightList];
        const element = aux.find((elem) => elem.value === value);
        if (!!element) {
            element.selected = !element.selected;
        }
        setRightList(aux);
    }, [rightList]);
    /**
     * on select (right arrow press)
     */
    const select = React__namespace.useCallback(() => {
        const toMove = leftList.filter((element) => !!element.selected).map((element) => ({ ...element, selected: false }));
        if (!toMove?.length) {
            return;
        }
        onChange([
            ...rightList,
            ...toMove,
        ], toMove, "selected");
    }, [leftList, rightList]);
    /**
     * on deselect (left arrow press)
     */
    const unselect = React__namespace.useCallback(() => {
        if (!rightList?.filter((element) => !!element.selected)?.length) {
            return;
        }
        onChange(rightList.filter((element) => !element.selected), rightList.filter((element) => !!element.selected), "unselected");
    }, [rightList]);
    /**
     * on select all
     */
    const selectAll = React__namespace.useCallback(() => {
        if (!leftList?.length) {
            return;
        }
        onChange([
            ...leftList.map((element) => ({ ...element, selected: false })),
            ...rightList.map((element) => ({ ...element, selected: false }))
        ], leftList, "selected");
    }, [leftList, rightList]);
    /**
     * on deselect all
     */
    const unselectAll = React__namespace.useCallback(() => {
        if (!rightList?.length) {
            return;
        }
        onChange([], rightList, "unselected");
    }, [rightList]);
    /**
     * render
     */
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$m.container, containerStyle], children: [!!containerLabel && jsxRuntime.jsx(Title, { size: "xsmall", text: containerLabel }), jsxRuntime.jsxs(reactNative.View, { style: styles$m.boxContainer, children: [jsxRuntime.jsx(reactNative.View, { style: { flex: 1, marginRight: 5 }, children: jsxRuntime.jsx(ListBox, { data: leftList, label: label, clicked: onHighlightLeft, buttons: [
                                { label: t('common:dualList.addAll') + ' ⇉', disabled, onPress: selectAll },
                                { label: t('common:dualList.addSelected') + ' →', disabled, onPress: select },
                            ] }) }), jsxRuntime.jsx(reactNative.View, { style: { flex: 1 }, children: jsxRuntime.jsx(ListBox, { data: rightList, label: selectedLabel, clicked: onHighlightRight, buttons: [
                                { label: '← ' + t('common:dualList.removeSelected'), disabled, onPress: unselect },
                                { label: '⇇ ' + t('common:dualList.removeAll'), disabled, onPress: unselectAll },
                            ] }) })] })] }));
};

const Feedback = ({ text }) => {
    return (jsxRuntime.jsx(reactNative.View, { children: jsxRuntime.jsx(Text, { style: { fontSize: 16, margin: 10 }, children: text }) }));
};

const styles$l = reactNative.StyleSheet.create({
    labelbox: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    container: {
        marginBottom: 15,
    },
    label: {
        paddingLeft: 10,
        marginBottom: 5,
        color: '#333',
    },
    labelError: {
        color: 'crimson',
    },
    inputContainer: {
        //  padding: 5,
        width: '100%',
        backgroundColor: 'white',
        flexDirection: 'row',
    },
    inputContainerError: {
        borderColor: 'crimson',
        shadowColor: 'crimson',
    },
    button: {
        marginBottom: 0,
        minWidth: 200,
        width: 'auto',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    text: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: 5,
    },
    textError: {
        // fontSize: 12,
        // paddingLeft: 10,
        color: 'crimson',
    },
});

const FileButton = React__namespace.forwardRef(({ disabled = false, label, error, containerStyle, onChange = () => { }, extensions = ['pdf', 'jpg', 'jpeg', 'png'], maxSize = 2 * 1024 * 1024, loading = false, backgroundColor }, ref) => {
    const [internalError, setInternalError] = React__namespace.useState(null);
    const [file, setFile] = React__namespace.useState(null);
    const inputRef = React__namespace.useRef(null);
    /**
     * expose methods
     */
    React__namespace.useImperativeHandle(ref, () => ({
        clickFile,
    }));
    /**
     * trigger click
     */
    const clickFile = () => {
        !disabled && inputRef.current.click();
    };
    /**
     * handle change
     */
    const handleChange = (event) => {
        const _file = event?.target?.files[0];
        //controlamos que el user haya puesto algún fichero
        if (!_file) {
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const name = _file?.name;
            const extension = name?.split('.').pop();
            const result = reader?.result;
            const base64 = result?.substring(result.indexOf(',') + 1);
            const size = _file?.size;
            const file = _file;
            let _internalError = null;
            let object = {
                result,
                base64,
                name,
                extension,
                size,
                file
            };
            if (extensions.length && !extensions.includes(extension?.toLowerCase())) {
                _internalError = t('common:fileButton.invalidExtension', { validExtensions: extensions.join(', ') });
                object = null;
            }
            else if (!!maxSize && size > maxSize) {
                _internalError = t('common:fileButton.invalidSize') + ' (' + maxSize / 1024 / 1024 + 'Mb)';
                object = null;
            }
            setInternalError(_internalError);
            onChange(object);
            setFile(object);
        };
        reader.onerror = (err) => {
            setFile(null);
            throw err;
        };
        reader.readAsDataURL(_file);
    };
    /**
     * open selected file
     */
    const open = () => {
        if (!file) {
            return;
        }
        if (reactNative.Platform.OS === 'web') {
            window.open(file.result);
        }
    };
    /**
     * render
     */
    let iconContainerStyles = iconStyles.view;
    if (!file) {
        iconContainerStyles = { ...iconContainerStyles, ...iconStyles.disabled };
    }
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$l.container, containerStyle], children: [!!label && (jsxRuntime.jsx(reactNative.View, { style: styles$l.labelbox, children: jsxRuntime.jsx(Text, { style: [styles$l.label, error || internalError ? styles$l.labelError : undefined], children: label }) })), jsxRuntime.jsx("input", { onChange: handleChange, type: 'file', ref: inputRef, style: { display: 'none' } }), jsxRuntime.jsxs(reactNative.View, { style: [styles$l.inputContainer, error || internalError ? styles$l.inputContainerError : undefined, { backgroundColor: backgroundColor || styles$l.inputContainer.backgroundColor }], children: [jsxRuntime.jsx(Icon, { type: 'eye', onPress: open, borderWidth: 1, color: !file ? '#ddd' : '', containerStyle: iconContainerStyles }), jsxRuntime.jsx(Button, { type: 'primary', text: t('common:fileButton.selectDocument'), onPress: clickFile, containerStyle: styles$l.button, disabled: disabled, loading: loading }), jsxRuntime.jsx(Text, { style: styles$l.text, children: file?.name || '' })] }), jsxRuntime.jsx(Text, { style: [styles$l.textError], children: error || internalError })] }));
});
const iconStyles = {
    view: {
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 0,
        width: 40,
        height: 40,
        backgroundColor: '#eee',
        borderColor: '#ccc',
    },
    disabled: {
        cursor: 'not-allowed',
    },
};

const FloatingBox = ({ children, position = {}, maximizedPosition, visibility }) => {
    if (!visibility) {
        return jsxRuntime.jsx(reactNative.View, {});
    }
    return (jsxRuntime.jsx(reactNative.View, { style: [styles$k.container, maximizedPosition || position], children: children }));
};
const styles$k = {
    container: {
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
};

const styles$j = reactNative.StyleSheet.create({
    margin: {
        margin: 10
    },
    text: {
        fontSize: 16
    },
    row: {
        flexDirection: "row"
    }
});

const Header = ({ nav, children, backgroundColor = "#1fc8db", handlerPress }) => {
    return (jsxRuntime.jsxs(reactNative.View, { style: { backgroundColor, width: '100%' }, children: [jsxRuntime.jsx(reactNative.View, { style: [styles$j.margin, { justifyContent: 'center', alignItems: 'center' }], children: children }), jsxRuntime.jsx(reactNative.View, { style: styles$j.row, children: nav &&
                    nav.map((elementNav, index) => {
                        if (!elementNav) {
                            return null;
                        }
                        return (jsxRuntime.jsx(reactNative.TouchableOpacity, { style: styles$j.margin, onPress: () => handlerPress(elementNav.link), children: jsxRuntime.jsx(Text, { style: styles$j.text, children: elementNav.name }) }, index));
                    }) })] }));
};

const IconButton = ({ name, type = 'primary', color, backgroundColor, onPress, fontSize, containerStyle, disabled = false, text, title, padding = 5 }) => {
    const context = React__namespace.useContext(OWCContext);
    const [loading, setLoading] = React__namespace.useState(false);
    backgroundColor = backgroundColor || context.colors[type].background;
    color = color || context.colors[type].text;
    /**
     * on press
     */
    const handlePress = React__namespace.useCallback(async (args) => {
        setLoading(true);
        try {
            await Promise.resolve(onPress(args));
        }
        catch (error) {
            //
        }
        setLoading(false);
    }, [onPress]);
    if (loading) {
        return jsxRuntime.jsx(Loader, { size: 'small', margin: 0 });
    }
    /**
     * render
     */
    return (jsxRuntime.jsx(reactNative.View, { style: [styles$i.container, containerStyle, { backgroundColor }, (loading || disabled) && styles$i.disabled], children: jsxRuntime.jsx(Icon, { padding: padding, title: title, text: text, onPress: handlePress, type: name, fontSize: fontSize, style: styles$i.icon, color: color.toString() }) }));
};
const styles$i = reactNative.StyleSheet.create({
    container: {
        minWidth: 20,
        minHeight: 20,
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    disabled: {
        backgroundColor: '#eee',
    },
    icon: {
        margin: '0'
    }
});

const Legend = ({ data, textUppercase = false }) => {
    return (jsxRuntime.jsx(reactNative.View, { style: { marginBottom: 15, borderTopWidth: 1, borderColor: '#ccc' }, children: data.map((item, index) => {
            if (!item) {
                return null;
            }
            const isIconType = (value) => typeof value === "string";
            return (jsxRuntime.jsxs(reactNative.View, { style: { flexDirection: 'row', padding: 2, borderBottomWidth: 1, borderColor: '#ccc', alignItems: 'center', backgroundColor: item.backGroundColor || '#fff' }, children: [!!item.icon ? jsxRuntime.jsx(Icon, { text: item.text, color: item.iconColor || '#333', ...isIconType(item.icon) ? { type: item.icon } : item.icon }) : item.text ? jsxRuntime.jsxs(Text, { uppercase: textUppercase, bold: true, children: [item.text, " "] }) : null, jsxRuntime.jsx(Text, { children: item.label })] }, index));
        }) }));
};

const padding = 30;
const Line = ({ data, containerStyle, width }) => {
    const _width = width;
    const height = 450;
    const maxData = Math.max(...data.map(item => Math.max(...item.data.filter(x => !isNaN(x)))));
    const yScale = (height - 2 * padding) / maxData;
    const numTicks = Math.ceil(maxData / 10);
    const calculatePoints = (serie) => {
        let points = '';
        let lastValidIndex = -1;
        let gapStarted = false;
        serie.data.forEach((value, i) => {
            if (!isNaN(value)) {
                if (gapStarted) {
                    // End the gap by moving to the new point
                    const x = (i / (serie.data?.length - 1)) * (_width - 2 * padding) + padding;
                    const y = (height - padding) - (value * yScale);
                    points += `L${x},${y} `;
                    gapStarted = false;
                }
                else {
                    // Add the current point to the line
                    const x = (i / (serie.data?.length - 1)) * (_width - 2 * padding) + padding;
                    const y = (height - padding) - (value * yScale);
                    points += `${i === 0 ? 'M' : 'L'}${x},${y} `;
                    lastValidIndex = i;
                }
            }
            else {
                if (lastValidIndex !== i - 1) {
                    // Start a gap by moving to (0,0)
                    points += 'M0,0 ';
                    gapStarted = true;
                }
            }
        });
        return points.trim();
    };
    const lines = data?.map((serie, i) => (jsxRuntime.jsx(reactNativeSvg.Path, { d: calculatePoints(serie), fill: "none", stroke: serie.color, strokeWidth: "3" }, `line-${i}`)));
    const yAxisLines = Array.from({ length: numTicks }, (_, i) => {
        const y = ((height - 2 * padding) * (1 - i / numTicks)) + padding;
        return (jsxRuntime.jsx(reactNativeSvg.Line, { x1: padding, y1: y, x2: _width - padding, y2: y, stroke: "gray", strokeWidth: "1", strokeDasharray: "4" }, `y-axis-line-${i}`));
    });
    const yAxisLabels = Array.from({ length: numTicks }, (_, i) => {
        const y = ((height - 2 * padding) * (1 - i / numTicks)) + padding;
        return (jsxRuntime.jsx(reactNativeSvg.Text, { x: padding - 5, y: y, textAnchor: "end", alignmentBaseline: "middle", fontSize: "12", fill: "gray", children: i * 10 }, `y-axis-label-${i}`));
    });
    return (jsxRuntime.jsx("div", { style: containerStyle, children: jsxRuntime.jsxs(reactNativeSvg.Svg, { width: _width, height: height, children: [yAxisLines, lines, yAxisLabels] }) }));
};

const Link = ({ children, text, to, tab = false, type = 'link', button = false, textAlign, styles = {}, containerStyle = {}, title, disabled = false, onPress }) => {
    const context = React__namespace.useContext(OWCContext);
    const color = context?.colors[type]?.text;
    const colorBox = context?.colors[type]?.background;
    const textContext = React__namespace.useContext(TextContext);
    const fontSize = textContext?.fontSize || context?.fonts?.body?.fontSize || 12;
    /**
     * navigate
     */
    const navigate = React__namespace.useCallback((event) => {
        event?.preventDefault?.();
        if (disabled) {
            return;
        }
        const params = {
            tab,
            replace: !!to?.startsWith('http'),
        };
        context.navigate(to, params);
    }, [context, to, tab, disabled]);
    /**
     * render
     */
    if (reactNative.Platform.OS !== 'web') {
        if (!to) {
            jsxRuntime.jsx(Button, { type: 'link', onPress: () => console.log, text: text });
        }
        return (jsxRuntime.jsx(Button, { type: 'link', onPress: () => onPress?.() ?? reactNative.Linking.openURL(to), text: text }));
    }
    if (button) {
        return (jsxRuntime.jsx(reactNative.View, { style: [
                style.container,
                { minHeight: 30, minWidth: 150 },
                { backgroundColor: colorBox, },
                containerStyle,
            ], children: jsxRuntime.jsx(reactNative.View, { style: [style.boxText, { justifyContent: 'center' }], children: jsxRuntime.jsx(reactNative.View, { style: { width: '100%' }, children: jsxRuntime.jsxs("a", { href: to && !disabled ? to : undefined, target: tab ? '_blank' : undefined, style: { cursor: 'pointer', textDecoration: 'none', ...styles }, onClick: onPress ?? navigate, children: [!!text && jsxRuntime.jsx(Text, { textAlign: textAlign, color: color, style: [style.text], children: text }), !!children && jsxRuntime.jsx(reactNative.View, { children: typeof children === 'string' ? jsxRuntime.jsx(Text, { textAlign: textAlign, color: color, style: { ...styles }, children: children }) : children })] }) }) }) }));
    }
    return (jsxRuntime.jsxs("a", { href: to && !disabled ? to : undefined, target: tab ? '_blank' : undefined, style: { color, cursor: 'pointer', textDecoration: 'none', textAlign, overflowWrap: 'anywhere', fontSize }, title: title, onClick: onPress, children: [!!text && jsxRuntime.jsx(Text, { textAlign: textAlign, color: color, style: { ...styles }, children: text }), !!children && jsxRuntime.jsx(reactNative.View, { children: typeof children === 'string' ? jsxRuntime.jsx(Text, { textAlign: textAlign, color: color, style: { ...styles }, children: children }) : children })] }));
};
const style = reactNative.StyleSheet.create({
    container: {
        width: 'max-content',
        maxWidth: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        // flex: 1,
        // borderRadius: 5,
        padding: 10,
    },
    containerLink: {
        width: undefined,
        flex: undefined,
        padding: 0,
    },
    boxText: {
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
    },
    shadow: {
        elevation: 5,
        shadowColor: '#000',
        shadowOffset: { width: 0.5, height: 0.5 },
        shadowOpacity: 0.5,
        shadowRadius: 3,
    },
    text: {
        // fontSize: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%',
    },
    disabled: {
        backgroundColor: '#eee',
        cursor: 'not-allowed',
    },
});

const Minimizer = ({ children, position = {}, maximizedPosition }) => {
    const [minimized, setMinimized] = React__namespace.useState(true);
    if (minimized) {
        return (jsxRuntime.jsx(reactNative.View, { style: [styles$h.container, position], children: jsxRuntime.jsx(Icon, { type: 'more', onPress: () => setMinimized(false), marginRight: 0, borderWidth: 1, containerStyle: { backgroundColor: 'white' } }) }));
    }
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$h.container, maximizedPosition || position], children: [jsxRuntime.jsx(Icon, { type: 'less', onPress: () => setMinimized(true), marginRight: 0, borderWidth: 1, containerStyle: { backgroundColor: 'white' } }), jsxRuntime.jsx(reactNative.View, { style: { flex: 1 }, children: children })] }));
};
const styles$h = {
    container: {
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
};

const ModalConfirm = ({ visible = true, text, children, title, accept, close, animationType, minWidth, maxWidth = 400 }) => {
    return (jsxRuntime.jsxs(Modal, { title: title || t('common:modal.confirm'), close: close, visible: visible, animationType: animationType, maxWidth: maxWidth, minWidth: minWidth, children: [jsxRuntime.jsx(reactNative.View, { style: { marginBottom: 15 }, children: children || !!text && jsxRuntime.jsx(Text, { fontSize: 14, children: text }) }), jsxRuntime.jsxs(reactNative.View, { style: { flexDirection: 'row' }, children: [jsxRuntime.jsx(Button, { text: t('common:modal.close'), onPress: close, type: 'secondary', containerStyle: { flex: 1, marginBottom: 0, marginRight: 5 } }), jsxRuntime.jsx(Button, { text: t('common:modal.accept'), onPress: accept, containerStyle: { flex: 1, marginBottom: 0 } })] })] }));
};

const NavbarContext = React__namespace.createContext({});

const NavbarItem = ({ rtl = false, containerStyle, labelStyle, label = '', onPress, hoverBackgroundColor, hoverColor, left }) => {
    const navbarContext = React__namespace.useContext(NavbarContext);
    const hbc = hoverBackgroundColor || navbarContext.hoverBackgroundColor;
    const hc = hoverColor || navbarContext.hoverColor;
    const handlePress = () => {
        navbarContext.setOpen(null);
        onPress();
    };
    return (jsxRuntime.jsx(reactNativeWebHover.Hoverable, { style: [styles$g.container], children: ({ hovered }) => (jsxRuntime.jsx(reactNative.TouchableOpacity, { onPress: handlePress, style: [
                styles$g.container,
                !!hbc && hovered && { backgroundColor: hbc },
                rtl && styles$g.rtl
            ], children: jsxRuntime.jsxs(reactNative.View, { style: [styles$g.content, containerStyle], children: [left, jsxRuntime.jsx(Text, { numberOfLines: 1, style: [styles$g.label, { color: !!hc && hovered ? hc : navbarContext.color }, labelStyle], children: label })] }) })) }));
};
const styles$g = reactNative.StyleSheet.create({
    container: {
        height: '100%',
        width: 'auto',
        justifyContent: 'center',
    },
    rtl: {
        alignItems: 'flex-end',
    },
    content: {
        padding: 10,
        justifyContent: 'center',
        flexDirection: 'row',
    },
    label: {
        color: 'white',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        flex: 1,
        display: 'flex',
        alignItems: 'center',
    },
});

/**
 * Navbar component
 */
const Navbar = ({ backgroundColor, containerStyle, hoverBackgroundColor, color, hoverColor, backdropColor = 'black', backdropOpacity = 0, children, collapsable = true }) => {
    const { width } = reactNative.useWindowDimensions();
    const collapsed = collapsable && width < MD;
    const [collapsedOpen, setCollapsedOpen] = React__namespace.useState(false);
    const context = React__namespace.useContext(OWCContext);
    const [open, setOpen] = React__namespace.useState(null);
    const dimensions = reactNative.useWindowDimensions();
    /**
     * ...
     * @param child
     * @param index
     */
    const getChild = (child, index) => {
        if (child?.type?.displayName === 'View') {
            return child;
        }
        return (jsxRuntime.jsx(reactNative.View, { style: [styles$f.item, open && { zIndex: 99 }], children: child }, index));
    };
    /**
     * render
     */
    return (jsxRuntime.jsx(NavbarContext.Provider, { value: {
            open,
            setOpen,
            backgroundColor: backgroundColor || context.colors.primary.background,
            hoverBackgroundColor: hoverBackgroundColor || backgroundColor || context.colors.dark.background,
            color: color || context.colors.primary.text,
            hoverColor: hoverColor || color || context.colors.dark.text,
            collapsed,
        }, children: jsxRuntime.jsxs(reactNative.View, { style: [styles$f.container, { backgroundColor: backgroundColor || context.colors.primary.background }, open && { zIndex: 98 }, collapsed && styles$f.collapsed, containerStyle], children: [open && (jsxRuntime.jsx(reactNative.TouchableWithoutFeedback, { onPress: () => setOpen(null), children: jsxRuntime.jsx(reactNative.View, { style: [
                            styles$f.backdrop,
                            { backgroundColor: backdropColor, opacity: backdropOpacity },
                            { top: 0, height: dimensions.height, position: 'fixed' },
                        ] }) })), collapsed && getChild(jsxRuntime.jsx(NavbarItem, { onPress: () => setCollapsedOpen(!collapsedOpen), left: jsxRuntime.jsx(Icon, { type: 'burger', color: context.colors.primary.text, onPress: () => setCollapsedOpen(!collapsedOpen) }) })), (!collapsed || collapsedOpen) && (Array.isArray(children) ? children : [children]).map((child, index) => getChild(child, index))] }) }));
};
/**
 * styles
 */
const styles$f = reactNative.StyleSheet.create({
    backdrop: {
        position: 'absolute',
        zIndex: 99,
        width: '100%',
    },
    container: {
        minHeight: 40,
        flexDirection: 'row',
        justifyContent: 'center',
    },
    item: {
        width: 'auto',
    },
    collapsed: {
        flexDirection: 'column',
    },
});

const NavbarDropdown = ({ labelStyle, rtl = false, label, icon = true, children, containerStyle }) => {
    const navbarContext = React__namespace.useContext(NavbarContext);
    const toggle = () => {
        if (navbarContext.open !== label) {
            navbarContext.setOpen(label);
        }
    };
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$e.container], children: [jsxRuntime.jsx(NavbarItem, { containerStyle: containerStyle, labelStyle: labelStyle, label: `${label} ${icon ? navbarContext.open === label ? '▲' : '▼' : ''}`, onPress: toggle, rtl: rtl }), jsxRuntime.jsx(reactNative.View, { style: styles$e.dropdownContainer, children: navbarContext.open === label && (jsxRuntime.jsx(reactNative.View, { style: [styles$e.dropdown, !!rtl && styles$e.dropdownRtl, { backgroundColor: navbarContext.backgroundColor }, navbarContext.collapsed && styles$e.dropdownCollapsed], children: children })) })] }));
};
const styles$e = reactNative.StyleSheet.create({
    container: {
        height: '100%',
    },
    dropdownContainer: {
        flex: 0,
    },
    dropdown: {
        paddingVertical: 5,
        position: 'absolute',
        top: 0,
        minWidth: 200,
        // marginTop: -3,
        shadowColor: '#000',
        shadowOffset: { width: 3, height: 3 },
        shadowOpacity: 0.6,
        shadowRadius: 2,
        elevation: 5,
    },
    dropdownRtl: {
        right: 0,
    },
    dropdownCollapsed: {
        position: 'relative',
        padding: 20,
        shadowOffset: undefined,
        shadowOpacity: 0,
    },
});

const NavbarSeparator = () => {
    return (jsxRuntime.jsx(Separator, { backgroundColor: '#eee', style: { marginVertical: 5 } }));
};

const PieChart = ({ containerStyle, size, data, label, sublabel }) => {
    const [calc, setCalc] = React__namespace.useState();
    const radius = size / 4 - 1;
    const width = size / 2;
    /**
     * calculate slices data
     */
    React__namespace.useEffect(() => {
        const total = data.reduce((sum, item) => sum + item.value, 0);
        // const radius = size / 4;
        const circumference = 2 * Math.PI * radius;
        let slices = [];
        if (total > 0) {
            let amount = total;
            slices = [...data].reverse().map((item) => {
                const percentage = Math.floor(amount / total * 100);
                const offset = circumference - (circumference * percentage) / 100;
                amount -= item.value;
                return { offset, value: item.value, color: item.color };
            });
        }
        else {
            slices = data.map((item) => item);
        }
        setCalc({ radius, circumference, slices });
    }, [data, size]);
    /**
     *
     */
    if (!calc) {
        return null;
    }
    /**
     * render
     */
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$d.container, containerStyle], children: [!!label && jsxRuntime.jsx(Text, { bold: true, uppercase: true, style: { marginTop: 10, marginBottom: !!sublabel ? 0 : 10 }, children: label }), !!sublabel && jsxRuntime.jsx(Text, { uppercase: true, style: { marginBottom: 10 }, children: sublabel }), jsxRuntime.jsxs(reactNative.View, { style: [styles$d.content, { width: size, height: size }], children: [jsxRuntime.jsxs(reactNativeSvg.Svg, { height: size, width: size, children: [jsxRuntime.jsx(reactNativeSvg.Circle, { cx: size / 2, cy: size / 2, r: size / 2 - 1, fill: '#eee' }), !!calc && calc.slices?.map((slice, idx) => {
                                if (!slice.value) {
                                    return null;
                                }
                                return (jsxRuntime.jsx(reactNativeSvg.Circle, { cx: size / 2, cy: size / 2, r: calc.radius, fill: 'transparent', stroke: slice.color, strokeWidth: width, strokeDasharray: calc.circumference, strokeDashoffset: slice.offset, strokeLinecap: "butt" }, `${idx}-${slice.value}-${slice.color}`));
                            }), jsxRuntime.jsx(reactNativeSvg.Circle, { cx: size / 2, cy: size / 2, r: size / 2 * 0.6, fill: 'white' })] }), jsxRuntime.jsx(reactNative.View, { style: { position: 'absolute', margin: 0 }, children: [...calc.slices].reverse().map((slice, idx) => (jsxRuntime.jsxs(reactNative.View, { style: { flexDirection: 'row', alignItems: 'center' }, children: [jsxRuntime.jsx(reactNative.View, { style: { width: 10, height: 10, backgroundColor: slice.color, marginRight: 5 } }), jsxRuntime.jsx(Text, { children: slice.value })] }, idx))) })] })] }));
};
const styles$d = reactNative.StyleSheet.create({
    container: {
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        // borderWidth: 1,
    },
    content: {
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
    }
});

const styles$c = reactNative.StyleSheet.create({
    container: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginBottom: 15,
    },
    step: {
        flexDirection: 'column',
        minWidth: 80,
        marginBottom: 5,
    },
    barContainer: {
        flexDirection: 'row',
        height: 40,
        alignItems: 'center',
    },
    bar: {
        flex: 1,
        height: 5,
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderColor: '#d5d5da',
        backgroundColor: '#eee',
    },
    circle: {
        position: 'absolute',
        width: 40,
        height: 40,
        borderRadius: 20,
        left: '50%',
        marginLeft: -20,
        padding: 3,
        borderWidth: 1,
        borderColor: '#d5d5da',
        backgroundColor: '#eee',
        justifyContent: 'center',
        alignItems: 'center',
    },
    innerCircle: {
        width: '100%',
        height: '100%',
        borderRadius: 100,
        alignItems: 'center',
        justifyContent: 'center',
    },
    innerCircleText: {
        fontSize: 11,
    },
    text: {
        paddingHorizontal: 10,
    },
});

const ProgressBar = ({ data, onChange }) => {
    const context = React__namespace.useContext(OWCContext);
    return (jsxRuntime.jsx(reactNative.View, { style: styles$c.container, children: data.map((progress, idx) => {
            const circleColor = progress.status === 'active' && context.colors.primary.background || progress.status === 'done' && context.colors.success.background || 'transparent';
            const textColor = progress.status === 'active' && context.colors.primary.text || progress.status === 'done' && context.colors.success.text || '#ccc';
            return (jsxRuntime.jsx(reactNative.View, { style: styles$c.step, children: jsxRuntime.jsxs(reactNative.View, { style: styles$c.barContainer, children: [jsxRuntime.jsx(reactNative.View, { style: [styles$c.bar, idx === 0 && { backgroundColor: 'transparent', borderColor: 'transparent' }] }), jsxRuntime.jsx(reactNative.View, { style: [styles$c.bar, idx === data.length - 1 && { backgroundColor: 'transparent', borderColor: 'transparent' }] }), jsxRuntime.jsx(reactNative.TouchableWithoutFeedback, { onPress: onChange ? () => onChange(idx) : undefined, children: jsxRuntime.jsx(reactNative.View, { style: [styles$c.circle, !!onChange && { cursor: 'pointer' }], children: jsxRuntime.jsx(reactNative.View, { style: [styles$c.innerCircle, { backgroundColor: circleColor }], children: jsxRuntime.jsx(Text, { style: [styles$c.innerCircleText, { color: textColor }], children: idx + 1 }) }) }) })] }) }, idx));
        }) }));
};

const QRCode = ({ value, size, containerStyle }) => {
    return (jsxRuntime.jsx(reactNative.View, { style: containerStyle, children: jsxRuntime.jsx(qrcode_react.QRCodeSVG, { value: value, size: size }) }));
};

const Radio = ({ value = false, backgroundColor, label, onChange, containerStyle, disabled = false }) => {
    const context = React__namespace.useContext(OWCContext);
    const bgc = backgroundColor || context.colors.primary.background;
    return (jsxRuntime.jsx(reactNative.View, { style: [styles$b.container, containerStyle], children: jsxRuntime.jsx(reactNative.TouchableWithoutFeedback, { onPress: !disabled ? onChange : null, children: jsxRuntime.jsxs(reactNative.View, { style: { width: 'auto', flexDirection: 'row', cursor: disabled ? 'no-drop' : 'pointer' }, children: [jsxRuntime.jsx(reactNative.View, { style: [styles$b.button, { backgroundColor: disabled ? '#ccc' : 'white' }], children: value && jsxRuntime.jsx(reactNative.View, { style: [styles$b.checked, { backgroundColor: bgc }] }) }), label !== undefined && jsxRuntime.jsx(Text, { style: styles$b.label, children: label })] }) }) }));
};
const styles$b = reactNative.StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 15,
    },
    button: {
        width: 20,
        height: 20,
        borderRadius: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        borderWidth: 1,
        borderColor: '#ccc',
        marginRight: 5,
    },
    checked: {
        width: 14,
        height: 14,
        borderRadius: 7,
    },
    label: {
        flex: 1,
        marginTop: 3,
    },
});

const RadioGroup = ({ disabled = false, direction = 'column', data, value, defaultValue, onChange, containerStyle, label }) => {
    const [selected, setSelected] = React__namespace.useState(value !== undefined ? value : defaultValue);
    const handleChange = (value) => {
        if (disabled || selected === value) {
            return;
        }
        onChange?.(value);
        setSelected(value);
    };
    React__namespace.useEffect(() => {
        if (value === undefined) {
            return;
        }
        setSelected(value);
    }, [value]);
    return (jsxRuntime.jsxs(reactNative.View, { style: { flex: 1 }, children: [label ?
                jsxRuntime.jsx(Text, { style: styles$a.label, children: label })
                : null, jsxRuntime.jsx(reactNative.View, { style: [styles$a.container, { flexDirection: direction }, containerStyle], children: data.map((item) => {
                    return (jsxRuntime.jsx(Radio, { disabled: item.disabled, label: item.label, onChange: () => handleChange(item.value), value: item.value === selected, containerStyle: direction === 'row' && styles$a.horizontal }, item.value));
                }) })] }));
};
const styles$a = reactNative.StyleSheet.create({
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    horizontal: {
        marginRight: 10,
    },
    label: {
        marginBottom: 5,
        marginLeft: 5,
    },
});

const RadioGroupNumeric = ({ start = 1, end, disabled = false, direction = 'row', defaultValue, onChange, containerStyle }) => {
    const data = [];
    if (start !== undefined && end !== undefined) {
        for (let i = start; i <= end; i++) {
            data.push({ label: i, value: i });
        }
    }
    return (jsxRuntime.jsx(RadioGroup, { data: data, direction: direction, disabled: disabled, onChange: onChange, defaultValue: defaultValue, containerStyle: containerStyle }));
};

const styles$9 = reactNative.StyleSheet.create({
    labelbox: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    container: {
        marginBottom: 15,
    },
    label: {
        //  paddingLeft: 10,
        marginBottom: 5,
        color: '#333',
    },
    labelError: {
        color: 'crimson',
    },
    inputContainer: {
        //  padding: 5,
        width: '100%',
        backgroundColor: 'white',
    },
    inputContainerError: {
        borderColor: 'crimson',
        shadowColor: 'crimson',
    },
    input: {
        width: '100%',
        flex: 1,
        backgroundColor: 'white',
        borderRadius: 0,
        //  fontSize: 15,
        paddingLeft: 10,
        color: '#333',
        borderWidth: 1,
        borderColor: '#ccc',
        height: 40,
        minHeight: 40,
    },
    text: {
        width: '90%',
        textAlign: 'left',
        fontWeight: 'bold',
        //  fontSize: 18,
    },
    textError: {
        //  fontSize: 12,
        paddingLeft: 10,
        color: 'crimson',
    },
});

const Range = ({ disabled = false, label, error, containerStyle, onChange = () => { }, value, min, max, step }) => {
    const handleChange = (event) => {
        onChange(event.target.value);
    };
    /**
     * render
     */
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$9.container, containerStyle], children: [!!label && (jsxRuntime.jsx(reactNative.View, { style: styles$9.labelbox, children: jsxRuntime.jsx(Text, { style: [styles$9.label, error ? styles$9.labelError : undefined], children: label }) })), jsxRuntime.jsx("input", { onChange: handleChange, disabled: disabled, step: step, type: 'range', min: min, max: max, value: value, style: { backgroundColor: 'red' } }), jsxRuntime.jsx(Text, { style: [styles$9.textError], children: error })] }));
};

const Row = ({ children, style, marginBottom, alignItems = 'center' }) => {
    return (jsxRuntime.jsx(reactNative.View, { style: [styles$8.container, style, { alignItems }, !!marginBottom && { marginBottom }], children: children }));
};
const styles$8 = reactNative.StyleSheet.create({
    container: {
        flexDirection: 'row',
        flexWrap: 'wrap',
    }
});

const Selector = ({ disabled = false, emptyOption, options, label, onChange, selected }) => {
    return (jsxRuntime.jsx(Picker, { label: label, defaultOptionLabel: emptyOption, editable: !disabled, items: options, onChange: onChange, selected: selected }));
};

const Stacks = React__namespace.forwardRef(({}, ref) => {
    const [alerts, setAlerts] = React__namespace.useState([]);
    const refs = React__namespace.useRef([]);
    React__namespace.useImperativeHandle(ref, () => ({
        create,
    }));
    const remove = (id) => {
        refs.current = refs.current.filter((_alert) => _alert.id !== id);
        setAlerts(refs.current);
    };
    const create = (alert) => {
        refs.current = [...refs.current, alert];
        setAlerts(refs.current);
        setTimeout(() => remove(alert.id), alert.time ? alert.time : 8000);
    };
    return (jsxRuntime.jsx(reactNative.View, { children: alerts?.map((alert) => (jsxRuntime.jsx(reactNative.View, { children: alert.data }, alert.id))) }));
});

const StatsLine = ({ label, leftTotal, leftValue, left = 0, leftZeroable = true, rightTotal, rightValue, right = 0, rightZeroable = true, highlight = 1, round: round$1 = false, bars = true, extended = false, isExtended = false }) => {
    const context = React__namespace.useContext(OWCContext);
    const styles = useResponsiveStyles({ xs: xs$3, md: md$2 });
    /**
     *
     */
    if (!isExtended && extended) {
        return null;
    }
    /**
     * render
     */
    // flex
    leftTotal = leftTotal || (left + right) || 1;
    rightTotal = rightTotal || (left + right) || 1;
    const leftFlex = Math.floor((left || 0));
    const rightFlex = Math.floor((right || 0));
    // values
    leftValue = leftValue || (!leftZeroable && left === 0 ? '-' : round$1 ? toFixed(round(left), 1) : left);
    rightValue = rightValue || (!rightZeroable && right === 0 ? '-' : round$1 ? toFixed(round(right), 1) : right);
    // highlights
    const leftZeroed = (!leftZeroable && left === 0);
    const rightZeroed = (!rightZeroable && right === 0);
    const zeroed = leftZeroed || rightZeroed;
    const highlightLeft = !zeroed && highlight && (left * highlight >= right * highlight);
    const highlightRight = !zeroed && highlight && (left * highlight <= right * highlight);
    return (jsxRuntime.jsxs(reactNative.View, { style: styles.container, children: [jsxRuntime.jsxs(reactNative.View, { style: styles.textContainer, children: [jsxRuntime.jsx(Text, { fontSize: 18, textAlign: 'center', bold: highlightLeft, style: styles.text, children: leftValue }), jsxRuntime.jsx(Text, { uppercase: true, textAlign: 'center', style: { display: 'flex' }, children: label }), jsxRuntime.jsx(Text, { fontSize: 18, textAlign: 'center', bold: highlightRight, style: styles.text, children: rightValue })] }), jsxRuntime.jsxs(reactNative.View, { style: styles.lineContainer, children: [jsxRuntime.jsxs(reactNative.View, { style: { flex: 1, flexDirection: 'row' }, children: [jsxRuntime.jsx(reactNative.View, { style: { flex: leftTotal - leftFlex } }), !!bars && jsxRuntime.jsx(reactNative.View, { style: { flex: leftFlex, backgroundColor: context.colors.primary.background } })] }), jsxRuntime.jsxs(reactNative.View, { style: { flex: 1, flexDirection: 'row' }, children: [!!bars && jsxRuntime.jsx(reactNative.View, { style: { flex: rightFlex, backgroundColor: context.colors.secondary.background } }), jsxRuntime.jsx(reactNative.View, { style: { flex: rightTotal - rightFlex } })] })] })] }));
};
const xs$3 = reactNative.StyleSheet.create({
    textContainer: {
        flexDirection: 'row', padding: 5, alignItems: 'center', justifyContent: 'center'
    },
    text: {
        minWidth: 30, marginHorizontal: 5, display: 'flex'
    },
    container: {
        marginBottom: 7
    },
    lineContainer: {
        flexDirection: 'row', height: 5
    }
});
const md$2 = reactNative.StyleSheet.create({
    textContainer: {
        flexDirection: 'row', padding: 5, alignItems: 'center', justifyContent: 'center'
    },
    text: {
        minWidth: 30, marginHorizontal: 5, display: 'flex'
    },
    container: {
        marginBottom: 15
    },
    lineContainer: {
        flexDirection: 'row', height: 10
    }
});

const Stepper = ({ step = 0, selected = 0, headers, children, onPress, containerStyle }) => {
    const styles = useResponsiveStyles({ xs: xs$2, lg: lg$1 });
    /**
     * render
     */
    return (jsxRuntime.jsxs(reactNative.View, { children: [jsxRuntime.jsx(reactNative.View, { style: [styles.stepper, containerStyle], children: jsxRuntime.jsx(OWCStepper, { activeStep: step, children: headers.map((header, idx) => (jsxRuntime.jsx(OWCStep, { onPress: () => idx <= step && onPress?.(idx), label: header.label?.toUpperCase(), activeStep: false, completed: step > idx }, header.label))) }) }), children?.map((child, idx) => (jsxRuntime.jsx(reactNative.View, { style: [idx !== selected && styles.hidden], children: child }, idx)))] }));
};
const OWCStepper = ({ children, containerStyle, activeStep }) => {
    const styles = useResponsiveStyles({ xs: xs$2, lg: lg$1 });
    return (jsxRuntime.jsx(reactNative.View, { style: [styles.stepper, containerStyle], children: children.map((child, idx) => (jsxRuntime.jsxs(React__namespace.Fragment, { children: [jsxRuntime.jsx(OWCStep, { label: child.props.label, value: child.props.value, id: idx, activeStep: activeStep === idx, onPress: child.props.onPress, completed: child.props.completed }, idx), (idx !== children.length - 1) && jsxRuntime.jsx(reactNative.View, { style: styles.stepLine })] }, idx))) }));
};
const OWCStep = ({ label, id, activeStep, onPress, completed }) => {
    const styles = useResponsiveStyles({ xs: xs$2, lg: lg$1 });
    return (jsxRuntime.jsxs(reactNative.View, { style: { display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0.5em' }, children: [completed ? (jsxRuntime.jsx(IconButton, { name: 'ok', backgroundColor: 'transparent', color: 'green', onPress: onPress })) : (jsxRuntime.jsx(Button, { backgroundColor: (!activeStep && 'grey') || '', onPress: onPress, text: id + 1, containerStyle: styles.button, marginBottom: 0 })), jsxRuntime.jsx(Text, { bold: true, children: label })] }));
};
const xs$2 = reactNative.StyleSheet.create({
    stepLine: {
        display: 'none',
    },
    stepper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        flexWrap: 'wrap',
        flex: 1,
    },
    button: {
        minHeight: 20,
        minWidth: 20,
        height: 20,
        width: 20,
        borderRadius: 100,
        marginRight: '0.5em',
        padding: 0,
    },
    hidden: {
        display: 'none',
    }
});
const lg$1 = reactNative.StyleSheet.create({
    stepLine: {
        display: 'flex',
        flex: 1,
        height: 1,
        backgroundColor: '#AAAAAA',
        paddingHorizontal: 4,
    },
});

const styles$7 = reactNative.StyleSheet.create({
    container: {
        marginVertical: 3,
        alignItems: "center",
        crusor: 'pointer',
        flexDirection: 'row'
    },
    label: {
        marginHorizontal: 10,
        // fontSize:16
    }
});

const Switch = ({ onChange = () => { }, disabled = false, label, value = false, trackColorTrue = "#00EE6B", trackColorFalse = "#767577", thumbColorTrue = "#ccc", thumbColorFalse = "white", containerStyle }) => {
    return (jsxRuntime.jsxs(reactNative.View, { style: [styles$7.container, containerStyle], children: [jsxRuntime.jsx(reactNative.Switch, { disabled: disabled, trackColor: { false: trackColorFalse, true: trackColorTrue }, thumbColor: !!value ? thumbColorTrue : thumbColorFalse, ios_backgroundColor: "#3e3e3e", onValueChange: onChange, value: value }), label && jsxRuntime.jsx(Text, { style: styles$7.label, children: label })] }));
};

/**
 * Componente para la paginación de la <Table />
 */
const Pagination = ({ page, pages, amount = 5, onChange }) => {
    /**
     * context
     */
    const context = React__namespace.useContext(OWCContext);
    const borderColor = context.colors.primary.background || '#333';
    const backgroundColor = context.colors.primary.background || '#eee';
    const color = context.colors.primary.text || '#333';
    /**
     * render pages
     */
    const renderPages = () => {
        const items = [];
        for (let i = 1; i <= pages; i++) {
            items.push(getPageComponent(i, onChange));
        }
        let start = Math.max(page - (amount / 2), 0);
        const end = Math.min(start + amount, items.length);
        if (start > end - amount) {
            start = Math.max(0, end - amount);
        }
        return [
            getPageComponent('←', () => onChange(Math.max(page - 1, 1)), page <= 1, { width: 40 }),
            items.slice(start, end),
            getPageComponent('→', () => onChange(Math.min(page + 1, pages)), page >= pages, { width: 40 }),
        ];
    };
    const getPageComponent = (value, onPress, disabled = false, style = {}) => {
        return (jsxRuntime.jsx(reactNative.TouchableWithoutFeedback, { onPress: () => !disabled && onPress(value), children: jsxRuntime.jsx(reactNative.View, { style: [styles$6.page, { borderColor }, value === page && { backgroundColor }, style], children: jsxRuntime.jsx(Text, { style: [value === page && { color }, disabled && styles$6.disabled], children: value }) }) }, value));
    };
    /**
     * render
     */
    return (jsxRuntime.jsx(reactNative.View, { style: styles$6.container, children: renderPages() }));
};
const styles$6 = reactNative.StyleSheet.create({
    container: {
        flexDirection: 'row',
    },
    page: {
        borderWidth: 1,
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        padding: 10,
        paddingHorizontal: 15,
        marginRight: 5,
        userSelect: 'none',
        minWidth: 40,
    },
    disabled: {
        color: '#ccc',
        cursor: 'not-allowed',
    },
});

const TableContext = React__namespace.createContext({
    bordered: true,
    borderColor: '#333',
    rowOddBackgroundColor: '#eee',
    headerBackgroundColor: '#333',
    headerColor: '#eee',
    collapsed: false,
});

/**
 * TableData component
 */
const TableData = ({ data, compact = false, center = false, justifyContent = 'flex-start', flex, width }) => {
    const { collapsed } = React__namespace.useContext(TableContext);
    /**
     * get content
     */
    const getContent = () => {
        // typescript workaround...
        const _data = data;
        if (_data === null || _data === undefined) {
            return jsxRuntime.jsx(Text, {});
        }
        // string | number
        if (isText(_data)) {
            return jsxRuntime.jsx(Text, { children: _data });
        }
        const text = _data?.text || _data?.content;
        // text or content is string | number
        if (isText(text)) {
            return jsxRuntime.jsx(Text, { children: text });
        }
        // content is undefined
        if (typeof _data === 'object' && Object.keys(_data).includes('content') && (_data.content === undefined || _data.content === null)) {
            return jsxRuntime.jsx(Text, {});
        }
        // content is not text
        if (!!_data?.content) {
            return _data.content;
        }
        // data as function
        if (!!_data?.render) {
            return _data.render();
        }
        // hopefully data is a component
        return typeof _data === 'function' ? _data() : _data;
    };
    /**
     * render
     */
    return (jsxRuntime.jsx(reactNative.View, { style: [styles$5.td, compact && styles$5.tdCompact, center && styles$5.center, collapsed && styles$5.tdCollapsed, { flex, justifyContent, maxWidth: width, minWidth: width }], children: getContent() }));
};
/**
 * styles
 */
const styles$5 = reactNative.StyleSheet.create({
    td: {
        flex: 1,
        paddingHorizontal: 10,
        paddingVertical: 5,
        minHeight: 42,
        overflow: 'hidden',
        flexDirection: 'row',
        alignItems: 'center',
    },
    tdCompact: {
        minHeight: 'auto',
        paddingLeft: 10,
        paddingVertical: 4,
        padding: 4,
    },
    tdCollapsed: {
        minHeight: 'auto',
        paddingLeft: 1,
        paddingVertical: 1,
        padding: 1,
        paddingHorizontal: 5,
    },
    center: {
        justifyContent: 'center',
    },
});

const TableRow = ({ odd, children, containerStyle }) => {
    const context = React__namespace.useContext(TableContext);
    return (jsxRuntime.jsx(reactNative.View, { style: [styles$4.tr, { borderColor: context.borderColor }, odd && { backgroundColor: context.rowOddBackgroundColor }, containerStyle], children: children }));
};
const styles$4 = reactNative.StyleSheet.create({
    tr: {
        width: '100%',
        flexDirection: 'row',
        borderBottomWidth: 2,
    }
});

const TableBody = ({ children }) => {
    return (jsxRuntime.jsx(reactNative.View, { style: styles$3.tbody, children: !!children?.length ? children : jsxRuntime.jsx(TableRow, { children: jsxRuntime.jsx(TableData, { data: t('common:table.empty'), center: true }) }) }));
};
const styles$3 = reactNative.StyleSheet.create({
    tbody: {
        width: '100%',
    },
});

const TableHead = ({ children }) => {
    const context = React__namespace.useContext(TableContext);
    return (jsxRuntime.jsx(reactNative.View, { style: [styles$2.thead, { backgroundColor: context.headerBackgroundColor }], children: children }));
};
const styles$2 = reactNative.StyleSheet.create({
    thead: {
        width: '100%',
        minHeight: 2,
    }
});

const TableHeader = ({ text, flex, width, onHeaderClick, sortDirection = 0, justifyContent = 'flex-start' }) => {
    const context = React__namespace.useContext(TableContext);
    return (jsxRuntime.jsx(reactNative.TouchableWithoutFeedback, { onPress: !!onHeaderClick ? onHeaderClick : undefined, children: jsxRuntime.jsxs(reactNative.View, { style: [styles$1.th, { flex, justifyContent, maxWidth: width, minWidth: width }, !!onHeaderClick && { cursor: 'pointer' }], children: [jsxRuntime.jsx(Text, { color: context.headerColor, justifyContent: justifyContent, bold: true, children: text }), !!onHeaderClick && (jsxRuntime.jsx(Icon, { type: 'text', text: sortDirection === 0 ? ' ' : sortDirection === -1 ? '↑' : '↓', color: context.headerColor, fontSize: 20, containerStyle: { marginBottom: 5, position: 'absolute', right: 0, marginRight: 0, width: 5 }, onPress: onHeaderClick }))] }) }));
};
const styles$1 = reactNative.StyleSheet.create({
    th: {
        flex: 1,
        paddingHorizontal: 10,
        minHeight: 42,
        flexDirection: 'row',
        alignItems: 'center',
        // borderLeftWidth: 1,
        // borderTopWidth: 1,
    },
    thText: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
});

//interface ITableData {
//  content: any;
//};
const Table = ({ csvButton = true, scrollIndex, responsiveCollaps = true, compact = false, pagination = true, searchable = true, fileName = null, initialSize, sizes = [5, 10, 25, 50, -1], headers, footer, data, initialSortColumn = 0, initialSortDirection = 1 }) => {
    /* table state */
    const [loading, setLoading] = React__namespace.useState(true);
    const [filtered, setFiltered] = React__namespace.useState(data);
    const [search, setSearch] = React__namespace.useState('');
    const [size, setSize] = React__namespace.useState(initialSize || sizes.includes(10) ? 10 : sizes[0]);
    const [page, setPage] = React__namespace.useState(1);
    const [pages, setPages] = React__namespace.useState(size > 0 ? Math.ceil(data.length / size) : 1);
    const [sort, setSort] = React__namespace.useState({ column: initialSortColumn, direction: initialSortDirection });
    const [information, setInformation] = React__namespace.useState({});
    const [downloadExcel, setDownloadExcel] = React__namespace.useState(false);
    const { width } = reactNative.useWindowDimensions();
    const _scrollIndex = responsiveCollaps === false && !scrollIndex ? 1 : scrollIndex;
    /* dimensions del contenedor  */
    const [dimensions, setDimensions] = React__namespace.useState(1200);
    /* dimensiones de la tabla */
    const total = headers.reduce((acc, header) => acc += header?.width && header?.width || 0, 0);
    /* control para activar o desactivar el scroll */
    const scrolled = _scrollIndex ? dimensions > total ? false : true : false;
    /* columnas fijas en visualización scroll */
    const fixed = scrolled ? headers.slice(0, _scrollIndex) : headers;
    /* collapsed in responsive  */
    const collapsed = width < MD && responsiveCollaps;
    /* context */
    const context = React__namespace.useContext(OWCContext);
    const tableContext = {
        bordered: true,
        borderColor: context.colors.primary.background,
        rowOddBackgroundColor: context.colors.light.background,
        headerBackgroundColor: context.colors.primary.background,
        headerColor: context.colors.primary.text,
        collapsed,
    };
    /**
     * download excel
     */
    React__namespace.useEffect(() => {
        if (downloadExcel) {
            setDownloadExcel(false);
        }
    }, [downloadExcel]);
    /**
     * gets the column data
     */
    const getColsData = (row) => {
        if (!row) {
            return null;
        }
        return !Array.isArray(row) && !!row.colsData ? row.colsData : row;
    };
    /**
     *
     */
    const handleSearch = debounce$1((value) => {
        setSearch(value);
    }, 500);
    /**
     * gets the sort value for the given data
     */
    const getSortValue = (data) => {
        if (typeof data === 'number') {
            return data;
        }
        if (typeof data === 'string') {
            return data + '';
        }
        if (!data) {
            return '';
        }
        if (!!data.sort) {
            if (typeof data.sort === 'function') {
                return data.sort();
            }
            return data.sort;
        }
        if (!!data.content && ['string', 'number'].includes(typeof data.content)) {
            return data.content;
        }
        return '';
    };
    /**
     * on filter
     */
    React__namespace.useEffect(() => {
        // if (!pagination) {
        //   setFiltered(data);
        //   setLoading(false);
        //   return;
        // }
        let _filtered = data;
        // search
        if (!!searchable) {
            _filtered = _filtered.filter((row) => {
                if (!search) {
                    return true;
                }
                return getColsData(row).some((column) => {
                    if (column === null || column === undefined) {
                        return false;
                    }
                    let text = '';
                    if (isText(column)) {
                        text = column;
                    }
                    else if (!!column.search) {
                        text = column.search;
                    }
                    else if (isText(column.content)) {
                        text = column.content;
                    }
                    else {
                        text = getTextNodes(text);
                    }
                    return (text + '').toLowerCase().includes(search.toLowerCase());
                });
            });
        }
        // total filtered
        const filteredTotal = _filtered.length;
        // pages
        const _size = size < 0 ? data.length : size;
        const pages = Math.max(1, Math.ceil(_filtered.length / _size));
        if (page > pages) {
            return setPage(pages);
        }
        // sort
        _filtered.sort((a, b) => {
            if (typeof a === 'object' && Object.keys(a).includes('colsData')) {
                a = a.colsData;
            }
            if (typeof b === 'object' && Object.keys(b).includes('colsData')) {
                b = b.colsData;
            }
            const sortA = getSortValue(a[sort.column]);
            const sortB = getSortValue(b[sort.column]);
            if (typeof sortA === 'number' && typeof sortB === 'number') {
                return (sortA - sortB) * sort.direction;
            }
            return (sortA + '').localeCompare(sortB + '') * sort.direction;
        });
        // pagination
        const start = Math.max(0, _size * (page - 1));
        const end = Math.max(0, start + Math.min(_size, _filtered.length));
        if (!!pagination) {
            _filtered = _filtered.slice(start, end);
        }
        // set information
        setInformation({
            start: Math.min(start + 1, end),
            end: Math.min(end, filteredTotal),
            filtered: filteredTotal,
            total: data.length
        });
        // set data
        setPages(pages);
        setFiltered(_filtered);
        setLoading(false);
    }, [data, search, size, page, sort]);
    /**
     * loading
     */
    if (loading) {
        return null;
    }
    /**
     * get header data
     */
    const getHeaderData = (header) => {
        if (!header) {
            return { label: ' ' };
        }
        if (typeof header === 'string') {
            return { label: header, sortable: true, flex: 1 };
        }
        return {
            key: header.key,
            sortable: header.sortable !== undefined ? header.sortable : true,
            label: header.label || ' ',
            width: header.width,
            flex: header.flex && !header.width ? header.flex : !header.width && !header.flex ? 1 : undefined,
            justifyContent: header.justifyContent || 'flex-start',
        };
    };
    /**
     *
     */
    const onHeaderClick = (idx) => {
        setSort({ column: idx, direction: sort.column === idx ? sort.direction * -1 : 1 });
    };
    /**
     * get collapsed table data
     */
    const getCollapsedTableData = () => (jsxRuntime.jsxs(React__namespace.Fragment, { children: [jsxRuntime.jsx(TableHead, {}), jsxRuntime.jsx(TableBody, { children: filtered?.map((row, idx) => {
                    return (jsxRuntime.jsx(TableRow, { odd: idx % 2 === 0, flexDirection: 'column', containerStyle: { ...row.rowStyles, flexDirection: 'column' }, children: getColsData(row).map((content, contentIdx) => {
                            const { key, label } = getHeaderData(headers[contentIdx]);
                            return (jsxRuntime.jsxs(reactNative.View, { style: [styles.collapsedContainer, contentIdx === row.length - 1 && { borderBottomWidth: 0 }], children: [!!label?.trim().length && jsxRuntime.jsx(TableData, { data: { content: jsxRuntime.jsx(Text, { style: { fontWeight: 'bold' }, children: label }) } }), jsxRuntime.jsx(TableData, { data: content || collapsed && ' ' })] }, content?.key || key || contentIdx));
                        }) }, idx));
                }) })] }));
    /**
     * get table data
     */
    const getTableData = () => (jsxRuntime.jsxs(reactNative.View, { ref: (node) => node && _scrollIndex && setDimensions(node?.offsetWidth), children: [!!scrolled && (jsxRuntime.jsxs(reactNative.View, { style: [styles.fixed, { borderRightWidth: 1, borderRightColor: context.colors.primary.background }], children: [jsxRuntime.jsx(TableHead, { children: jsxRuntime.jsx(TableRow, { children: fixed.map((header, idx) => {
                                const { key, sortable, label, flex, width, justifyContent } = getHeaderData(header);
                                return (jsxRuntime.jsx(TableHeader, { text: label, width: width, flex: flex, onHeaderClick: !!sortable ? () => onHeaderClick(idx) : undefined, sortDirection: sort.column === idx ? sort.direction : 0, justifyContent: justifyContent }, key || idx));
                            }) }) }), jsxRuntime.jsx(TableBody, { children: filtered?.map((row, idx) => (jsxRuntime.jsx(TableRow, { odd: idx % 2 === 1, containerStyle: row.rowStyles, children: getColsData(row).map((content, contentIdx) => {
                                const header = fixed[contentIdx];
                                const { flex, width, justifyContent } = getHeaderData(header);
                                if (header) {
                                    return (jsxRuntime.jsx(TableData, { data: content, flex: flex, width: width, compact: compact, justifyContent: justifyContent }, content?.key || contentIdx));
                                }
                                else {
                                    return jsxRuntime.jsx(jsxRuntime.Fragment, {});
                                }
                            }) }, idx))) })] })), !!scrolled && (jsxRuntime.jsx(reactNative.ScrollView, { horizontal: true, children: jsxRuntime.jsxs(reactNative.View, { style: { display: 'flex', flexDirection: 'column' }, children: [jsxRuntime.jsx(TableHead, { children: jsxRuntime.jsx(TableRow, { children: headers.map((header, idx) => {
                                    const { key, sortable, label, flex, width, justifyContent } = getHeaderData(header);
                                    return (jsxRuntime.jsx(TableHeader, { text: label, width: width, flex: flex, onHeaderClick: !!sortable ? () => onHeaderClick(idx) : undefined, sortDirection: sort.column === idx ? sort.direction : 0, justifyContent: justifyContent }, key || idx));
                                }) }) }), jsxRuntime.jsx(TableBody, { children: filtered?.map((row, idx) => (jsxRuntime.jsx(TableRow, { odd: idx % 2 === 1, containerStyle: row.rowStyles, children: getColsData(row).map((content, contentIdx) => {
                                    const header = headers[contentIdx];
                                    const { flex, width, justifyContent } = getHeaderData(header);
                                    return (jsxRuntime.jsx(TableData, { data: content, flex: flex, width: width, compact: compact, justifyContent: justifyContent }, content?.key || contentIdx));
                                }) }, idx))) })] }) })), (!scrolled) && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(TableHead, { children: jsxRuntime.jsx(TableRow, { children: headers.map((header, idx) => {
                                const { key, sortable, label, flex, width, justifyContent } = getHeaderData(header);
                                return (jsxRuntime.jsx(TableHeader, { text: label, width: width, flex: flex, onHeaderClick: !!sortable ? () => onHeaderClick(idx) : undefined, sortDirection: sort.column === idx ? sort.direction : 0, justifyContent: justifyContent }, key || idx));
                            }) }) }), jsxRuntime.jsx(TableBody, { children: filtered?.map((row, idx) => (jsxRuntime.jsx(TableRow, { odd: idx % 2 === 1, containerStyle: row.rowStyles, children: getColsData(row).map((content, contentIdx) => {
                                const header = headers[contentIdx];
                                const { flex, width, justifyContent } = getHeaderData(header);
                                return (jsxRuntime.jsx(TableData, { data: content, flex: flex, width: width, compact: compact, justifyContent: justifyContent }, content?.key || contentIdx));
                            }) }, idx))) })] })), !!footer && (jsxRuntime.jsx(TableRow, { containerStyle: { backgroundColor: context.colors.primary.background }, children: getColsData(footer).map((content, contentIdx) => {
                    const header = headers[contentIdx];
                    const { flex, width } = getHeaderData(header);
                    return (jsxRuntime.jsx(TableData, { data: content, flex: flex, width: width, compact: compact }, contentIdx));
                }) }))] }));
    /**
     *
     */
    const getSizesDescription = (size) => {
        if (size === -1) {
            return t('common:table.ALL');
        }
        return size + '';
    };
    /**
     *
     */
    const getExcelHeader = () => {
        return headers.map((header) => {
            const { label } = getHeaderData(header);
            return label;
        });
    };
    /**
     *
     */
    const getExcelData = () => {
        let excel = [];
        excel.push(getExcelHeader()); // header
        // data
        excel = excel.concat(data.map((row) => (Array.isArray(row) && row || row.colsData || []).map((column) => {
            if (column === null || column === undefined) {
                return '';
            }
            // column is a string or a number
            if (isText(column)) {
                return column + '';
            }
            if (typeof column === 'function') {
                // column is a react element
                if (React__namespace.isValidElement(column)) {
                    return getTextNodes(column);
                }
                // column is a function
                return getTextNodes(column());
            }
            // render property
            if (!!column.render) {
                return getTextNodes(column.render());
            }
            if (Object.keys(column).includes('csv')) {
                return column.csv;
            }
            if (Object.keys(column).includes('content')) {
                if (column.content === undefined || column.content === null) {
                    return ' ';
                }
                // content property is a react component
                if (React__namespace.isValidElement(column.content)) {
                    return getTextNodes(column.content);
                }
                // content property is a function
                if (typeof column.content === 'function') {
                    return getTextNodes(column.content());
                }
                // content property
                return getTextNodes(column.content);
            }
            // default
            return ' ';
        })));
        return excel;
    };
    /**
     * render
     */
    return (jsxRuntime.jsx(TableContext.Provider, { value: tableContext, children: jsxRuntime.jsxs(reactNative.View, { style: styles.container, children: [jsxRuntime.jsxs(reactNative.View, { style: styles.preTableContainer, children: [pagination && (jsxRuntime.jsx(reactNative.View, { style: styles.sizeContainer, children: jsxRuntime.jsx(Picker, { items: sizes.map((value) => ({ label: getSizesDescription(value), value: value })), onChange: (value) => setSize(value), defaultOptionLabel: null, selected: size }) })), searchable && (jsxRuntime.jsx(reactNative.View, { style: styles.searchContainer, children: jsxRuntime.jsx(Input, { onChange: handleSearch, placeholder: t('common:table.search') + '...' }) })), !!csvButton &&
                            jsxRuntime.jsx(reactCsv.CSVLink, { filename: `${fileName ? fileName + "-" : ''}${generate()}.csv`, data: getExcelData(), separator: ';', style: { textDecoration: 'none' }, children: jsxRuntime.jsxs(reactNative.View, { style: { marginLeft: 5, minWidth: 0, height: 40, borderWidth: 1, borderColor: '#ccc', backgroundColor: '#eeeeee', width: 46, justifyContent: 'center', borderRadius: 5 }, children: [jsxRuntime.jsx(Icon, { marginBottom: -5, marginRight: 0, color: '#5f5f5f', type: 'fileDownload' }), jsxRuntime.jsx(Text, { uppercase: true, textAlign: 'center', fontSize: 8, children: "CSV" })] }) })] }), jsxRuntime.jsx(reactNative.View, { style: styles.tableContainer, children: collapsed ? getCollapsedTableData() : getTableData() }), (pagination || searchable) && (jsxRuntime.jsxs(reactNative.View, { style: styles.postTableContainer, children: [jsxRuntime.jsx(reactNative.View, { style: styles.filterInformation, children: jsxRuntime.jsx(Text, { children: t('common:table.filterInformation', information) }) }), pagination && (jsxRuntime.jsx(reactNative.View, { children: jsxRuntime.jsx(Pagination, { onChange: (value) => setPage(value), page: page, pages: pages }) }))] }))] }) }));
};
const styles = reactNative.StyleSheet.create({
    container: {
        width: '100%',
        marginBottom: 15,
    },
    preTableContainer: {
        width: '100%',
        flexDirection: 'row',
    },
    sizeContainer: {
        marginRight: 5,
        width: 60,
    },
    fixed: {
        position: 'absolute',
        top: 0,
        zIndex: 99,
        backgroundColor: 'white'
        // borderRightWidth: 1,
    },
    searchContainer: {
        flex: 1,
    },
    tableContainer: {
        width: '100%',
        // borderBottomWidth: 1,
        // borderRightWidth: 1,
        marginBottom: 15,
    },
    postTableContainer: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
    },
    filterInformation: {
        flex: 1,
    },
    collapsedContainer: {
        flexDirection: 'column',
        justifyContent: 'center',
        borderBottomWidth: 1,
        borderColor: '#ccc',
        padding: 5,
    },
});

const Tabs = React.forwardRef(({ tabnames, buttonStyle, alignTabs = 'flex-start', borderBottomWidth = 1, borderWidth = 1, textTransform = 'none', activeBold = false, onChangeTab = () => { }, defaultTab = 0, children, activeColor, inactiveColor = '#ccc', isClosable = () => false, onClose, containerStyle, contentStyle }, ref) => {
    const [activeTab, setActiveTab] = React.useState(defaultTab < children.length ? defaultTab : 0);
    const context = React.useContext(OWCContext);
    const color = activeColor || context.colors.primary.background;
    const styles = useResponsiveStyles({ xs: xs$1, md: md$1 });
    const [viewWidth, setViewWidth] = React.useState(0);
    const [tabWidthsSum, setTabWidthsSum] = React.useState(0);
    const [tabWidths, setTabWidths] = React.useState([]);
    const scrollRef = React.useRef(null);
    const [currentOffset, setCurrentOffset] = React.useState(0); // Controla la posición actual del scroll
    /**
     * expose methods
     */
    React.useImperativeHandle(ref, () => ({
        selectTab,
    }));
    /**
     * component did mount
     */
    useComponentDidMount(() => {
        if (children?.length > 0) {
            onChangeTab(defaultTab);
        }
    });
    /**
     * on children change
     */
    React.useEffect(() => {
        if (!!children?.length) {
            if (activeTab >= children.length) {
                selectTab(0);
            }
        }
    }, [children]);
    /**
     * select tab
     */
    const selectTab = (tab) => {
        if (activeTab !== tab) {
            if (tab >= 0 && tab < children?.length) {
                setActiveTab(tab);
                onChangeTab(tab);
            }
            else {
                setActiveTab(0);
            }
        }
    };
    /**
     * close tab
     */
    const close = (index) => {
        onClose?.(index);
    };
    /* Detectamos tamaño div contenedor */
    const handleLayout = (event) => {
        const { width } = event.nativeEvent.layout;
        if (width > 0) {
            setViewWidth(width);
        }
    };
    /* Detectamos tamaño total tabs  */
    const handleLayoutTab = (event, index) => {
        const { width } = event.nativeEvent.layout;
        if (width > 0) {
            setTimeout(() => {
                setTabWidths((prevWidths) => {
                    const newWidths = [...prevWidths];
                    newWidths[index] = width;
                    return newWidths;
                });
            }, 50);
        }
    };
    /* flecha scroll left */
    const scrollLeft = () => {
        if (scrollRef.current) {
            // Calcula el próximo desplazamiento a la izquierda, sin sobrepasar el inicio
            const newOffset = Math.max(currentOffset - 70, 0);
            scrollRef.current.scrollTo({ x: newOffset, animated: true });
            setCurrentOffset(newOffset);
        }
    };
    /* flecha scroll right */
    const scrollRight = () => {
        if (scrollRef.current) {
            const maxOffset = tabWidthsSum - viewWidth;
            const newOffset = Math.min(currentOffset + 70, (maxOffset));
            scrollRef.current.scrollTo({ x: newOffset, animated: true });
            setCurrentOffset(newOffset);
        }
    };
    React.useEffect(() => {
        const totalWidth = tabWidths.reduce((acc, width) => acc + width, 0);
        setTabWidthsSum(totalWidth + 65);
    }, [tabWidths]);
    /**
     * render
     */
    return (jsxRuntime.jsxs(reactNative.View, { style: [{ width: '100%' }, containerStyle], children: [jsxRuntime.jsxs(reactNative.View, { onLayout: handleLayout, children: [jsxRuntime.jsxs(reactNative.View, { style: { flexDirection: 'row', alignItems: "center" }, children: [tabWidthsSum > viewWidth && (jsxRuntime.jsx(reactNative.TouchableOpacity, { style: { height: '100%', width: 30, justifyContent: 'center', alignContent: 'center' }, onPress: scrollLeft, children: jsxRuntime.jsx(reactNative.View, { style: { zIndex: 99999, height: 25, width: 25, borderRadius: 999, justifyContent: 'center', backgroundColor: context.colors.primary.background, shadowColor: 'rgba(0, 0, 0, 0.3)' }, children: jsxRuntime.jsx(Icon, { type: 'arrowleft', fontSize: 12, padding: 0, marginBottom: 0, marginRight: 0, color: context.colors.primary.text }) }) })), jsxRuntime.jsx(reactNative.ScrollView, { ref: scrollRef, horizontal: true, showsHorizontalScrollIndicator: false, contentContainerStyle: { flexDirection: 'row', justifyContent: tabWidthsSum > viewWidth ? 'flex-start' : alignTabs, flex: 1 }, children: tabnames.map((tabName, index) => {
                                    const name = typeof tabName === "string" ? tabName : tabName?.name;
                                    const onPress = typeof tabName === 'string' ? () => selectTab(index) : () => {
                                        tabName?.onPress(); // Ejecuta la función onPress personalizada
                                        !!tabName?.onPressUpdateIndexTab && selectTab(index); // Actualiza el tab seleccionado
                                    };
                                    const url = typeof tabName === "string" ? undefined : tabName?.url;
                                    return (jsxRuntime.jsxs(reactNative.View, { onLayout: (event) => handleLayoutTab(event, index), style: [{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', minWidth: 100 }, activeTab === index ? [styles.buttonsActive, { borderWidth: borderWidth }] : [styles.buttonsInactive, { borderBottomWidth: 0 }]], children: [url ?
                                                jsxRuntime.jsx(Link, { to: url, type: 'link', tab: true, textTransform: textTransform, color: context.colors.primary.text, styles: { paddingTop: 10, paddingRight: 15, paddingBottom: 10, paddingLeft: 15, color: context.colors.primary.text, ...buttonStyle }, containerStyle: [styles.button], ...buttonStyle, children: name })
                                                :
                                                    jsxRuntime.jsx(Button, { type: 'link', text: name, textTransform: textTransform, fontWeight: activeTab === index ? activeBold ? 900 : 400 : 400, onPress: onPress, color: activeTab !== index && inactiveColor || color, containerStyle: styles.button, ...buttonStyle }), isClosable(index) && jsxRuntime.jsx(Icon, { type: 'close', onPress: () => close(index) })] }, index));
                                }) }), tabWidthsSum > viewWidth && (jsxRuntime.jsx(reactNative.TouchableOpacity, { style: { height: '100%', width: 30, alignItems: "flex-end", justifyContent: 'center', alignContent: 'center' }, onPress: scrollRight, children: jsxRuntime.jsx(reactNative.View, { style: { zIndex: 99999, height: 25, width: 25, borderRadius: 999, justifyContent: 'center', backgroundColor: context.colors.primary.background, shadowColor: 'rgba(0, 0, 0, 0.3)' }, children: jsxRuntime.jsx(Icon, { type: 'arrowright', fontSize: 12, padding: 0, marginBottom: 0, marginRight: 0, color: context.colors.primary.text }) }) }))] }), jsxRuntime.jsx(reactNative.View, { style: { height: 1, display: 'flex', flex: 1, borderTopColor: inactiveColor, borderTopWidth: borderBottomWidth, borderStyle: 'solid', marginTop: -1, zIndex: -999 } })] }), jsxRuntime.jsx(reactNative.View, { style: [{ paddingTop: 15, }, contentStyle], children: children?.[activeTab] || null })] }));
});
const xs$1 = reactNative.StyleSheet.create({
    buttonsActive: {
        borderColor: '#ccc',
        borderBottomColor: 'white',
        //backgroundColor: 'white'
    },
    buttonsInactive: {
        borderColor: '#ccc',
    },
    button: {
        marginBottom: 0, minWidth: 0, paddingLeft: 10, paddingRight: 10, paddingTop: 10, paddingBottom: 10
    }
});
const md$1 = reactNative.StyleSheet.create({
    buttonsActive: {
        borderColor: '#ccc',
        borderBottomColor: 'white',
    },
    buttonsInactive: {
        borderColor: '#ccc',
    },
    button: {
        marginBottom: 0, paddingLeft: 10, paddingRight: 10, paddingTop: 10, paddingBottom: 10
    }
});

/**
 * TextArea generic component
 */
const TextArea = ({ rows = 5, onChange = () => { }, disabled = false, value, defaultValue, placeholder, containerStyle, label }) => {
    /**
     * handle change
     * @param text
     */
    const handleChange = (text) => {
        onChange(text);
    };
    /**
     * render
     */
    return (jsxRuntime.jsx(Input, { onChange: handleChange, defaultValue: defaultValue, value: value, label: label, placeholder: placeholder, disabled: disabled, numberOfLines: rows, containerStyle: [{ paddingTop: 5 }, containerStyle] }));
};

const BorderedTitle = (props) => {
    return (jsxRuntime.jsx(Title, { ...props, borderBottomWidth: 1, containerStyle: { paddingBottom: 20 }, borderColor: '#eee', uppercase: true }));
};

const Tooltip = ({ label }) => {
    return (jsxRuntime.jsx(Text, { children: label }));
};

const getErrorMessage = (error) => {
    return error?.response?.data?.issuer === 'optimalway' ? error.response.data.message : t('common:errors.defaultErrorMessage');
};

var ErrorUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getErrorMessage: getErrorMessage
});

const OWCContextProvider = ({ children, defaultColors = {}, defaultFonts = {}, navigate, defaultJwtRole, defaultUrls }) => {
    const alertsRef = React.useRef([]); // setTimeout makes a copy of alerts on create, we need a ref
    const [alerts, setAlerts] = React.useState([]);
    const [colors$1, _setColors] = React.useState({ ...colors, ...defaultColors });
    const [fonts$1, _setFonts] = React.useState({ ...fonts, ...defaultFonts });
    const [jwtRole$1, _setJwtRole] = React.useState(defaultJwtRole ? defaultJwtRole : jwtRole);
    const [urls$1, _setUrls] = React.useState(defaultUrls ? defaultUrls : urls);
    /**
     * create alert
     */
    const createAlert = React.useCallback((alert) => {
        const id = alert.id || Math.random() * 1000;
        const type = alert.type || 'error';
        const text = alert.text;
        alertsRef.current = [...alertsRef.current, { id, type, text }];
        setAlerts(alertsRef.current);
        setTimeout(() => deleteAlert(id), alert.timeout || 6 * 1000);
    }, []);
    /**
     * create default error alert
     */
    const createDefaultErrorAlert = React.useCallback((error) => {
        createAlert({ text: getErrorMessage(error) });
    }, []);
    /**
     * delete alert
     */
    const deleteAlert = React.useCallback((id) => {
        alertsRef.current = alertsRef.current.filter((alert) => alert.id !== id);
        setAlerts(alertsRef.current);
    }, []);
    /**
     *
     * @param _colors
     */
    const setColors = React.useCallback((_colors = {}) => {
        _setColors({ ...colors, ..._colors });
    }, [colors]);
    /**
     *
     * @param _fonts
     */
    const setFonts = React.useCallback((_fonts = {}) => {
        _setFonts({ ...fonts, ..._fonts });
    }, [fonts]);
    /**
     *
     * @param _jwtRole
     */
    const setJwtRole = React.useCallback((_jwtRole) => {
        _setJwtRole(_jwtRole);
    }, [jwtRole]);
    /**
   *
   * @param _urls
   */
    const setUrls = React.useCallback((_urls) => {
        _setUrls(_urls);
    }, [urls]);
    /**
     * context
     */
    const context = {
        alerts: {
            items: alerts,
            create: createAlert,
            createDefaultError: createDefaultErrorAlert,
            delete: deleteAlert,
        },
        setColors,
        colors: colors$1,
        setFonts,
        fonts: fonts$1,
        navigate: navigate || ((route, params) => {
            if (!!params?.tab) {
                window.open(route, '_blank');
                return;
            }
            window.location.href = route;
        }),
        jwtRole: jwtRole$1,
        setJwtRole,
        urls: urls$1,
        setUrls
    };
    /**
     * render
     */
    return (jsxRuntime.jsxs(OWCContext.Provider, { value: context, children: [jsxRuntime.jsx(AlertManager, {}), children] }));
};

const useLoad = (func, defaultValue) => {
    const [data, setData] = React.useState(defaultValue);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState();
    React.useEffect(() => {
        Promise.resolve(func()).then((data) => {
            setData(data);
        }).catch((error) => {
            setError(error.message);
        }).finally(() => {
            setLoading(false);
        });
    }, []);
    return [data, loading, error];
};

const useScreenSize = () => {
    const { width } = reactNative.useWindowDimensions();
    if (width > XL) {
        return 'xl';
    }
    if (width > LG) {
        return 'lg';
    }
    if (width > MD) {
        return 'md';
    }
    if (width > SM) {
        return 'sm';
    }
    return 'xs';
};

var global$3 = {
	selectAnOption: "Selecciona una opció",
	accept: "Acceptar",
	clear: "Netejar"
};
var errors$3 = {
	defaultErrorMessage: "Error al processar la petició"
};
var table$3 = {
	empty: "No hi ha informació disponible",
	filterInformation: "Mostrant de {{start}} a {{end}} d'un filtrat de {{filtered}} i un total de {{total}}",
	search: "Buscar",
	ALL: "Tot"
};
var date$3 = {
	monday: "Dilluns",
	tuesday: "Dimarts",
	wednesday: "Dimecres",
	thursday: "Dijous",
	friday: "Divendres",
	saturday: "Dissabte",
	sunday: "Diumenge"
};
var dateShort$3 = {
	monday: "Dl",
	tuesday: "Dm",
	wednesday: "Dc",
	thursday: "Dj",
	friday: "Dv",
	saturday: "Ds",
	sunday: "Dg"
};
var month$3 = {
	january: "Gener",
	february: "Febrer",
	march: "Març",
	april: "Abril",
	may: "Maig",
	june: "Juny",
	july: "Juliol",
	august: "Agost",
	september: "Setembre",
	october: "Octubre",
	november: "Novembre",
	december: "Desembre"
};
var timezone$3 = {
	morning: "Matí",
	afternoon: "Tarda"
};
var modal$3 = {
	alert: "Alerta",
	confirm: "Confirmar",
	accept: "Acceptar",
	close: "Tancar"
};
var dualList$3 = {
	elements: "Elements",
	selected: "Seleccionats",
	search: "Buscar...",
	addAll: "Afegir tots",
	addSelected: "Afegir seleccionats",
	removeAll: "Eliminar tots",
	removeSelected: "Eliminar seleccionats"
};
var cookies$3 = {
	accept: "D'acord",
	close: "Rebutjar"
};
var fileButton$3 = {
	selectDocument: "Seleccionar Document",
	invalidExtension: "El fitxer té una extensió invàlida. Només s'accepten {{validExtensions}}",
	invalidSize: "El fitxer excedeix el tamany màxim"
};
var dateTimePicker$3 = {
	initialdate: "Data inicial",
	hour: "Hora",
	min: "Minut",
	finaldate: "Data final",
	apply: "Aplicar",
	dateLabel: "dd/mm/aaaa",
	timeLabel: "hh:mm"
};
var datatable$3 = {
	all: "Tot",
	empty: "No hi ha registres",
	filter: {
		block: "Bloquejar",
		title: "Filtre",
		exact: "Exactament",
		contains: "Conté",
		value: "Valor",
		select: "Seleccionar tot",
		deselect: "Deseleccionar tot"
	},
	search: "Buscar",
	visibility: "Visibilitat"
};
var ca = {
	global: global$3,
	errors: errors$3,
	table: table$3,
	date: date$3,
	dateShort: dateShort$3,
	month: month$3,
	timezone: timezone$3,
	modal: modal$3,
	dualList: dualList$3,
	cookies: cookies$3,
	fileButton: fileButton$3,
	dateTimePicker: dateTimePicker$3,
	datatable: datatable$3
};

var global$2 = {
	selectAnOption: "Selecciona una opción",
	accept: "Aceptar",
	clear: "Limpiar"
};
var errors$2 = {
	defaultErrorMessage: "Error al procesar la petición"
};
var table$2 = {
	empty: "No hay información disponible",
	filterInformation: "Mostrando de {{start}} a {{end}} de un filtrado de {{filtered}} y un total total de {{total}}",
	search: "Buscar",
	ALL: "Todo"
};
var date$2 = {
	monday: "Lunes",
	tuesday: "Martes",
	wednesday: "Miércoles",
	thursday: "Jueves",
	friday: "Viernes",
	saturday: "Sábado",
	sunday: "Domingo"
};
var dateShort$2 = {
	monday: "Lu",
	tuesday: "Ma",
	wednesday: "Mi",
	thursday: "Ju",
	friday: "Vi",
	saturday: "Sa",
	sunday: "Do"
};
var month$2 = {
	january: "Enero",
	february: "Febrero",
	march: "Marzo",
	april: "Abril",
	may: "Mayo",
	june: "Junio",
	july: "Julio",
	august: "Agosto",
	september: "Septiembre",
	october: "Octubre",
	november: "Noviembre",
	december: "Diciembre"
};
var timezone$2 = {
	morning: "Mañana",
	afternoon: "Tarde"
};
var modal$2 = {
	alert: "Alerta",
	confirm: "Confirmar",
	accept: "Aceptar",
	close: "Cerrar"
};
var dualList$2 = {
	elements: "Elementos",
	selected: "Seleccionados",
	search: "Buscar...",
	addAll: "Añadir todos",
	addSelected: "Añadir seleccionados",
	removeAll: "Eliminar todos",
	removeSelected: "Eliminar seleccionados"
};
var cookies$2 = {
	accept: "D'acord",
	close: "Rebutjar"
};
var fileButton$2 = {
	selectDocument: "Seleccionar Documento",
	invalidExtension: "El archivo tiene una extensión inválida. Solo se acepta {{validExtensions}}",
	invalidSize: "El archivo excede el tamaño máximo"
};
var dateTimePicker$2 = {
	initialdate: "Fecha inicial",
	hour: "Hora",
	min: "Minuto",
	finaldate: "Fecha final",
	apply: "Aplicar",
	dateLabel: "dd/mm/aaaa",
	timeLabel: "hh:mm"
};
var datatable$2 = {
	all: "Todo",
	empty: "No hay registros",
	filter: {
		block: "Bloquear",
		title: "Filtro",
		exact: "Exactamente",
		contains: "Contiene",
		value: "Valor",
		select: "Seleccionar todo",
		deselect: "Deseleccionar todo"
	},
	search: "Buscar",
	visibility: "Visibilidad"
};
var es = {
	global: global$2,
	errors: errors$2,
	table: table$2,
	date: date$2,
	dateShort: dateShort$2,
	month: month$2,
	timezone: timezone$2,
	modal: modal$2,
	dualList: dualList$2,
	cookies: cookies$2,
	fileButton: fileButton$2,
	dateTimePicker: dateTimePicker$2,
	datatable: datatable$2
};

var global$1 = {
	selectAnOption: "Select an option",
	accept: "Accept",
	clear: "Clear"
};
var errors$1 = {
	defaultErrorMessage: "Error processing request"
};
var table$1 = {
	empty: "There is no information available",
	filterInformation: "Showing {{start}} to {{end}} of a {{filtered}} filter and a total of {{total}}",
	search: "Search",
	ALL: "All"
};
var date$1 = {
	monday: "Monday",
	tuesday: "Tuesday",
	wednesday: "Wednesday",
	thursday: "Thursday",
	friday: "Friday",
	saturday: "Saturday",
	sunday: "Sunday"
};
var dateShort$1 = {
	monday: "Mo",
	tuesday: "Tu",
	wednesday: "We",
	thursday: "Th",
	friday: "Fr",
	saturday: "Sa",
	sunday: "Su"
};
var month$1 = {
	january: "January",
	february: "February",
	march: "March",
	april: "April",
	may: "May",
	june: "June",
	july: "July",
	august: "August",
	september: "September",
	october: "October",
	november: "November",
	december: "December"
};
var timezone$1 = {
	morning: "Morning",
	afternoon: "Afternoon"
};
var modal$1 = {
	alert: "Alert",
	confirm: "Confirm",
	accept: "Accept",
	close: "Close"
};
var dualList$1 = {
	elements: "Elements",
	selected: "Selected",
	search: "Search...",
	addAll: "Add them all",
	addSelected: "Add selected",
	removeAll: "Delete all",
	removeSelected: "Delete selected"
};
var cookies$1 = {
	accept: "OK",
	close: "Reject"
};
var fileButton$1 = {
	selectDocument: "Select Document",
	invalidExtension: "The file has an invalid extension. Only accept {{validExtensions}}",
	invalidSize: "File exceeds maximum size"
};
var dateTimePicker$1 = {
	initialdate: "Start date",
	hour: "Time",
	min: "Minutes",
	finaldate: "End date",
	apply: "Apply",
	dateLabel: "dd/mm/yyyy",
	timeLabel: "hh:mm"
};
var datatable$1 = {
	all: "All",
	empty: "No data",
	filter: {
		block: "Block",
		title: "Filter",
		exact: "Exact",
		contains: "Contains",
		value: "Value",
		select: "Select all",
		deselect: "Deselect all"
	},
	search: "Search",
	visibility: "Visibility"
};
var en = {
	global: global$1,
	errors: errors$1,
	table: table$1,
	date: date$1,
	dateShort: dateShort$1,
	month: month$1,
	timezone: timezone$1,
	modal: modal$1,
	dualList: dualList$1,
	cookies: cookies$1,
	fileButton: fileButton$1,
	dateTimePicker: dateTimePicker$1,
	datatable: datatable$1
};

var global = {
	selectAnOption: "Selecione uma opção",
	accept: "Aceptar",
	clear: "Limpiar"
};
var errors = {
	defaultErrorMessage: "Erro ao processar a solicitação"
};
var table = {
	empty: "Não há informação disponível",
	filterInformation: "Exibindo de {{start}} a {{end}} de uma filtragem de {{filtered}} e um total total de {{total}}",
	search: "Pesquisar",
	ALL: "Tudo"
};
var date = {
	monday: "Segunda-feira",
	tuesday: "Terça-feira",
	wednesday: "Quarta-feira",
	thursday: "Quinta-feira",
	friday: "Sexta-feira",
	saturday: "Sábado",
	sunday: "Domingo"
};
var dateShort = {
	monday: "Seg",
	tuesday: "Ter",
	wednesday: "Qua",
	thursday: "Qui",
	friday: "Sex",
	saturday: "Sáb",
	sunday: "Dom"
};
var month = {
	january: "Janeiro",
	february: "Fevereiro",
	march: "Março",
	april: "Abril",
	may: "Maio",
	june: "Junho",
	july: "Julho",
	august: "Agosto",
	september: "Setembro",
	october: "Outubro",
	november: "Novembro",
	december: "Dezembro"
};
var timezone = {
	morning: "Manhã",
	afternoon: "Tarde"
};
var modal = {
	alert: "Alerta",
	confirm: "Confirmar",
	accept: "Aceitar",
	close: "Fechar"
};
var dualList = {
	elements: "Elementos",
	selected: "Selecionados",
	search: "Buscar...",
	addAll: "Adicionar tudo",
	addSelected: "Adicionar selecionado",
	removeAll: "Excluir all",
	removeSelected: "Excluir selecionado"
};
var cookies = {
	accept: "D'acord",
	close: "Rebutjar"
};
var fileButton = {
	selectDocument: "Selecionar documento",
	invalidExtension: "O arquivo possui uma extensão inválida. Só são aceito {{validExtensions}}",
	invalidSize: "O arquivo excede o tamanho máximo"
};
var dateTimePicker = {
	initialdate: "Data inicial",
	hour: "Hora",
	min: "Minuto",
	finaldate: "Data final",
	apply: "Aplicar",
	dateLabel: "dd/mm/aaaa",
	timeLabel: "hh:mm"
};
var datatable = {
	all: "Todo",
	empty: "No hay registros",
	filter: {
		block: "Bloquear",
		title: "Filtro",
		exact: "Exactamente",
		contains: "Contiene",
		value: "Valor",
		select: "Seleccionar todo",
		deselect: "Deseleccionar todo"
	},
	search: "Buscar",
	visibility: "Visibilidad"
};
var pt = {
	global: global,
	errors: errors,
	table: table,
	date: date,
	dateShort: dateShort,
	month: month,
	timezone: timezone,
	modal: modal,
	dualList: dualList,
	cookies: cookies,
	fileButton: fileButton,
	dateTimePicker: dateTimePicker,
	datatable: datatable
};

const translation = { ca, es, en, pt };

const get = (value = '') => {
    value = parseFloat(value + '');
    return value.toFixed(2) + ' €';
};

var CurrencyUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get: get
});

const deepMerge = (target, source) => {
    const isObject = (obj) => obj && typeof obj === 'object';
    if (!isObject(target) || !isObject(source)) {
        return source;
    }
    Object.keys(source).forEach(key => {
        if (Array.isArray(target[key]) && Array.isArray(source[key])) {
            target[key] = target[key].concat(source[key]);
        }
        else if (isObject(target[key]) && isObject(source[key])) {
            target[key] = deepMerge(Object.assign({}, target[key]), source[key]);
        }
        else {
            target[key] = source[key];
        }
    });
    return target;
};

var MergeUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  deepMerge: deepMerge
});

const isEmpty = (value) => {
    return !value || !value.length || !value.trim().length;
};
const isEmail = (email) => {
    return /(?:[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.exec(email);
};
// export const isNIF = (nif: string) => {
//   return /((([x-zX-Z])|([lmLM])){1}([-]?)((\d){7})([-]?)([a-zA-Z]{1}))|((\d{8})([-]?)([a-zA-Z]))/.exec(nif);
// }
const isNIF = (nif) => {
    if (nif == null) {
        return false;
    }
    const letters = 'TRWAGMYFPDXBNJZSQVHLCKET';
    nif = nif.toUpperCase();
    if (!/^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i.test(nif) && !/^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i.test(nif)) {
        return false;
    }
    const nie = nif.replace(/^[X]/, '0').replace(/^[Y]/, '1').replace(/^[Z]/, '2');
    const letter = nif.substr(-1);
    const index = parseInt(nie.substr(0, 8)) % 23;
    if (letters.charAt(index) === letter) {
        return true;
    }
    return false;
};
const isDate = (date) => {
    return /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.exec(date);
};

var ValidationUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isDate: isDate,
  isEmail: isEmail,
  isEmpty: isEmpty,
  isNIF: isNIF
});

const HorizontalBar = ({ data }) => {
    let _values = [];
    let _extensive = data;
    const styles = useResponsiveStyles({ xs, md, lg, xl });
    const context = React.useContext(OWCContext);
    _extensive.forEach((item) => {
        if (item) {
            _values.push(item?.val1);
            _values.push(item?.val2);
        }
    });
    const min = Math.min(..._values);
    const max = Math.max(..._values);
    // Calcular el ancho máximo del label
    const maxLabelWidth = Math.max(..._extensive.map((item) => item?.label ? String(item.label).length : 0));
    return (jsxRuntime.jsx(reactNative.View, { style: styles.extensiveContent, children: _extensive.map((item) => {
            if (!item)
                return null;
            let _val1 = ((item.val1 - min) / (max - min)) * 100;
            let _val2 = ((item.val2 - min) / (max - min)) * 100;
            return (jsxRuntime.jsxs(reactNative.View, { style: { flexDirection: 'row' }, children: [jsxRuntime.jsx(reactNative.View, { style: { flex: 3, alignItems: 'flex-end' }, children: jsxRuntime.jsx(reactNative.View, { style: [
                                styles.extensiveBarLeft,
                                { backgroundColor: context.colors.primary.background, width: `${_val1}%` },
                            ] }) }), jsxRuntime.jsx(reactNative.View, { style: [styles.extensivePointsContent, { backgroundColor: '#dcdcdc', marginBottom: 3 }], children: jsxRuntime.jsx(Text, { fontSize: 15, style: styles.extensiveText, bold: true, textAlign: 'center', children: item?.val1 }) }), jsxRuntime.jsx(reactNative.View, { style: [
                            styles.extensiveLabelContent2,
                            {
                                width: maxLabelWidth * 10,
                                marginBottom: 3,
                                backgroundColor: '#eeeeee',
                            },
                        ], children: jsxRuntime.jsx(Text, { style: styles.extensiveText, children: item?.label }) }), jsxRuntime.jsx(reactNative.View, { style: [styles.extensivePointsContent, { backgroundColor: '#dcdcdc', marginBottom: 3 }], children: jsxRuntime.jsx(Text, { fontSize: 15, style: styles.extensiveText, bold: true, textAlign: 'center', children: item?.val2 }) }), jsxRuntime.jsx(reactNative.View, { style: { flex: 3, alignItems: 'flex-start' }, children: jsxRuntime.jsx(reactNative.View, { style: [
                                styles.extensiveBarRight,
                                { backgroundColor: context.colors.secondary.background, width: `${_val2}%` },
                            ] }) })] }, item.label));
        }) }));
};
const xs = reactNative.StyleSheet.create({
    extensiveContent: {
        flexDirection: 'column',
        marginBottom: 20,
    },
    extensiveBarRight: {
        alignItems: 'flex-end',
        height: 20,
        marginBottom: 3,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 99,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 99,
    },
    extensiveBarLeft: {
        alignItems: 'flex-end',
        height: 20,
        marginBottom: 3,
        borderTopLeftRadius: 99,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 99,
        borderBottomRightRadius: 0,
    },
    extensiveText: {
        fontSize: 11,
    },
    extensiveLabelContent2: {
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 70
    },
    extensivePointsContent: {
        width: 25,
        justifyContent: 'center',
    },
});
const md = reactNative.StyleSheet.create({
    extensiveContent: {
        flexDirection: 'column',
        marginBottom: 20,
    },
    extensiveBar: {
        borderRadius: 99,
        alignItems: 'flex-end',
        height: 23,
        marginBottom: 3,
    },
    extensiveText: {
        fontSize: 12,
    },
    extensiveLabelContent2: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    extensivePointsContent: {
        width: 35,
    },
});
const lg = reactNative.StyleSheet.create({});
const xl = reactNative.StyleSheet.create({});

exports.Alert = Alert;
exports.AlertManager = AlertManager;
exports.BackgroundLoader = BackgroundLoader;
exports.BigIcon = BigIcon;
exports.BorderedTitle = BorderedTitle;
exports.Button = Button;
exports.ButtonTab = ButtonTab;
exports.Card = Card;
exports.Checkbox = Checkbox;
exports.CircleImage = CircleImage;
exports.Collapsible = Collapsible;
exports.CompletedBar = CompletedBar;
exports.ComponentLoader = ComponentLoader;
exports.Container = Container;
exports.Cookies = Cookies;
exports.CurrencyUtils = CurrencyUtils;
exports.CustomPicker = CustomPicker;
exports.Datatable = Datatable;
exports.DateTimePicker = DateTimePicker;
exports.DateUtils = DateUtils$1;
exports.Doughnut = Doughnut;
exports.DraggableList = DraggableList;
exports.DualListBox = DualListBox;
exports.ErrorUtils = ErrorUtils;
exports.Feedback = Feedback;
exports.FileButton = FileButton;
exports.FloatingBox = FloatingBox;
exports.Header = Header;
exports.HorizontalBar = HorizontalBar;
exports.Icon = Icon;
exports.IconButton = IconButton;
exports.Image = Image;
exports.Input = Input;
exports.Legend = Legend;
exports.Line = Line;
exports.Link = Link;
exports.Loader = Loader;
exports.MergeUtils = MergeUtils;
exports.Minimizer = Minimizer;
exports.Modal = Modal;
exports.ModalComponent = Modal;
exports.ModalConfirm = ModalConfirm;
exports.Navbar = Navbar;
exports.NavbarDropdown = NavbarDropdown;
exports.NavbarItem = NavbarItem;
exports.NavbarSeparator = NavbarSeparator;
exports.NumberUtils = NumberUtils;
exports.OWCContext = OWCContext;
exports.OWCContextProvider = OWCContextProvider;
exports.Picker = Picker;
exports.PieChart = PieChart;
exports.ProgressBar = ProgressBar;
exports.QRCode = QRCode;
exports.Radio = Radio;
exports.RadioGroup = RadioGroup;
exports.RadioGroupNumeric = RadioGroupNumeric;
exports.Range = Range;
exports.RestService = RestService;
exports.Row = Row;
exports.Selector = Selector;
exports.Separator = Separator;
exports.Stacks = Stacks;
exports.StatsLine = StatsLine;
exports.Stepper = Stepper;
exports.Switch = Switch;
exports.Table = Table;
exports.Tabs = Tabs;
exports.Text = Text;
exports.TextArea = TextArea;
exports.TextContext = TextContext;
exports.TextUtils = TextUtils;
exports.Title = Title;
exports.Tooltip = Tooltip;
exports.ValidationUtils = ValidationUtils;
exports.i18n = i18n;
exports.t = t;
exports.translation = translation;
exports.useAlert = useAlert;
exports.useComponentDidMount = useComponentDidMount;
exports.useLoad = useLoad;
exports.useResponsiveStyles = useResponsiveStyles;
exports.useScreenSize = useScreenSize;
